import { FaqItem, IFaqCategory } from "@/interfaces";
import { nanoid } from "nanoid";
import {
  LiBanknote,
  LiBus,
  LiDiplomaVerified,
  LiHome,
  LiLetterOpened,
  LiShieldUser,
  LiUsersGroupTwoRounded,
} from "solar-icon-react/li";

export const legacyFaqCategorySelectorData: IFaqCategory[] = [
  {
    id: nanoid(),
    label: "سوالات عمومی",
    icon: <LiHome className="size-full!" />,
    faqContent: [
      {
        id: nanoid(),
        title: "سامانه استعلام نوین چیست؟",
        content: "سامانه‌ای برای استعلام آنلاین اطلاعات رسمی.",
      },
      {
        id: nanoid(),
        title: "سامانه استعلام نوین چیست؟",
        content: "سامانه‌ای برای استعلام آنلاین اطلاعات رسمی.",
      },
      {
        id: nanoid(),
        title: "سامانه استعلام نوین چیست؟",
        content: "سامانه‌ای برای استعلام آنلاین اطلاعات رسمی.",
      },
      {
        id: nanoid(),
        title: "سامانه استعلام نوین چیست؟",
        content: "سامانه‌ای برای استعلام آنلاین اطلاعات رسمی.",
      },
      {
        id: nanoid(),
        title: "سامانه استعلام نوین چیست؟",
        content: "سامانه‌ای برای استعلام آنلاین اطلاعات رسمی.",
      },
      {
        id: nanoid(),
        title: "سامانه استعلام نوین چیست؟",
        content: "سامانه‌ای برای استعلام آنلاین اطلاعات رسمی.",
      },
      {
        id: nanoid(),
        title: "سامانه استعلام نوین چیست؟",
        content: "سامانه‌ای برای استعلام آنلاین اطلاعات رسمی.",
      },
      {
        id: nanoid(),
        title: "سامانه استعلام نوین چیست؟",
        content: "سامانه‌ای برای استعلام آنلاین اطلاعات رسمی.",
      },
      {
        id: nanoid(),
        title: "سامانه استعلام نوین چیست؟",
        content: "سامانه‌ای برای استعلام آنلاین اطلاعات رسمی.",
      },
      {
        id: nanoid(),
        title: "سامانه استعلام نوین چیست؟",
        content: "سامانه‌ای برای استعلام آنلاین اطلاعات رسمی.",
      },
    ],
    description: "پاسخ به سوالات عمومی کاربران.",
  },
  {
    id: nanoid(),
    label: "پشتیبانی",
    icon: <LiUsersGroupTwoRounded className="size-full!" />,
    faqContent: [
      {
        id: nanoid(),
        title: "چگونه با پشتیبانی تماس بگیرم؟",
        content: "از طریق شماره تماس یا ایمیل پشتیبانی.",
      },
      {
        id: nanoid(),
        title: "چگونه با پشتیبانی تماس بگیرم؟",
        content: "از طریق شماره تماس یا ایمیل پشتیبانی.",
      },
      {
        id: nanoid(),
        title: "چگونه با پشتیبانی تماس بگیرم؟",
        content: "از طریق شماره تماس یا ایمیل پشتیبانی.",
      },
      {
        id: nanoid(),
        title: "چگونه با پشتیبانی تماس بگیرم؟",
        content: "از طریق شماره تماس یا ایمیل پشتیبانی.",
      },
      {
        id: nanoid(),
        title: "چگونه با پشتیبانی تماس بگیرم؟",
        content: "از طریق شماره تماس یا ایمیل پشتیبانی.",
      },
      {
        id: nanoid(),
        title: "چگونه با پشتیبانی تماس بگیرم؟",
        content: "از طریق شماره تماس یا ایمیل پشتیبانی.",
      },
      {
        id: nanoid(),
        title: "چگونه با پشتیبانی تماس بگیرم؟",
        content: "از طریق شماره تماس یا ایمیل پشتیبانی.",
      },
      {
        id: nanoid(),
        title: "چگونه با پشتیبانی تماس بگیرم؟",
        content: "از طریق شماره تماس یا ایمیل پشتیبانی.",
      },
      {
        id: nanoid(),
        title: "چگونه با پشتیبانی تماس بگیرم؟",
        content: "از طریق شماره تماس یا ایمیل پشتیبانی.",
      },
      {
        id: nanoid(),
        title: "چگونه با پشتیبانی تماس بگیرم؟",
        content: "از طریق شماره تماس یا ایمیل پشتیبانی.",
      },
    ],
    description: "راهنمایی و پشتیبانی کاربران.",
  },
  {
    id: nanoid(),
    label: "امنیت",
    icon: <LiShieldUser className="size-full!" />,
    faqContent: [
      {
        id: nanoid(),
        title: "چگونه امنیت اطلاعات تضمین می‌شود؟",
        content: "اطلاعات با پروتکل‌های امنیتی رمزنگاری می‌شوند.",
      },
      {
        id: nanoid(),
        title: "چگونه امنیت اطلاعات تضمین می‌شود؟",
        content: "اطلاعات با پروتکل‌های امنیتی رمزنگاری می‌شوند.",
      },
      {
        id: nanoid(),
        title: "چگونه امنیت اطلاعات تضمین می‌شود؟",
        content: "اطلاعات با پروتکل‌های امنیتی رمزنگاری می‌شوند.",
      },
      {
        id: nanoid(),
        title: "چگونه امنیت اطلاعات تضمین می‌شود؟",
        content: "اطلاعات با پروتکل‌های امنیتی رمزنگاری می‌شوند.",
      },
      {
        id: nanoid(),
        title: "چگونه امنیت اطلاعات تضمین می‌شود؟",
        content: "اطلاعات با پروتکل‌های امنیتی رمزنگاری می‌شوند.",
      },
      {
        id: nanoid(),
        title: "چگونه امنیت اطلاعات تضمین می‌شود؟",
        content: "اطلاعات با پروتکل‌های امنیتی رمزنگاری می‌شوند.",
      },
      {
        id: nanoid(),
        title: "چگونه امنیت اطلاعات تضمین می‌شود؟",
        content: "اطلاعات با پروتکل‌های امنیتی رمزنگاری می‌شوند.",
      },
      {
        id: nanoid(),
        title: "چگونه امنیت اطلاعات تضمین می‌شود؟",
        content: "اطلاعات با پروتکل‌های امنیتی رمزنگاری می‌شوند.",
      },
      {
        id: nanoid(),
        title: "چگونه امنیت اطلاعات تضمین می‌شود؟",
        content: "اطلاعات با پروتکل‌های امنیتی رمزنگاری می‌شوند.",
      },
      {
        id: nanoid(),
        title: "چگونه امنیت اطلاعات تضمین می‌شود؟",
        content: "اطلاعات با پروتکل‌های امنیتی رمزنگاری می‌شوند.",
      },
    ],
    description: "اطمینان از امنیت اطلاعات کاربران.",
  },
  {
    id: nanoid(),
    label: "خدمات بانکی",
    icon: <LiBanknote className="size-full!" />,
    faqContent: [
      {
        id: nanoid(),
        title: "چه خدمات بانکی ارائه می‌شود؟",
        content: "استعلام چک برگشتی، شماره شبا و غیره.",
      },
      {
        id: nanoid(),
        title: "چه خدمات بانکی ارائه می‌شود؟",
        content: "استعلام چک برگشتی، شماره شبا و غیره.",
      },
      {
        id: nanoid(),
        title: "چه خدمات بانکی ارائه می‌شود؟",
        content: "استعلام چک برگشتی، شماره شبا و غیره.",
      },
      {
        id: nanoid(),
        title: "چه خدمات بانکی ارائه می‌شود؟",
        content: "استعلام چک برگشتی، شماره شبا و غیره.",
      },
      {
        id: nanoid(),
        title: "چه خدمات بانکی ارائه می‌شود؟",
        content: "استعلام چک برگشتی، شماره شبا و غیره.",
      },
      {
        id: nanoid(),
        title: "چه خدمات بانکی ارائه می‌شود؟",
        content: "استعلام چک برگشتی، شماره شبا و غیره.",
      },
      {
        id: nanoid(),
        title: "چه خدمات بانکی ارائه می‌شود؟",
        content: "استعلام چک برگشتی، شماره شبا و غیره.",
      },
      {
        id: nanoid(),
        title: "چه خدمات بانکی ارائه می‌شود؟",
        content: "استعلام چک برگشتی، شماره شبا و غیره.",
      },
      {
        id: nanoid(),
        title: "چه خدمات بانکی ارائه می‌شود؟",
        content: "استعلام چک برگشتی، شماره شبا و غیره.",
      },
      {
        id: nanoid(),
        title: "چه خدمات بانکی ارائه می‌شود؟",
        content: "استعلام چک برگشتی، شماره شبا و غیره.",
      },
    ],
    description: "ارائه خدمات بانکی متنوع.",
  },
  {
    id: nanoid(),
    label: "خدمات حقوقی",
    icon: <LiDiplomaVerified className="size-full!" />,
    faqContent: [
      {
        id: nanoid(),
        title: "چه خدمات حقوقی ارائه می‌شود؟",
        content: "استعلام اطلاعات شرکت‌ها و روزنامه رسمی.",
      },
      {
        id: nanoid(),
        title: "چه خدمات حقوقی ارائه می‌شود؟",
        content: "استعلام اطلاعات شرکت‌ها و روزنامه رسمی.",
      },
      {
        id: nanoid(),
        title: "چه خدمات حقوقی ارائه می‌شود؟",
        content: "استعلام اطلاعات شرکت‌ها و روزنامه رسمی.",
      },
      {
        id: nanoid(),
        title: "چه خدمات حقوقی ارائه می‌شود؟",
        content: "استعلام اطلاعات شرکت‌ها و روزنامه رسمی.",
      },
      {
        id: nanoid(),
        title: "چه خدمات حقوقی ارائه می‌شود؟",
        content: "استعلام اطلاعات شرکت‌ها و روزنامه رسمی.",
      },
      {
        id: nanoid(),
        title: "چه خدمات حقوقی ارائه می‌شود؟",
        content: "استعلام اطلاعات شرکت‌ها و روزنامه رسمی.",
      },
      {
        id: nanoid(),
        title: "چه خدمات حقوقی ارائه می‌شود؟",
        content: "استعلام اطلاعات شرکت‌ها و روزنامه رسمی.",
      },
      {
        id: nanoid(),
        title: "چه خدمات حقوقی ارائه می‌شود؟",
        content: "استعلام اطلاعات شرکت‌ها و روزنامه رسمی.",
      },
      {
        id: nanoid(),
        title: "چه خدمات حقوقی ارائه می‌شود؟",
        content: "استعلام اطلاعات شرکت‌ها و روزنامه رسمی.",
      },
      {
        id: nanoid(),
        title: "چه خدمات حقوقی ارائه می‌شود؟",
        content: "استعلام اطلاعات شرکت‌ها و روزنامه رسمی.",
      },
    ],
    description: "خدمات حقوقی برای شرکت‌ها و افراد.",
  },
  {
    id: nanoid(),
    label: "خدمات دولتی",
    icon: <LiLetterOpened className="size-full!" />,
    faqContent: [
      {
        id: nanoid(),
        title: "چه خدمات دولتی ارائه می‌شود؟",
        content: "استعلام وضعیت نظام وظیفه و کد پستی.",
      },
      {
        id: nanoid(),
        title: "چه خدمات دولتی ارائه می‌شود؟",
        content: "استعلام وضعیت نظام وظیفه و کد پستی.",
      },
      {
        id: nanoid(),
        title: "چه خدمات دولتی ارائه می‌شود؟",
        content: "استعلام وضعیت نظام وظیفه و کد پستی.",
      },
      {
        id: nanoid(),
        title: "چه خدمات دولتی ارائه می‌شود؟",
        content: "استعلام وضعیت نظام وظیفه و کد پستی.",
      },
      {
        id: nanoid(),
        title: "چه خدمات دولتی ارائه می‌شود؟",
        content: "استعلام وضعیت نظام وظیفه و کد پستی.",
      },
      {
        id: nanoid(),
        title: "چه خدمات دولتی ارائه می‌شود؟",
        content: "استعلام وضعیت نظام وظیفه و کد پستی.",
      },
      {
        id: nanoid(),
        title: "چه خدمات دولتی ارائه می‌شود؟",
        content: "استعلام وضعیت نظام وظیفه و کد پستی.",
      },
      {
        id: nanoid(),
        title: "چه خدمات دولتی ارائه می‌شود؟",
        content: "استعلام وضعیت نظام وظیفه و کد پستی.",
      },
      {
        id: nanoid(),
        title: "چه خدمات دولتی ارائه می‌شود؟",
        content: "استعلام وضعیت نظام وظیفه و کد پستی.",
      },
      {
        id: nanoid(),
        title: "چه خدمات دولتی ارائه می‌شود؟",
        content: "استعلام وضعیت نظام وظیفه و کد پستی.",
      },
    ],
    description: "دریافت خدمات دولتی به صورت آنلاین.",
  },
  {
    id: nanoid(),
    label: "خدمات خودرو",
    icon: <LiBus className="size-full!" />,
    faqContent: [
      {
        id: nanoid(),
        title: "چه خدمات خودرویی ارائه می‌شود؟",
        content: "استعلام خلافی خودرو و بیمه شخص ثالث.",
      },
      {
        id: nanoid(),
        title: "چه خدمات خودرویی ارائه می‌شود؟",
        content: "استعلام خلافی خودرو و بیمه شخص ثالث.",
      },
      {
        id: nanoid(),
        title: "چه خدمات خودرویی ارائه می‌شود؟",
        content: "استعلام خلافی خودرو و بیمه شخص ثالث.",
      },
      {
        id: nanoid(),
        title: "چه خدمات خودرویی ارائه می‌شود؟",
        content: "استعلام خلافی خودرو و بیمه شخص ثالث.",
      },
      {
        id: nanoid(),
        title: "چه خدمات خودرویی ارائه می‌شود؟",
        content: "استعلام خلافی خودرو و بیمه شخص ثالث.",
      },
      {
        id: nanoid(),
        title: "چه خدمات خودرویی ارائه می‌شود؟",
        content: "استعلام خلافی خودرو و بیمه شخص ثالث.",
      },
      {
        id: nanoid(),
        title: "چه خدمات خودرویی ارائه می‌شود؟",
        content: "استعلام خلافی خودرو و بیمه شخص ثالث.",
      },
      {
        id: nanoid(),
        title: "چه خدمات خودرویی ارائه می‌شود؟",
        content: "استعلام خلافی خودرو و بیمه شخص ثالث.",
      },
      {
        id: nanoid(),
        title: "چه خدمات خودرویی ارائه می‌شود؟",
        content: "استعلام خلافی خودرو و بیمه شخص ثالث.",
      },
      {
        id: nanoid(),
        title: "چه خدمات خودرویی ارائه می‌شود؟",
        content: "استعلام خلافی خودرو و بیمه شخص ثالث.",
      },
    ],
    description: "خدمات مرتبط با خودرو و حمل‌ونقل.",
  },
];

export const faqCategorySelectorData: IFaqCategory[] = [
  {
    id: nanoid(),
    label: "سوالات عمومی",
    icon: <LiHome className="size-full!" />,
    description:
      "پاسخ به پرسش‌های عمومی درباره نحوه استفاده از سامانه، پرداخت و مشاهده نتیجه استعلام‌ها.",
    faqContent: [
      {
        id: nanoid(),
        title: "سامانه استعلام نوین وان چیست؟",
        content:
          "نوین وان یک سامانه آنلاین برای انجام استعلام‌های بانکی، خودرویی، هویتی، حقوقی، قبوض و ابزارهای محاسباتی است. کاربر می‌تواند بدون مراجعه حضوری درخواست استعلام را ثبت کند و نتیجه را در پنل خود ببیند.",
      },
      {
        id: nanoid(),
        title: "برای استفاده از سرویس‌ها باید ثبت‌نام کنم؟",
        content:
          "برای مشاهده قیمت‌ها، پرداخت و دریافت نتیجه بیشتر سرویس‌ها ورود به حساب کاربری لازم است. برخی ابزارهای رایگان مثل ماشین حساب‌ها بدون پرداخت و بدون API قابل استفاده هستند.",
      },
      {
        id: nanoid(),
        title: "نتیجه استعلام‌ها کجا نمایش داده می‌شود؟",
        content:
          "پس از ثبت موفق استعلام، نتیجه در همان صفحه نتیجه و همچنین در بخش تاریخچه استعلام‌های حساب کاربری قابل مشاهده است. در برخی سرویس‌ها امکان دریافت خروجی PDF هم وجود دارد.",
      },
      {
        id: nanoid(),
        title: "اگر استعلام ناموفق شود هزینه کسر می‌شود؟",
        content:
          "روال سرویس‌ها به این صورت طراحی شده که هزینه نهایی برای نتیجه موفق محاسبه شود. اگر خطا از سمت ورودی، احراز شرایط یا provider رخ دهد، پیام خطا نمایش داده می‌شود و باید وضعیت پرداخت یا کیف پول طبق پیام سیستم بررسی شود.",
      },
      {
        id: nanoid(),
        title: "اطلاعات وارد شده در سرویس‌ها باید دقیق باشد؟",
        content:
          "بله. بیشتر سرویس‌ها به داده‌هایی مثل کد ملی، تاریخ تولد، شماره پلاک، شناسه قبض یا شماره شبا وابسته هستند. ورود اطلاعات اشتباه باعث خطای استعلام یا نمایش نتیجه نامعتبر می‌شود.",
      },
    ],
  },
  {
    id: nanoid(),
    label: "پشتیبانی و حساب کاربری",
    icon: <LiUsersGroupTwoRounded className="size-full!" />,
    description:
      "راهنمایی درباره حساب کاربری، تاریخچه استعلام‌ها، کیف پول و مسیرهای پشتیبانی.",
    faqContent: [
      {
        id: nanoid(),
        title: "اگر نتیجه استعلام را پیدا نکنم چه کار کنم؟",
        content:
          "از منوی حساب کاربری وارد بخش تاریخچه استعلام‌ها شوید. اگر پرداخت انجام شده اما نتیجه نمایش داده نمی‌شود، کد پیگیری یا شناسه خرید را از همان بخش بررسی و برای پشتیبانی ارسال کنید.",
      },
      {
        id: nanoid(),
        title: "چطور اعتبار کیف پولم را افزایش بدهم؟",
        content:
          "در پنل کاربری از بخش کیف پول می‌توانید موجودی را شارژ کنید. هنگام ثبت استعلام هم اگر اعتبار کافی نباشد، سیستم مسیر افزایش اعتبار یا پرداخت را نمایش می‌دهد.",
      },
      {
        id: nanoid(),
        title: "آیا امکان ذخیره قبض‌ها وجود دارد؟",
        content:
          "بله. در سرویس‌های قبوض، بعد از مشاهده نتیجه می‌توانید شناسه قبض را در بخش قبض‌های من ذخیره کنید تا دفعات بعد سریع‌تر استعلام یا پرداخت انجام دهید.",
      },
      {
        id: nanoid(),
        title: "اگر حساب سازمانی در حال بررسی باشد چه محدودیتی دارم؟",
        content:
          "تا زمان تایید نهایی مدارک سازمانی، دسترسی به برخی امکانات پنل، سرویس‌های API و تنظیمات همکاری محدود می‌ماند. پس از تایید، امکانات فعال می‌شود.",
      },
      {
        id: nanoid(),
        title: "از چه راهی با پشتیبانی در ارتباط باشم؟",
        content:
          "از بخش راهنمایی بیشتر، کانال‌های ارتباطی و شبکه‌های اجتماعی فعال نمایش داده می‌شود. همچنین در صورت فعال بودن چت آنلاین، می‌توانید از همان ابزار برای راهنمایی سریع استفاده کنید.",
      },
    ],
  },
  {
    id: nanoid(),
    label: "امنیت و حریم خصوصی",
    icon: <LiShieldUser className="size-full!" />,
    description:
      "پرسش‌های مربوط به نگهداری اطلاعات، حریم خصوصی، دسترسی به نتایج و اعتبار منابع استعلام.",
    faqContent: [
      {
        id: nanoid(),
        title: "اطلاعات من در سامانه ذخیره می‌شود؟",
        content:
          "اطلاعات لازم برای ثبت و پیگیری استعلام، پرداخت، گزارش و تاریخچه در حساب کاربری نگهداری می‌شود. اطلاعات حساس مثل کلیدهای API داخلی یا تنظیمات محرمانه به کاربر نهایی نمایش داده نمی‌شود.",
      },
      {
        id: nanoid(),
        title: "آیا نتیجه استعلام‌ها برای دیگران قابل مشاهده است؟",
        content:
          "نتایج استعلام در پنل همان کاربر نمایش داده می‌شود. دسترسی به اطلاعات حساب و تاریخچه نیازمند ورود به حساب کاربری است.",
      },
      {
        id: nanoid(),
        title: "چرا بعضی سرویس‌ها به کد ملی و تاریخ تولد نیاز دارند؟",
        content:
          "در سرویس‌های هویتی، اعتبارسنجی یا سرویس‌هایی که مالکیت اطلاعات مهم است، provider برای تطبیق و جلوگیری از خطا به اطلاعات دقیق‌تری مثل کد ملی، تاریخ تولد یا شماره همراه نیاز دارد.",
      },
      {
        id: nanoid(),
        title: "آیا امکان حذف یا اصلاح اطلاعات اشتباه وجود دارد؟",
        content:
          "اگر اطلاعات واردشده در درخواست اشتباه باشد، معمولاً باید استعلام جدید با اطلاعات صحیح ثبت شود. برای موارد مربوط به حساب کاربری یا سوابق پرداخت، از پشتیبانی کمک بگیرید.",
      },
      {
        id: nanoid(),
        title: "آیا سرویس‌ها به منابع رسمی متصل هستند؟",
        content:
          "سرویس‌ها از طریق providerهای متصل به سامانه و منابع معتبر استعلام می‌شوند. کیفیت و جزئیات خروجی به نوع سرویس، provider فعال و وضعیت پاسخ‌دهی منبع بستگی دارد.",
      },
    ],
  },
  {
    id: nanoid(),
    label: "خدمات بانکی",
    icon: <LiBanknote className="size-full!" />,
    description:
      "راهنمای خدمات بانکی شامل شبا، کارت، چک، تسهیلات و اعتبارسنجی.",
    faqContent: [
      {
        id: nanoid(),
        title: "چه سرویس‌های بانکی در نوین وان وجود دارد؟",
        content:
          "سرویس‌هایی مثل استعلام شبا، تبدیل کارت به شبا، تبدیل کارت به حساب، تبدیل حساب به شبا، استعلام کارت بانکی، استعلام چک صیادی، استعلام چک برگشتی، اعتبارسنجی بانکی و استعلام تسهیلات فعال بانکی در دسته بانکی قرار می‌گیرند.",
      },
      {
        id: nanoid(),
        title: "برای اعتبارسنجی بانکی چه اطلاعاتی لازم است؟",
        content:
          "در نسخه جدید اعتبارسنجی، معمولاً کد ملی و شماره همراه دریافت می‌شود، کد تایید ارسال می‌گردد و پس از تایید و تطبیق لازم، استعلام اعتبارسنجی انجام می‌شود.",
      },
      {
        id: nanoid(),
        title: "استعلام شبا یا کارت چه کاربردی دارد؟",
        content:
          "این سرویس‌ها برای بررسی اطلاعات بانکی، دریافت شماره شبا، تبدیل شماره کارت یا حساب و کاهش خطای واریز استفاده می‌شوند.",
      },
      {
        id: nanoid(),
        title: "نتیجه چک برگشتی چه اطلاعاتی نشان می‌دهد؟",
        content:
          "بسته به نوع سرویس، نتیجه می‌تواند وضعیت وجود چک برگشتی، جزئیات چک‌ها، مبلغ، بانک، شعبه، تاریخ و علت برگشت را نمایش دهد.",
      },
      {
        id: nanoid(),
        title: "آیا خدمات بانکی برای API سازمانی هم قابل استفاده است؟",
        content:
          "بله. بسیاری از سرویس‌های بانکی برای کاربران سازمانی از طریق API هم ارائه می‌شوند و خروجی آن‌ها با فرمت استاندارد API در پنل هاب قابل استفاده است.",
      },
    ],
  },
  {
    id: nanoid(),
    label: "خدمات حقوقی و شرکتی",
    icon: <LiDiplomaVerified className="size-full!" />,
    description:
      "سوالات مربوط به استعلام شرکت‌ها، روزنامه رسمی، پرونده مالیاتی و سرویس‌های حقوقی کسب‌وکارها.",
    faqContent: [
      {
        id: nanoid(),
        title: "در بخش حقوقی چه استعلام‌هایی ارائه می‌شود؟",
        content:
          "استعلام اطلاعات شرکت، صاحبان اعضا، اعضای شرکت، روزنامه رسمی، مجوزها، شرکت‌های مادر و فرزند، شناسه صنفی، هویت حقوقی و پرونده‌های مالیاتی از سرویس‌های حقوقی و شرکتی هستند.",
      },
      {
        id: nanoid(),
        title: "برای استعلام شرکت چه شناسه‌ای نیاز است؟",
        content:
          "بسته به سرویس، معمولاً شناسه ملی، شماره ثبت یا شناسه اقتصادی/کد مرتبط دریافت می‌شود. عنوان دقیق فیلد در فرم همان سرویس نمایش داده می‌شود.",
      },
      {
        id: nanoid(),
        title: "استعلام پرونده‌های مالیاتی چه چیزی نشان می‌دهد؟",
        content:
          "این سرویس با ورودی شماره ملی حقیقی، شناسه ملی حقوقی یا شماره اقتصادی، پرونده‌های قابل نمایش و اطلاعاتی مانند نام، کد اقتصادی، وضعیت ثبت‌نام و مرحله ثبت‌نام را نمایش می‌دهد.",
      },
      {
        id: nanoid(),
        title: "آیا نتیجه استعلام حقوقی قابل استناد قانونی است؟",
        content:
          "نتایج برای بررسی و تصمیم‌گیری کاربردی هستند، اما در موارد حقوقی حساس بهتر است نتیجه با مدارک رسمی و آخرین وضعیت مراجع ذی‌صلاح تطبیق داده شود.",
      },
      {
        id: nanoid(),
        title: "این سرویس‌ها برای کسب‌وکارها هم مناسب‌اند؟",
        content:
          "بله. کسب‌وکارها می‌توانند برای احراز اطلاعات شرکت‌ها، بررسی طرف قرارداد، اعتبارسنجی مشتری حقوقی و اتصال API سازمانی از این سرویس‌ها استفاده کنند.",
      },
    ],
  },
  {
    id: nanoid(),
    label: "خدمات هویتی و دولتی",
    icon: <LiLetterOpened className="size-full!" />,
    description:
      "راهنمای سرویس‌های هویتی، دولتی، پستی، گذرنامه، ثنا و نظام وظیفه.",
    faqContent: [
      {
        id: nanoid(),
        title: "چه سرویس‌هایی در دسته هویتی و دولتی قرار دارد؟",
        content:
          "استعلام ثبت احوال، اتباع خارجی، ثنا، وضعیت گذرنامه، گذرنامه زیارتی، نظام وظیفه، کارت پایان خدمت، معافیت تحصیلی، کد پستی و رهگیری مرسوله از سرویس‌های این دسته هستند.",
      },
      {
        id: nanoid(),
        title: "استعلام ثبت احوال چه ورودی‌هایی نیاز دارد؟",
        content:
          "برای استعلام اطلاعات هویتی معمولاً کد ملی و تاریخ تولد لازم است. اگر این دو با هم تطبیق نداشته باشند، سیستم پیام خطا یا عدم تطابق نمایش می‌دهد.",
      },
      {
        id: nanoid(),
        title: "برای استعلام اتباع خارجی چه اطلاعاتی باید وارد شود؟",
        content:
          "در سرویس اتباع خارجی، شناسه فراگیر یا شماره اختصاصی اتباع به همراه تاریخ تولد وارد می‌شود و اطلاعات هویتی قابل نمایش مانند نام، نام خانوادگی، ملیت و نوع مدرک برگردانده می‌شود.",
      },
      {
        id: nanoid(),
        title: "چرا در بعضی سرویس‌های هویتی شماره همراه لازم است؟",
        content:
          "برای سرویس‌هایی مانند ثنا یا اعتبارسنجی‌هایی که نیاز به تطبیق مالکیت شماره همراه دارند، شماره موبایل برای بررسی تطبیق یا ارسال کد تایید استفاده می‌شود.",
      },
      {
        id: nanoid(),
        title: "استعلام کد پستی و رهگیری مرسوله چه کاربردی دارد؟",
        content:
          "استعلام کد پستی برای بررسی اطلاعات نشانی و سرویس رهگیری مرسوله برای پیگیری وضعیت مرسوله پستی استفاده می‌شود.",
      },
    ],
  },
  {
    id: nanoid(),
    label: "خدمات خودرو و قبوض",
    icon: <LiBus className="size-full!" />,
    description:
      "پاسخ به سوالات مربوط به سرویس‌های خودرو، خلافی، پلاک، عوارض و قبوض.",
    faqContent: [
      {
        id: nanoid(),
        title: "چه سرویس‌های خودرویی در نوین وان ارائه می‌شود؟",
        content:
          "استعلام خلافی خودرو، خلافی با تصویر، خلافی موتورسیکلت، ریز نمره منفی، استعلام پلاک، عوارض آزادراهی، مالیات نقل و انتقال، مشخصات و مدل خودرو و سوابق بیمه‌نامه شخص ثالث از سرویس‌های خودرویی هستند.",
      },
      {
        id: nanoid(),
        title: "برای استعلام‌های پلاک چه اطلاعاتی لازم است؟",
        content:
          "در سرویس‌های پلاک‌محور، بخش‌های پلاک به‌صورت جداگانه دریافت می‌شود و در بک‌اند متناسب با provider به فرمت موردنیاز تبدیل می‌شود.",
      },
      {
        id: nanoid(),
        title: "آیا پرداخت قبض‌ها و ذخیره قبض امکان‌پذیر است؟",
        content:
          "بله. در بخش قبوض می‌توانید قبض‌های آب، برق، گاز، تلفن و موبایل را استعلام کنید. همچنین امکان افزودن شناسه قبض به قبض‌های من برای استفاده سریع‌تر وجود دارد.",
      },
      {
        id: nanoid(),
        title: "استعلام گروهی قبوض چگونه انجام می‌شود؟",
        content:
          "در پرداخت سریع قبوض، کاربر می‌تواند چند قبض را انتخاب کند، هزینه استعلام‌ها را تایید کند و پس از پرداخت یا کسر از کیف پول، وضعیت قبض‌ها به‌روزرسانی شود.",
      },
      {
        id: nanoid(),
        title: "آیا برای پرداخت قبوض کارمزد درگاه محاسبه می‌شود؟",
        content:
          "در سرویس‌هایی که پرداخت از درگاه انجام می‌شود، ممکن است کارمزد درگاه طبق تنظیمات سرویس یا تنظیمات عمومی سامانه محاسبه و از حساب کاربر کسر شود.",
      },
    ],
  },
];

export const chekBargashtiFaqItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "چگونه می‌توانم بفهمم یک چک صیادی اصالت دارد یا جعلی است؟",
    content:
      "برای تشخیص اصالت چک صیادی، می‌توانید از طریق سامانه نوین با وارد کردن شناسه 16 رقمی صیادی چک، استعلام اصالت انجام دهید. چک‌های صیادی اصل دارای ویژگی‌های امنیتی خاصی مانند رنگ بنفش، واترمارک و شناسه منحصر به فرد هستند که در سامانه استعلام قابل بررسی است.",
  },
  {
    id: nanoid(),
    title: "رنگ‌های مختلف در نتیجه استعلام چک برگشتی به چه معناست؟",
    content:
      "در نتیجه استعلام چک برگشتی، رنگ‌های مختلفی نمایش داده می‌شود که هر کدام معنای خاصی دارد:\n" +
      "\n" +
      "رنگ سبز: نشان‌دهنده عدم وجود سابقه چک برگشتی است\n" +
      "رنگ زرد: هشدار برای وجود چک‌های رفع سوءاثر شده است\n" +
      "رنگ قرمز: نشان‌دهنده وجود چک برگشتی فعال و رفع سوءاثر نشده است\n" +
      "رنگ خاکستری: اطلاعات ناکافی یا عدم امکان استعلام در لحظه",
  },
  {
    id: nanoid(),
    title: "تفاوت چک صیادی و چک عادی در استعلام چک برگشتی چیست؟",
    content:
      "چک صیادی برخلاف چک عادی، دارای شناسه 16 رقمی منحصر به فرد است که امکان استعلام دقیق‌تر و جامع‌تر را فراهم می‌کند. در استعلام چک صیادی، علاوه بر وضعیت برگشتی، اطلاعاتی مانند وضعیت ثبت در سامانه صیاد، انتقال‌های قبلی و تاریخچه کامل چک نیز قابل مشاهده است، در حالی که در چک‌های عادی تنها وضعیت برگشتی قابل استعلام است.",
  },
  {
    id: nanoid(),
    title: "آیا می‌توان چک برگشتی را بدون مراجعه به بانک رفع سوءاثر کرد؟",
    content:
      "خیر، رفع سوءاثر چک برگشتی نیازمند طی مراحل قانونی است که شامل پرداخت مبلغ چک به ذینفع، دریافت رضایت‌نامه کتبی از وی و مراجعه به بانک صادرکننده چک می‌باشد. در حال حاضر امکان رفع سوءاثر به صورت آنلاین و بدون مراجعه حضوری به بانک وجود ندارد، اما می‌توانید وضعیت رفع سوءاثر را از طریق سامانه نوین استعلام کنید.",
  },
  {
    id: nanoid(),
    title:
      "چرا گاهی با وجود پرداخت مبلغ چک، همچنان در استعلام به عنوان چک برگشتی نمایش داده می‌شود؟",
    content:
      "این مسئله می‌تواند به دلیل عدم طی مراحل کامل رفع سوءاثر باشد. صرف پرداخت مبلغ چک کافی نیست و باید با مراجعه به بانک و ارائه مدارک لازم، فرآیند رفع سوءاثر را تکمیل کنید. همچنین به‌روزرسانی اطلاعات در سامانه بانک مرکزی ممکن است با تأخیر 24 تا 48 ساعته انجام شود که باعث می‌شود علی‌رغم پرداخت، همچنان چک برگشتی نمایش داده شود.",
  },
  {
    id: nanoid(),
    title: "آیا استعلام چک برگشتی برای چک‌های قدیمی (غیرصیادی) امکان‌پذیر است؟",
    content:
      "بله، استعلام چک برگشتی برای چک‌های قدیمی نیز امکان‌پذیر است، اما اطلاعات ارائه شده محدودتر خواهد بود. برای چک‌های غیرصیادی، تنها می‌توانید وضعیت برگشتی را استعلام کنید و جزئیات بیشتری مانند تاریخچه انتقال یا وضعیت ثبت در سامانه صیاد قابل مشاهده نخواهد بود. برای استعلام این چک‌ها نیز می‌توانید از کد ملی صاحب حساب در سامانه نوین استفاده کنید.",
  },
  {
    id: nanoid(),
    title: "چگونه می‌توانم تعداد دقیق چک‌های برگشتی یک شخص را استعلام کنم؟",
    content:
      "برای استعلام تعداد دقیق چک‌های برگشتی یک شخص، می‌توانید با وارد کردن کد ملی (برای اشخاص حقیقی) یا شناسه ملی (برای اشخاص حقوقی) در سامانه نوین، گزارش کاملی دریافت کنید که شامل تعداد چک‌های برگشتی فعال، تعداد چک‌های رفع سوءاثر شده و مجموع مبالغ آن‌ها می‌باشد. این گزارش به صورت تفکیک شده و با جزئیات کامل ارائه می‌شود.",
  },
  {
    id: nanoid(),
    title: "آیا استعلام چک برگشتی توسط شخص ثالث قانونی است؟",
    content:
      "بله، استعلام چک برگشتی توسط شخص ثالث کاملاً قانونی است و محدودیتی برای آن وجود ندارد. این امکان به منظور افزایش امنیت معاملات و کاهش ریسک کلاهبرداری فراهم شده است. هر شخصی می‌تواند قبل از پذیرش چک، با استفاده از کد ملی صاحب چک، وضعیت چک‌های برگشتی او را استعلام کند. البته نتیجه استعلام محرمانه است و نباید بدون دلیل موجه منتشر شود.",
  },
  {
    id: nanoid(),
    title:
      'اگر در استعلام چک برگشتی با خطای "عدم امکان استعلام در لحظه" مواجه شدم، چه کنم؟',
    content:
      "این خطا معمولاً به دلیل اختلال موقت در ارتباط با سرورهای بانک مرکزی یا حجم بالای درخواست‌ها رخ می‌دهد. در این صورت:\n" +
      "\n" +
      "چند دقیقه صبر کنید و مجدداً تلاش کنید\n" +
      "از مرورگر دیگری استفاده کنید\n" +
      "کوکی‌ها و کش مرورگر خود را پاک کنید\n" +
      "در ساعات کم‌ترافیک (مثلاً صبح زود یا آخر شب) مجدداً تلاش کنید\n" +
      "اگر مشکل ادامه داشت، با پشتیبانی سامانه نوین تماس بگیرید",
  },
  {
    id: nanoid(),
    title: "چگونه می‌توانم بفهمم یک چک در سامانه صیاد ثبت شده است یا خیر؟",
    content:
      'برای اطلاع از ثبت چک در سامانه صیاد، می‌توانید با وارد کردن شناسه صیادی 16 رقمی چک در بخش استعلام چک صیادی سامانه نوین، وضعیت ثبت آن را بررسی کنید. در نتیجه استعلام، وضعیت چک به صورت "ثبت شده"، "ثبت نشده" یا "باطل شده" نمایش داده می‌شود. چک‌هایی که در سامانه صیاد ثبت نشده‌اند، فاقد اعتبار قانونی هستند و نباید پذیرفته شوند.',
  },
  {
    id: nanoid(),
    title:
      "آیا می‌توان از طریق پیامک یا اپلیکیشن موبایل، چک برگشتی را استعلام کرد؟",
    content:
      "بله، علاوه بر وب‌سایت سامانه نوین، می‌توانید از طریق اپلیکیشن موبایل نوین نیز استعلام چک برگشتی را انجام دهید. همچنین سرویس پیامکی استعلام چک برگشتی نیز فعال است که با ارسال کد ملی به شماره مشخص، نتیجه استعلام را دریافت می‌کنید. این روش‌ها برای مواقعی که دسترسی به اینترنت محدود است یا نیاز به استعلام سریع دارید، بسیار کاربردی است.",
  },
  {
    id: nanoid(),
    title:
      'تفاوت "چک برگشتی" و "چک سوخت شده" چیست و چگونه در استعلام مشخص می‌شود؟',
    content:
      'چک برگشتی به چکی گفته می‌شود که به دلیل کسری موجودی یا مشکلات فنی پاس نشده، اما قابلیت رفع سوءاثر دارد. چک سوخت شده چکی است که علی‌رغم پیگیری‌های قانونی، امکان وصول آن وجود ندارد و معمولاً به دلیل ورشکستگی یا فوت صادرکننده، به عنوان مطالبات لاوصول طبقه‌بندی می‌شود. در نتیجه استعلام، چک‌های برگشتی با عنوان "برگشتی فعال" و چک‌های سوخت شده با عنوان "غیرقابل وصول" یا "سوخت شده" مشخص می‌شوند.',
  },
];

export const estelaamShabaFaqItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "سقف انتقال وجه با شماره شبا چقدر است؟",
    content:
      "سقف انتقال وجه با شماره شبا در هر بانک متفاوت است و به طور معمولی بین 100 میلیون تومان در بانک های دولتی و 150 میلیون تومان در بانک های خصوصی است. همچنین نوع انتقال نیز در سقف انتقال وجه شبا تاثیر دارد، نوع انتقال میتواند پایا و یا ساتنا باشد. باتوجه به اینکه پایا محدودیتی 50 میلیون تومانی دارد و ساتنا 200 میلیون تومانی. در مورد سقف دقیق انتقال وجه بانک خود با تلفن بانک خود تماس بگیرید.",
  },
  {
    id: nanoid(),
    title: "شماره شبا چیست؟",
    content:
      "شماره شبا (IBAN) یک شناسه استاندارد بین‌المللی 24 رقمی است که برای شناسایی حساب‌های بانکی در ایران و سراسر جهان استفاده می‌شود. این شماره با کد IR (نشان‌دهنده ایران) شروع می‌شود و شامل اطلاعاتی مانند کد بانک، شماره حساب و ارقام کنترلی است. شماره شبا برای تسهیل انتقال وجه بین بانکی و استاندارد‌سازی مبادلات مالی طراحی شده است.",
  },
  {
    id: nanoid(),
    title: "شماره شبا کجاست؟",
    content:
      "شماره شبا را می‌توانید از روش‌های زیر دریافت کنید:\n" +
      "\n" +
      "مراجعه به اینترنت بانک یا همراه بانک خود و مشاهده در بخش اطلاعات حساب\n" +
      "مراجعه به شعبه بانک و درخواست شماره شبا\n" +
      "چاپ شده روی برخی از کارت‌های بانکی جدید\n" +
      "استفاده از سرویس‌های استعلام آنلاین مانند سامانه نوین برای تبدیل شماره کارت یا شماره حساب به شماره شبا",
  },
  {
    id: nanoid(),
    title: "تفاوت پایا و ساتنا چیست؟",
    content:
      "پایا و ساتنا دو سیستم انتقال وجه بین بانکی در ایران هستند که تفاوت‌های اساسی دارند:\n" +
      "\n" +
      "پایا (ACH): برای انتقال مبالغ کمتر از 500 میلیون ریال استفاده می‌شود، انتقال در چرخه‌های مشخص روزانه انجام می‌شود و معمولاً چند ساعت طول می‌کشد.\n" +
      "ساتنا (RTGS): برای انتقال مبالغ بالای 500 میلیون ریال استفاده می‌شود، انتقال به صورت آنی و در همان روز کاری انجام می‌شود، اما فقط در ساعات کاری بانک‌ها فعال است.",
  },
  {
    id: nanoid(),
    title: "آیا استعلام شماره شبا رایگان است؟",
    content:
      "استعلام شماره شبای خودتان معمولاً از طریق اینترنت بانک یا همراه بانک رایگان است. اما استعلام مشخصات صاحب حساب با شماره شبا در سامانه‌های استعلام مانند سامانه نوین، مستلزم پرداخت هزینه ناچیزی است. این هزینه برای تأیید هویت صاحب حساب و اطمینان از صحت اطلاعات قبل از انجام تراکنش‌های مالی دریافت می‌شود.",
  },
  {
    id: nanoid(),
    title: "چگونه می‌توانم صحت یک شماره شبا را بررسی کنم؟",
    content:
      "برای بررسی صحت یک شماره شبا می‌توانید:\n" +
      "\n" +
      "از سرویس استعلام شماره شبا در سامانه نوین استفاده کنید\n" +
      "الگوریتم محاسباتی شماره شبا را بررسی کنید (دو رقم کنترلی در شماره شبا وجود دارد)\n" +
      "از طریق اینترنت بانک یا تماس با بانک مربوطه استعلام بگیرید\n" +
      "از سامانه‌های رسمی بانک مرکزی استفاده کنید",
  },
  {
    id: nanoid(),
    title: "آیا با داشتن شماره شبا می‌توان از حساب برداشت کرد؟",
    content:
      "خیر، صرف داشتن شماره شبا امکان برداشت از حساب را فراهم نمی‌کند. شماره شبا فقط برای واریز وجه به حساب استفاده می‌شود و برای برداشت از حساب به اطلاعات دیگری مانند رمز اینترنت بانک، رمز دوم کارت یا مراجعه حضوری به شعبه با مدارک شناسایی نیاز است. بنابراین، به اشتراک گذاشتن شماره شبا برای دریافت وجه خطری ندارد.",
  },
  {
    id: nanoid(),
    title: "آیا شماره شبا برای همه حساب‌های بانکی وجود دارد؟",
    content:
      "بله، تمام حساب‌های بانکی فعال در ایران دارای شماره شبا هستند. بانک مرکزی جمهوری اسلامی ایران از سال 1385 استفاده از شماره شبا را برای تمام بانک‌های کشور الزامی کرده است. حتی حساب‌های قدیمی نیز دارای شماره شبا هستند که می‌توانید با مراجعه به بانک یا استفاده از خدمات آنلاین آن را دریافت کنید.",
  },
  {
    id: nanoid(),
    title: "آیا شماره شبا برای انتقال ارز خارجی قابل استفاده است؟",
    content:
      "بله، شماره شبا (IBAN) یک استاندارد بین‌المللی است که برای انتقال وجه بین‌المللی نیز استفاده می‌شود. با این حال، برای انتقال ارز خارجی علاوه بر شماره شبا، به کد سوئیفت (SWIFT) بانک نیز نیاز دارید. همچنین با توجه به محدودیت‌های بانکی ایران، انتقال ارز خارجی ممکن است با محدودیت‌هایی همراه باشد و نیاز به هماهنگی با بانک مربوطه دارد.",
  },
  {
    id: nanoid(),
    title: "چرا گاهی با وجود درست بودن شماره شبا، انتقال وجه انجام نمی‌شود؟",
    content:
      "دلایل متعددی می‌تواند باعث عدم موفقیت در انتقال وجه با شماره شبا شود:\n" +
      "\n" +
      "مسدود بودن حساب مقصد\n" +
      "غیرفعال بودن حساب مقصد\n" +
      "محدودیت‌های امنیتی بانک مبدأ یا مقصد\n" +
      "اختلال در سیستم‌های بانکی\n" +
      "رعایت نکردن زمان‌بندی پایا یا ساتنا\n" +
      "محدودیت‌های مربوط به مبارزه با پولشویی\n" +
      "اشتباه در ثبت اطلاعات گیرنده\n" +
      "در صورت بروز مشکل در انتقال وجه، توصیه می‌شود با بانک مبدأ تماس گرفته و علت را جویا شوید.",
  },
  {
    id: nanoid(),
    title: "شماره شبا چند رقم است؟",
    content:
      "شماره شبا 26 کاراکتر است که 2 کاراکتر اول IR به معنی حساب بانکی داخل ایران است، دو رقم اول به معنی کد کنترلی جهت صحت اطلاعات است، 3 رقم بعدی کد بانک است و و 18 رقم بعدی مربوط به شماره حساب بانک است که از آخر در نظر گرفته میشود و مابقی 18 رقم را صفر میگذارند.",
  },
  {
    id: nanoid(),
    title: "زمان انتقال وجه در شبا چگونه است؟",
    content:
      "انتقال وجه شبا در چرخه زمانی مشخصی صورت میگیرد.\n" +
      "- چرخه اول: ساعت ۴ تا ۶ بامداد\n" +
      "- چرخه دوم: ساعت ۱۰:۳۰ تا ۱۲ ظهر\n" +
      "- چرخه سوم: ساعت ۱۴ تا ۱۶\n" +
      "- چرخه چهارم: ساعت ۱۸ تا ۲۰",
  },
  {
    id: nanoid(),
    title: "تفاوت شماره شبا و حساب چیست؟",
    content:
      "از شماره حساب بانکی تنها میتوانید در انتقال وجه داخل بانکی مثلا ملت به ملت استفاده کنید اما با شماره شبا میتوانید انتقال وجه بین بانکی مثلا ملت به سپه را داشته باشید. شماره شبا شناسه بانکی شما نزد بانک مرکزی است و شماره حساب بانک شما تنها قابلیت شناسایی در بانک خودتان را دارد.",
  },
];

export const estelaamKartFaqItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "استعلام کارت بانکی چیست و چه اطلاعاتی به من می‌دهد؟",
    content:
      "استعلام کارت بانکی سرویسی است که به شما امکان می‌دهد بدون مراجعه حضوری به بانک، اطلاعات مهمی درباره یک کارت بانکی دریافت کنید. این اطلاعات شامل وضعیت کارت (فعال یا غیرفعال)، نام صاحب کارت، بانک صادرکننده و صحت شماره کارت است. این سرویس برای اطمینان از اعتبار کارت بانکی قبل از انجام تراکنش یا واریز وجه بسیار مفید است.",
  },
  {
    id: nanoid(),
    title: "چرا باید قبل از واریز وجه، استعلام کارت بانکی انجام دهم؟",
    content:
      "استعلام کارت بانکی قبل از واریز وجه به چند دلیل مهم است:\n" +
      "اطمینان از تعلق کارت به شخصی که ادعا می‌کند صاحب کارت است\n" +
      "جلوگیری از کلاهبرداری و واریز وجه به کارت‌های جعلی یا سرقتی\n" +
      "تأیید فعال بودن کارت و عدم مسدودی آن\n" +
      "اطمینان از صحت شماره کارت و جلوگیری از اشتباه در واریز وجه این استعلام به خصوص در معاملات آنلاین و پرداخت‌های اینترنتی که طرفین یکدیگر را نمی‌شناسند، اهمیت بیشتری پیدا می‌کند.",
  },
  {
    id: nanoid(),
    title: "آیا با استعلام کارت بانکی می‌توانم موجودی کارت را هم ببینم؟",
    content:
      "خیر، سرویس استعلام کارت بانکی در سامانه نوین به دلایل امنیتی و حفظ حریم خصوصی افراد، اطلاعات مربوط به موجودی کارت را نمایش نمی‌دهد. این سرویس صرفاً برای تأیید اعتبار کارت، فعال بودن آن و شناسایی صاحب کارت طراحی شده است. موجودی کارت جزو اطلاعات محرمانه بانکی محسوب می‌شود و تنها صاحب کارت با مراجعه به درگاه‌های بانکی می‌تواند به آن دسترسی داشته باشد.",
  },
  {
    id: nanoid(),
    title: "آیا استعلام کارت بانکی برای تمام بانک‌های کشور امکان‌پذیر است؟",
    content:
      "بله، سرویس استعلام کارت بانکی سامانه نوین برای تمامی کارت‌های بانکی صادر شده توسط بانک‌های داخل کشور قابل استفاده است. این سرویس با پوشش کامل شبکه بانکی کشور، امکان استعلام کارت‌های بانک‌های مختلف از جمله بانک ملی، ملت، سپه، تجارت، کشاورزی، صادرات، پارسیان، پاسارگاد و سایر بانک‌ها را فراهم می‌کند.",
  },
  {
    id: nanoid(),
    title: "چگونه می‌توانم تشخیص دهم یک کارت بانکی متعلق به چه بانکی است؟",
    content:
      "شش رقم اول هر کارت بانکی (BIN کارت) نشان‌دهنده بانک صادرکننده آن است. با استعلام کارت بانکی در سامانه نوین، علاوه بر نام صاحب کارت، نام بانک صادرکننده نیز به شما نمایش داده می‌شود. این ویژگی به خصوص زمانی مفید است که می‌خواهید از تطابق شماره کارت با بانکی که طرف مقابل ادعا می‌کند، اطمینان حاصل کنید.",
  },
  {
    id: nanoid(),
    title:
      "اگر در نتیجه استعلام، نام صاحب کارت با نام اعلام شده مغایرت داشت، چه باید کرد؟",
    content:
      "مغایرت نام صاحب کارت با نام اعلام شده می‌تواند نشانه‌ای از تلاش برای کلاهبرداری باشد. در این صورت:\n" +
      "\n" +
      "از واریز وجه به آن کارت خودداری کنید\n" +
      "از طرف مقابل توضیح بخواهید (گاهی افراد از کارت اعضای خانواده استفاده می‌کنند)\n" +
      "در صورت عدم قانع شدن، روش پرداخت دیگری مانند پرداخت حضوری یا استفاده از درگاه‌های پرداخت رسمی را پیشنهاد دهید\n" +
      "اگر مشکوک به کلاهبرداری هستید، موضوع را به پلیس فتا گزارش دهید",
  },
  {
    id: nanoid(),
    title: "آیا استعلام کارت بانکی برای کارت‌های منقضی شده هم نتیجه می‌دهد؟",
    content:
      'بله، سیستم استعلام کارت بانکی سامانه نوین قادر است وضعیت انقضای کارت را نیز بررسی کند. در نتیجه استعلام، اگر کارت منقضی شده باشد، با پیام "کارت منقضی شده است" یا "تاریخ انقضای کارت گذشته است" مواجه خواهید شد. این اطلاعات به شما کمک می‌کند از واریز وجه به کارت‌هایی که دیگر قابل استفاده نیستند، خودداری کنید.',
  },
  {
    id: nanoid(),
    title:
      "آیا استعلام کارت بانکی برای کارت‌های اعتباری و هدیه هم کاربرد دارد؟",
    content:
      "بله، سرویس استعلام کارت بانکی برای انواع کارت‌های بانکی شامل کارت‌های نقدی (دبیت)، کارت‌های اعتباری و کارت‌های هدیه قابل استفاده است. البته در مورد کارت‌های هدیه بی‌نام، ممکن است اطلاعات صاحب کارت قابل نمایش نباشد و تنها اعتبار و فعال بودن کارت تأیید شود. برای کارت‌های اعتباری نیز علاوه بر نام صاحب کارت، نوع کارت (اعتباری) نیز مشخص می‌شود.",
  },
  {
    id: nanoid(),
    title: "چه اطلاعاتی برای استعلام کارت بانکی نیاز است؟",
    content:
      "برای استعلام کارت بانکی در سامانه نوین، تنها به شماره 16 رقمی کارت بانکی نیاز دارید. نیازی به وارد کردن تاریخ انقضا، CVV2 یا رمز دوم کارت نیست. این ویژگی باعث می‌شود استعلام کارت بانکی بدون نیاز به اطلاعات محرمانه کارت و با حفظ امنیت، به راحتی انجام شود.",
  },
  {
    id: nanoid(),
    title: "آیا استعلام کارت بانکی به صاحب کارت اطلاع داده می‌شود؟",
    content:
      "خیر، هنگام استعلام کارت بانکی در سامانه نوین، هیچ پیامک یا اعلانی برای صاحب کارت ارسال نمی‌شود و او از انجام استعلام مطلع نمی‌شود. این استعلام صرفاً یک بررسی اطلاعاتی است و هیچ تأثیری بر حساب یا کارت بانکی فرد ندارد. این ویژگی امکان بررسی محرمانه اعتبار کارت قبل از انجام معامله را فراهم می‌کند.",
  },
  {
    id: nanoid(),
    title: "تفاوت استعلام شبا با استعلام کارت بانکی چیست؟",
    content:
      "استعلام شبا و استعلام کارت بانکی دو سرویس متفاوت هستند:\n" +
      "\n" +
      "استعلام کارت بانکی: با استفاده از شماره 16 رقمی کارت انجام می‌شود و اطلاعاتی درباره صاحب کارت، وضعیت فعال بودن و بانک صادرکننده ارائه می‌دهد.\n" +
      "استعلام شبا: با استفاده از شماره شبای 24 رقمی انجام می‌شود و اطلاعاتی درباره صاحب حساب، بانک و شعبه مربوطه ارائه می‌دهد.\n" +
      "هر دو سرویس برای تأیید هویت طرف معامله مفید هستند، اما استعلام کارت برای پرداخت‌های کارت به کارت و استعلام شبا برای پرداخت‌های پایا و ساتنا کاربرد بیشتری دارد.",
  },
  {
    id: nanoid(),
    title: "آیا استعلام کارت بانکی برای کارت‌های مسدود شده هم نتیجه می‌دهد؟",
    content:
      'بله، سیستم استعلام کارت بانکی قادر است وضعیت مسدودی کارت را نیز تشخیص دهد. در نتیجه استعلام، اگر کارت مسدود شده باشد، با پیام "کارت مسدود است" یا "کارت غیرفعال است" مواجه خواهید شد. این اطلاعات به شما کمک می‌کند از واریز وجه به کارت‌هایی که به دلایلی مانند سرقت، مفقودی یا تخلف مسدود شده‌اند، خودداری کنید و از بروز مشکلات بعدی جلوگیری نمایید.',
  },
];

export const kartToShabaFaqItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "تبدیل شماره کارت به شبا چطور انجام می‌شود؟",
    content:
      "کافیه به novin.one برید، سرویس «تبدیل شماره کارت به شبا» رو از بخش خدمات بانکی انتخاب کنید، شماره ۱۶ رقمی کارت بانکی‌تون رو وارد کنید و روی دکمه استعلام کلیک کنید. در چند ثانیه، شماره شبا و اطلاعات اضافی مثل وضعیت حساب رو می‌بینید!",
  },
  {
    id: nanoid(),
    title: "چرا باید شماره کارت رو به شبا تبدیل کنم؟",
    content:
      "گاهی شماره شبا روی کارت نیست یا پاک شده، یا برای انتقال‌های بانکی (مثل پایا و ساتنا)، واریز حقوق، یا ثبت‌نام در سامانه‌های دولتی بهش نیاز دارید. با نوین، تو چند ثانیه شماره شبا رو از شماره کارت بگیرید و کارتون رو راه بندازید!",
  },
  {
    id: nanoid(),
    title: "این سرویس برای کدوم بانک‌ها کار می‌کنه؟",
    content:
      "سامانه نوین از همه بانک‌های ایرانی مثل بانک ملی، صادرات، ملت، پاسارگاد، سپه، تجارت، و کشاورزی پشتیبانی می‌کنه. هر شماره کارتی داشته باشید، تو novin.one می‌تونید شماره شبا رو بگیرید.",
  },
  {
    id: nanoid(),
    title: "استعلام شماره شبا با شماره کارت هزینه داره؟",
    content:
      "تو نوین یه هزینه خیلی کم برای این سرویس پرداخت می‌کنید، چون این هزینه به سرویس‌دهنده اطلاعات بانکی می‌رسه. ولی برخلاف بانک‌های خاص که فقط کارت خودشون رو قبول می‌کنن، نوین برای همه بانک‌ها کار می‌کنه! جزئیات رو تو novin.one ببینید.",
  },
  {
    id: nanoid(),
    title: "چه اطلاعاتی همراه با شماره شبا بهم می‌دن؟",
    content:
      "علاوه بر شماره شبا، سامانه نوین نام صاحب حساب، وضعیت حساب (فعال، مسدود، یا غیرفعال)، و گاهی نوع حساب رو هم نشون می‌ده. این اطلاعات تو novin.one بهتون اطمینان بیشتری می‌ده.",
  },
  {
    id: nanoid(),
    title: "اگه شماره کارت اشتباه وارد کنم چی می‌شه؟",
    content:
      "اگه شماره کارت رو اشتباه وارد کنید، استعلام نتیجه درستی نمی‌ده. حتماً شماره ۱۶ رقمی رو دقیق وارد کنید. اگه مشکلی پیش اومد، پشتیبانی نوین تو novin.one آماده کمک به شماست.",
  },
  {
    id: nanoid(),
    title: "چقدر طول می‌کشه تا شماره شبا رو بگیرم؟",
    content:
      "فقط چند ثانیه! بعد از وارد کردن شماره کارت تو novin.one، شماره شبا و اطلاعات مرتبط فوراً نمایش داده می‌شه. برای معاملات فوری عالیه!",
  },
  {
    id: nanoid(),
    title: "آیا اطلاعات من تو سامانه نوین امن می‌مونه؟",
    content:
      "بله، نوین از استانداردهای امنیتی بالا و رمزنگاری پیشرفته استفاده می‌کنه تا اطلاعات شما کاملاً محفوظ بمونه. با خیال راحت تو novin.one استعلام کنید.",
  },
  {
    id: nanoid(),
    title: "می‌تونم شماره شبا رو برای انتقال بین‌المللی استفاده کنم؟",
    content:
      "بله، شماره شبا یه شناسه بین‌المللی (IBAN) هست که برای حواله‌های ارزی و تراکنش‌های بین‌المللی مناسبه. با نوین، شماره شبا رو تو novin.one بگیرید و بدون دغدغه استفاده کنید.",
  },
  {
    id: nanoid(),
    title: "اگه فقط شماره حساب داشته باشم، می‌تونم شبا بگیرم؟",
    content:
      "بله، نوین سرویس جداگونه «تبدیل شماره حساب به شبا» هم داره. اگه شماره حساب دارید، تو novin.one می‌تونید اون رو وارد کنید و شماره شبا رو به‌همراه اطلاعات تکمیلی بگیرید.",
  },
];

export const hesabToShabaFaqItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "شماره شبا چیست و چرا بهش نیاز دارم؟",
    content:
      "شماره شبا یه کد ۲۴ رقمیه که با IR شروع می‌شه و برای انتقال وجه بین بانکی، واریز حقوق، یا ثبت‌نام در سامانه‌های دولتی مثل یارانه لازمه. با سامانه نوین، می‌تونید در چند ثانیه شماره شبا رو از شماره حساب بگیرید و کاراتون رو سریع انجام بدید!",
  },
  {
    id: nanoid(),
    title: "چطور میتوانم شماره حسابم را به شماره شبا تبدیل کنم؟",
    content:
      "کافیه به novin.one برید، بخش خدمات بانکی رو انتخاب کنید، سرویس «تبدیل شماره حساب به شماره شبا» رو پیدا کنید، بانک و شماره حساب رو وارد کنید و روی استعلام کلیک کنید. در چند ثانیه، شماره شبا رو می‌بینید!",
  },
  {
    id: nanoid(),
    title: "برای تبدیل شماره حساب به شبا نیاز به چه اطلاعاتی دارم؟",
    content:
      "فقط شماره حساب بانکی‌تون که معمولاً تو پیامک‌های بانکی هست و اسم بانک کافی‌یه. تو سامانه نوین، این اطلاعات رو وارد کنید تا شماره شبا رو فوری دریافت کنید.",
  },
  {
    id: nanoid(),
    title: "آیا تبدیل شماره حساب به شبا در نوین هزینه داره؟",
    content:
      "خیر، سرویس نوین یا رایگانه یا با هزینه خیلی کم ارائه می‌شه. برای جزئیات، به سامانه نوین سر بزنید و بدون دغدغه از خدمات استفاده کنید.",
  },
  {
    id: nanoid(),
    title: "استعلام شبا در نوین چقدر طول می‌کشه؟",
    content:
      "فقط چند ثانیه! کافیه شماره حساب رو تو سامانه نوین وارد کنید، شماره شبا و اطلاعات اضافی مثل نام صاحب حساب فوراً نمایش داده می‌شه. سریع و بدون معطلی!",
  },
  {
    id: nanoid(),
    title: "آیا اطلاعات من تو سامانه نوین امن می‌مونه؟",
    content:
      "بله، نوین از رمزنگاری پیشرفته استفاده می‌کنه تا اطلاعات شما کاملاً محفوظ بمونه. با خیال راحت در سامانه نوین استعلام کنید.",
  },
  {
    id: nanoid(),
    title: "اگه شماره حساب اشتباه وارد کنم چی می‌شه؟",
    content:
      "اگه شماره حساب اشتباه باشه، استعلام نتیجه درستی نمی‌ده. حتماً شماره حساب رو دقیق وارد کنید. در صورت مشکل، پشتیبانی نوین در سامانه نوین بهتون کمک می‌کنه.",
  },
  {
    id: nanoid(),
    title: "می‌تونم شماره شبا همه بانک‌ها رو تو نوین بگیرم؟",
    content:
      "بله، نوین از تمام بانک‌های ایرانی پشتیبانی می‌کنه. فرقی نمی‌کنه حساب شما تو کدوم بانک باشه، تو سامانه نوین می‌تونید شماره شبا رو بگیرید.",
  },
  {
    id: nanoid(),
    title:
      "گزارش تبدیل شماره حساب به شماره شبا سامانه نوین شامل چه اطلاعاتی است؟",
    content:
      "علاوه بر شماره شبا، سامانه نوین نام صاحب حساب، وضعیت حساب (فعال یا غیرفعال)، و نوع حساب (مثل جاری یا پس‌انداز) رو هم نشون می‌ده. این اطلاعات تو نوین وان بهتون اطمینان بیشتری می‌ده.",
  },
  {
    id: nanoid(),
    title: "اگه فقط شماره کارت داشته باشم، می‌تونم شبا بگیرم؟",
    content:
      "بله، نوین سرویس تبدیل شماره کارت به شماره شبا هم داره. کافیه شماره ۱۶ رقمی کارت رو تو نوین وان وارد کنید تا شماره شبا رو فوری دریافت کنید.",
  },
];

export const kartToHesabFaqItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "چطور می‌تونم شماره کارت رو به شماره حساب تبدیل کنم؟",
    content:
      "کافیه به novin.one برید، سرویس «تبدیل شماره کارت به شماره حساب» رو از بخش خدمات بانکی انتخاب کنید، شماره ۱۶ رقمی کارت بانکی‌تون رو وارد کنید و بعد از پرداخت هزینه کم، شماره حساب رو فوری دریافت کنید!",
  },
  {
    id: nanoid(),
    title: "چرا باید شماره کارت رو به شماره حساب تبدیل کنم؟",
    content:
      "بعضی وقت‌ها بانک‌ها شماره حساب رو روی کارت درج نمی‌کنن و شما برای تراکنش‌های خاص یا ثبت‌نام در سامانه‌های دولتی بهش نیاز دارید. با نوین، تو کمتر از یه دقیقه شماره حساب رو از شماره کارت بگیرید و کارتون رو راه بندازید!",
  },
  {
    id: nanoid(),
    title: "این سرویس برای کدوم بانک‌ها کار می‌کنه؟",
    content:
      "سامانه نوین از همه بانک‌های ایرانی مثل بانک ملی، صادرات، ملت، کشاورزی، پاسارگاد، و سپه پشتیبانی می‌کنه. هر شماره کارتی داشته باشید، تو novin.one می‌تونید شماره حساب رو بگیرید.",
  },
  {
    id: nanoid(),
    title: "تبدیل شماره کارت به شماره حساب هزینه داره؟",
    content:
      "بله، یه هزینه خیلی کم برای این سرویس پرداخت می‌کنید که خیلی کمتر از هزینه مراجعه حضوری به بانکه. جزئیات هزینه رو تو novin.one ببینید و با خیال راحت استعلام کنید.",
  },
  {
    id: nanoid(),
    title: "چقدر طول می‌کشه تا شماره حساب رو بگیرم؟",
    content:
      "فقط چند ثانیه! بعد از وارد کردن شماره کارت تو novin.one و پرداخت هزینه، شماره حساب فوراً نمایش داده می‌شه. برای موقعیت‌های فوری عالیه!",
  },
  {
    id: nanoid(),
    title: "اگه شماره کارت اشتباه وارد کنم چی می‌شه؟",
    content:
      "اگه شماره کارت رو اشتباه وارد کنید، استعلام نتیجه درستی نمی‌ده. حتماً شماره ۱۶ رقمی رو دقیق وارد کنید. اگه مشکلی پیش اومد، پشتیبانی نوین تو novin.one بهتون کمک می‌کنه.",
  },
  {
    id: nanoid(),
    title: "چه اطلاعاتی همراه با شماره حساب بهم می‌دن؟",
    content:
      "علاوه بر شماره حساب، سامانه نوین اطلاعاتی مثل نام صاحب حساب و گاهی وضعیت حساب (فعال یا غیرفعال) رو هم نشون می‌ده. این اطلاعات تو novin.one بهتون اطمینان بیشتری می‌ده.",
  },
  {
    id: nanoid(),
    title: "آیا اطلاعات من تو سامانه نوین امن می‌مونه؟",
    content:
      "بله، نوین از سیستم‌های امنیتی پیشرفته استفاده می‌کنه تا اطلاعات شما کاملاً محفوظ بمونه. با خیال راحت تو novin.one استعلام کنید.",
  },
  {
    id: nanoid(),
    title: "نتیجه استعلام رو می‌تونم ذخیره کنم؟",
    content:
      "بله، بعد از استعلام، نتیجه تو حساب کاربری‌تون تو novin.one ذخیره می‌شه و حتی به‌صورت فایل PDF قابل دانلوده. اینطوری بعداً بدون هزینه دوباره می‌تونید ازش استفاده کنید!",
  },
  {
    id: nanoid(),
    title: "اگه فقط شماره شبا داشته باشم، می‌تونم شماره حساب بگیرم؟",
    content:
      "بله، نوین سرویس جداگونه‌ای برای تبدیل شماره شبا به شماره حساب داره. اگه شماره شبا دارید، تو novin.one می‌تونید اون رو وارد کنید و شماره حساب رو بگیرید.",
  },
];

export const estelaamSherkatFaqItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "استعلام شرکت شامل چه اطلاعاتی می‌شود؟",
    content:
      "اطلاعاتی مانند شماره ثبت، شناسه ملی، نام شرکت، نوع شخصیت حقوقی، وضعیت قانونی، آدرس و تاریخ ثبت از طریق سامانه‌های رسمی قابل دسترسی است.",
  },
  {
    id: nanoid(),
    title: "آیا امکان استعلام شرکت با نام هم وجود دارد؟",
    content:
      "بله، با مراجعه به سامانه‌هایی مانند ilenc.ir یا irsherkat.ssaa.ir می‌توانید با وارد کردن نام شرکت، اطلاعات ثبت‌شده آن را مشاهده کنید. در سامانه استعلام نوین نیز امکان استعلام از طریق شناسه ملی شرکت نیز وجود دارد.",
  },
  {
    id: nanoid(),
    title: "آیا می‌توان استعلام رتبه شرکت را در نوین انجام داد؟",
    content:
      "خیر، برای استعلام رتبه شرکت‌های پیمانکاری و مشاور باید به سامانه ساجار به آدرس sajar.mporg.ir مراجعه کنید.",
  },
  {
    id: nanoid(),
    title: "آیا استعلام شرکت با شماره ثبت ممکن است؟",
    content:
      "در سامانه نوین خیر، اما در سامانه ثبت شرکت ها بله، با وارد کردن شماره ثبت در سامانه‌هایی مانند irsherkat.ssaa.ir یا ilenc.ir می‌توانید اطلاعات شرکت را مشاهده کنید. همچنین میتوانید از طریق استعلام نوین نیز نسبت به استعلام اطلاعات شرکت نیز اقدام نمایید.",
  },
  {
    id: nanoid(),
    title: "امکان استعلام آخرین تغییرات شرکت در روزنامه رسمی وجود دارد؟",
    content:
      "بله، با مراجعه به سایت روزنامه رسمی به آدرس rooznamehrasmi.ir و جستجوی نام شرکت، می‌توانید آخرین تغییرات آن را مشاهده کنید.",
  },
  {
    id: nanoid(),
    title: "چطور یک شرکت ثبت کنم؟",
    content:
      "ابتدا نوع شرکت را تعیین کرده، سپس مدارک لازم را تهیه و از طریق سامانه irsherkat.ssaa.ir اقدام به ثبت شرکت نمایید.",
  },
  {
    id: nanoid(),
    title: "چطور اطلاعات شرکت را تغییر دهم؟",
    content:
      "با تنظیم صورتجلسه تغییرات، امضای آن توسط اعضا و ثبت در سامانه اداره ثبت شرکت‌ها می‌توانید اطلاعات شرکت را به‌روزرسانی کنید.",
  },
  {
    id: nanoid(),
    title: "آیا امکان استعلام وضعیت مالیاتی شرکت وجود دارد؟",
    content:
      "بله، با ورود به سامانه my.tax.gov.ir و وارد کردن اطلاعات مورد نیاز، می‌توانید وضعیت مالیاتی شرکت را بررسی کنید.",
  },
  {
    id: nanoid(),
    title: "چگونه می‌توانم اعضای هیئت مدیره یک شرکت را استعلام کنم؟",
    content:
      "با مراجعه به سایت روزنامه رسمی و جستجوی نام شرکت، می‌توانید اطلاعات اعضای هیئت مدیره را مشاهده کنید.",
  },
  {
    id: nanoid(),
    title: "آیا امکان استعلام سوابق حقوقی و دعاوی شرکت وجود دارد؟",
    content:
      "بله، از طریق سامانه عدل ایران به آدرس adliran.ir می‌توانید سوابق حقوقی و دعاوی شرکت‌ها را بررسی کنید.",
  },
  {
    id: nanoid(),
    title: "مدارک لازم برای ثبت شرکت چیست؟",
    content:
      "مدارکی مانند کپی شناسنامه و کارت ملی اعضا، اساسنامه، اظهارنامه، صورتجلسه مؤسسین و گواهی عدم سوءپیشینه مورد نیاز است.",
  },
  {
    id: nanoid(),
    title: "هزینه‌های ثبت شرکت چقدر است؟",
    content:
      "هزینه ثبت شرکت بسته به نوع آن2متفاوت است؛ برای شرکت سهامی خاص بین 1,000,000 تا 2,800,000 تومان متغیر است. این قیمت در سال 1404 معتبر است.",
  },
  {
    id: nanoid(),
    title: "مراحل انحلال یک شرکت چیست؟",
    content:
      "شامل تنظیم صورتجلسه انحلال، ثبت آن در سامانه اداره ثبت شرکت‌ها، انتشار آگهی در روزنامه رسمی و تسویه حساب‌های مالی است.",
  },
  {
    id: nanoid(),
    title: "چگونه می‌توانم استعلام اعتبار شرکت را انجام دهم؟",
    content:
      "با مراجعه به سامانه irsherkat.ssaa.ir و وارد کردن شناسه ملی یا شماره ثبت شرکت، می‌توانید از اعتبار آن اطمینان حاصل کنید.",
  },
  {
    id: nanoid(),
    title: "مدت زمان لازم برای ثبت شرکت چقدر است؟",
    content:
      "معمولاً بین 15 تا 30 روز کاری زمان می‌برد، اما این مدت بسته به نوع شرکت و تکمیل بودن مدارک ممکن است متفاوت باشد.",
  },
];

export const estelaamAazaFaqItems: FaqItem[] = [
  { id: nanoid(), title: "", content: "" },
  { id: nanoid(), title: "", content: "" },
  { id: nanoid(), title: "", content: "" },
  { id: nanoid(), title: "", content: "" },
  { id: nanoid(), title: "", content: "" },
];

export const sahebanAazaFaqItems: FaqItem[] = [
  { id: nanoid(), title: "", content: "" },
  { id: nanoid(), title: "", content: "" },
  { id: nanoid(), title: "", content: "" },
  { id: nanoid(), title: "", content: "" },
  { id: nanoid(), title: "", content: "" },
];

export const rooznameRasmiFaqItems: FaqItem[] = [
  { id: nanoid(), title: "", content: "" },
  { id: nanoid(), title: "", content: "" },
  { id: nanoid(), title: "", content: "" },
  { id: nanoid(), title: "", content: "" },
  { id: nanoid(), title: "", content: "" },
];

export const nezamVazifeFaqItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "چگونه می‌توانم از وضعیت سربازی خود مطلع شوم؟",
    content:
      "برای اطلاع از وضعیت خدمت سربازی، می‌توانید به سامانه سخا به نشانی sakha.epolice.ir مراجعه کرده و با وارد کردن کد ملی و کد سخا، اطلاعات مربوط به وضعیت نظام وظیفه خود را مشاهده کنید. همچنین، از طریق ارسال پیامک به شماره ۱۱۰۲۰۶۰۱۰ نیز می‌توانید وضعیت خود را استعلام کنید.",
  },
  {
    id: nanoid(),
    title: "آیا مشمول خدمت سربازی هستم؟",
    content:
      "افرادی که به سن ۱۸ سال تمام رسیده‌اند و شرایط معافیت ندارند، مشمول خدمت سربازی محسوب می‌شوند. برای بررسی دقیق وضعیت مشمولیت، می‌توانید به سامانه سخا مراجعه کرده و اطلاعات خود را وارد کنید.",
  },
  {
    id: nanoid(),
    title: "نحوه استعلام میزان غیبت سربازی چگونه است؟",
    content:
      "برای استعلام میزان غیبت، می‌توانید از دو روش استفاده کنید:\n" +
      "\n" +
      "ورود به سامانه سخا با کد ملی و کد سخا و مشاهده وضعیت غیبت در بخش مربوطه.\n" +
      "\n" +
      "ارسال پیامک حاوی علامت سؤال (؟) به شماره ۱۱۰۲۰۶۰۱۰ و دنبال کردن دستورالعمل‌های ارسالی.",
  },
  {
    id: nanoid(),
    title: "کد سخا چیست و چگونه می‌توان آن را دریافت کرد؟",
    content:
      "کد سخا یک کد ۵ رقمی است که برای ورود به سامانه سخا استفاده می‌شود. این کد هنگام ثبت‌نام در دفاتر پلیس +۱۰ و ارسال دفترچه اعزام به خدمت به مشمولان داده می‌شود.",
  },
  {
    id: nanoid(),
    title: "چگونه می‌توان کارت معافیت یا پایان خدمت را پیگیری کرد؟",
    content:
      "برای پیگیری صدور کارت معافیت یا پایان خدمت، می‌توانید به سامانه نظام وظیفه عمومی به نشانی vazifeh.police.ir مراجعه کرده و از بخش خدمات الکترونیکی با وارد کردن کد ملی و کد سخا، وضعیت صدور کارت را بررسی کنید.",
  },
  {
    id: nanoid(),
    title: "آیا امکان استعلام وضعیت سربازی بدون کد سخا وجود دارد؟",
    content:
      "بله، در صورتی که کد سخا را در اختیار ندارید، می‌توانید از طریق ارسال پیامک به شماره ۱۱۰۲۰۶۰۱۰ و دنبال کردن دستورالعمل‌های ارسالی، وضعیت خود را استعلام کنید.",
  },
  {
    id: nanoid(),
    title: "چگونه می‌توان معافیت تحصیلی را استعلام کرد؟",
    content:
      "برای استعلام معافیت تحصیلی، می‌توانید به سامانه سخا مراجعه کرده و با وارد کردن کد ملی و کد سخا، وضعیت معافیت تحصیلی خود را مشاهده کنید.",
  },
  {
    id: nanoid(),
    title: "آیا می‌توان از طریق پیامک وضعیت سربازی را استعلام کرد؟",
    content:
      "بله، با ارسال پیامک حاوی علامت سؤال (؟) به شماره ۱۱۰۲۰۶۰۱۰، می‌توانید دستورالعمل‌های لازم برای استعلام وضعیت سربازی را دریافت کرده و با ارسال اطلاعات مورد نیاز، وضعیت خود را بررسی کنید.",
  },
  {
    id: nanoid(),
    title: "چگونه می‌توان از میزان اضافه خدمت مطلع شد؟",
    content:
      "برای اطلاع از میزان اضافه خدمت، می‌توانید به سامانه سخا مراجعه کرده و با وارد کردن کد ملی و کد سخا، اطلاعات مربوط به اضافه خدمت خود را مشاهده کنید.",
  },
  {
    id: nanoid(),
    title: "آیا امکان استعلام وضعیت سربازی به‌صورت حضوری وجود دارد؟",
    content:
      "بله، در صورت نیاز، می‌توانید به دفاتر پلیس +۱۰ مراجعه کرده و با ارائه مدارک شناسایی، وضعیت سربازی خود را به‌صورت حضوری استعلام کنید.",
  },
];

export const codepostiFaqItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "کد پستی چیست و چه کاربردی دارد؟",
    content:
      "کد پستی یک شناسه ۱۰ رقمی است که برای تعیین دقیق موقعیت جغرافیایی ساختمان‌ها و اماکن استفاده می‌شود. این کد به تسهیل در ارسال مرسولات پستی، خدمات بانکی، ثبت‌نام‌های دولتی و تبلیغات منطقه‌ای کمک می‌کند.",
  },
  {
    id: nanoid(),
    title: "ساختار کد پستی چگونه است؟",
    content:
      "کد پستی از ۱۰ رقم تشکیل شده است: پنج رقم اول نشان‌دهنده منطقه جغرافیایی (کد رهسپاری) و پنج رقم دوم مشخص‌کننده مکان دقیق‌تر یا کد توزیع است.",
  },
  {
    id: nanoid(),
    title: "چگونه می‌توان کد پستی را از روی نقشه پیدا کرد؟",
    content:
      "با مراجعه به سامانه GNAF شرکت ملی پست ایران به آدرس gnaf.post.ir، می‌توانید با وارد کردن آدرس یا انتخاب مکان مورد نظر روی نقشه، کد پستی مربوطه را مشاهده کنید.",
  },
  {
    id: nanoid(),
    title: "آیا امکان استعلام کد پستی با استفاده از پیامک وجود دارد؟",
    content:
      "بله، با ارسال شماره تلفن ثابت محل مورد نظر به شماره 7087، می‌توانید کد پستی مربوطه را دریافت کنید. توجه داشته باشید که این سرویس ممکن است هزینه‌ای داشته باشد و در برخی مواقع فعال نباشد.",
  },
  {
    id: nanoid(),
    title: "چگونه می‌توان کد پستی را از روی قبوض خدماتی پیدا کرد؟",
    content:
      "کد پستی معمولاً در قسمت بالای قبوض خدماتی مانند آب، برق و گاز درج می‌شود. با بررسی این قبوض می‌توانید کد پستی محل سکونت یا کار خود را بیابید.",
  },
  {
    id: nanoid(),
    title: "آیا می‌توان با استفاده از کد ملی، کد پستی را استعلام کرد؟",
    content:
      "خیر، در حال حاضر امکان استعلام کد پستی با استفاده از کد ملی وجود ندارد. برای این منظور باید از روش‌های دیگر مانند سامانه GNAF یا قبوض خدماتی استفاده کنید.",
  },
  {
    id: nanoid(),
    title: "چگونه می‌توان گواهی تأییدیه کد پستی دریافت کرد؟",
    content:
      "برای دریافت گواهی تأییدیه کد پستی، می‌توانید به سامانه شرکت ملی پست ایران مراجعه کرده و با وارد کردن کد پستی و اطلاعات مورد نیاز، گواهی مربوطه را دریافت کنید. این گواهی در امور اداری و بانکی کاربرد دارد.",
  },
  {
    id: nanoid(),
    title: "آیا امکان دریافت کد پستی به‌صورت حضوری وجود دارد؟",
    content:
      "بله، با مراجعه به دفاتر پست سراسر کشور و ارائه آدرس دقیق محل مورد نظر، می‌توانید کد پستی مربوطه را دریافت کنید. این روش برای افرادی که دسترسی به اینترنت ندارند مفید است.",
  },
  {
    id: nanoid(),
    title: "آیا کد پستی در کارت‌های ملی جدید درج شده است؟",
    content:
      "در کارت‌های ملی قدیمی، کد پستی درج می‌شد، اما در کارت‌های ملی جدید این اطلاعات وجود ندارد. برای یافتن کد پستی باید از روش‌های دیگر مانند سامانه GNAF یا قبوض خدماتی استفاده کنید.",
  },
  {
    id: nanoid(),
    title: "آیا امکان استعلام آدرس پستی از طریق کد ملی وجود دارد؟",
    content:
      "خیر، جستجوی زیادی در زمینه استعلام کد پستی با کد ملی توسط کاربران میشود اما چنین چیزی در حال حاضر امکان پذیر نیست.",
  },
];

export const servicesFaqItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "سامانه نوین چه خدماتی ارائه می‌دهد؟",
    content:
      "سامانه نوین خدمات متنوعی در چهار دسته بانکی، خودرویی، دولتی، و حقوقی ارائه می‌کند، از جمله استعلام چک برگشتی، تبدیل شماره کارت به شبا، استعلام خلافی خودرو، و استعلام اطلاعات شرکت. همه این خدمات به‌صورت آنلاین و آنی در novin.one در دسترس هستند.",
  },
  {
    id: nanoid(),
    title: "چگونه می‌توانم از خدمات بانکی نوین استفاده کنم؟",
    content:
      "کافی است به وب‌سایت novin.one مراجعه کنید، بخش «خدمات بانکی» را انتخاب کنید و سرویس موردنظرتان (مثل تبدیل شماره حساب به شبا یا استعلام چک برگشتی) را با وارد کردن اطلاعات لازم استعلام کنید. فرآیند سریع و ساده است!",
  },
  {
    id: nanoid(),
    title: "آیا خدمات استعلامی نوین برای همه بانک‌ها قابل استفاده است؟",
    content:
      "بله، سامانه نوین از تمام بانک‌های معتبر ایرانی پشتیبانی می‌کند. خدماتی مانند تبدیل شماره کارت به شبا یا شماره حساب برای همه بانک‌ها، از جمله بانک ملی، صادرات، ملت، و پاسارگاد، در novin.one ارائه می‌شود.",
  },
  {
    id: nanoid(),
    title: "هزینه استفاده از خدمات نوین چقدر است؟",
    content:
      "هزینه خدمات نوین بسیار مقرون‌به‌صرفه و معمولاً کمتر از مراجعه حضوری است. جزئیات هزینه هر سرویس هنگام استعلام در novin.one نمایش داده می‌شود، و برخی خدمات ممکن است رایگان باشند.",
  },
  {
    id: nanoid(),
    title: "آیا می‌توانم نتایج استعلام را ذخیره کنم؟",
    content:
      "بله، نتایج استعلام‌ها در حساب کاربری‌تان در novin.one ذخیره می‌شود و می‌توانید آن‌ها را به‌صورت فایل PDF دانلود کنید. این امکان برای مراجعات بعدی بسیار کاربردی است.",
  },
  {
    id: nanoid(),
    title: "چگونه می‌توانم از استعلام چک برگشتی استفاده کنم؟",
    content:
      "در بخش خدمات بانکی novin.one، سرویس «استعلام چک برگشتی» را انتخاب کنید، کد ملی صاحب چک یا شناسه ۱۶ رقمی صیادی را وارد کنید، و سابقه چک‌های برگشتی را در لحظه ببینید. این سرویس برای معاملات امن‌تر عالی است!",
  },
  {
    id: nanoid(),
    title: "برای استعلام خلافی خودرو به چه اطلاعاتی نیاز دارم؟",
    content:
      "برای استعلام خلافی در novin.one، شماره پلاک و شماره VIN (شماره شاسی) خودرو را وارد کنید. نتیجه شامل لیست تخلفات، مبلغ جریمه، و مجموع بدهی به‌صورت دقیق نمایش داده می‌شود.",
  },
  {
    id: nanoid(),
    title: "آیا خدمات نوین امن هستند؟",
    content:
      "بله، سامانه نوین از پروتکل‌های امنیتی پیشرفته استفاده می‌کند تا اطلاعات شما کاملاً محفوظ بماند. تمام استعلام‌ها با اتصال به منابع رسمی انجام می‌شود، و می‌توانید با اطمینان در novin.one از خدمات استفاده کنید.",
  },
  {
    id: nanoid(),
    title: "چقدر طول می‌کشد تا نتیجه استعلام را دریافت کنم؟",
    content:
      "اکثر استعلام‌ها در سامانه نوین در کمتر از یک دقیقه انجام می‌شوند. کافی است اطلاعات موردنیاز را در novin.one وارد کنید تا نتیجه به‌صورت آنی نمایش داده شود.",
  },
  {
    id: nanoid(),
    title: "آیا خدمات نوین جایگزین مراجعه حضوری می‌شوند؟",
    content:
      "بله، خدمات نوین به‌گونه‌ای طراحی شده‌اند که نیاز به مراجعه حضوری به بانک‌ها، ادارات دولتی، یا مراکز خدماتی مثل پلیس +۱۰ را برطرف کنند. با novin.one، همه استعلام‌ها را آنلاین و سریع انجام دهید!",
  },
];

export const khalafiFaqItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "استعلام خلافی خودرو در نوین وان چطور انجام می‌شه؟",
    content:
      "کافیه وارد سامانه نوین وان بشید، تو بخش خدمات خودرویی گزینه خلافی خودرو رو انتخاب کنید و شماره پلاک خودروتون رو با کد ملی مالک وارد کنید. تو کمتر از یه دقیقه، لیست کامل جریمه‌ها با جزئیات مثل زمان، مکان، و نوع تخلف بهتون نشون داده می‌شه.",
  },
  {
    id: nanoid(),
    title: "آیا استعلام خلافی خودرو تو نوین وان رایگانه؟",
    content:
      "خیر، استعلام خلافی خودرو نه تنها توی نوین وان رایگان نیست بلکه هیچجا حتی مراکز پلیس +10 مبلغی رو جهت استعلام دریافت میکنند چرا که باید به راهور این هزینه جهت استعلام پرداخت بشه، اما توی نوین وان از بقیه جاها ارزون تر میتونید استعلام بگیرید. ما سعی کردیم هزینه‌ها رو به حداقل برسونیم تا همه بتونن راحت از سرویس استفاده کنن.",
  },
  {
    id: nanoid(),
    title: "چطور می‌تونم جریمه‌های خودرومو با نوین وان پرداخت کنم؟",
    content:
      "بعد از استعلام خلافی، جزئیات جریمه‌ها با شناسه قبض و پرداخت بهتون نشون داده می‌شه. می‌تونید هر جریمه رو جداگونه یا همه رو یه‌جا با درگاه امن نوین وان پرداخت کنید. رسید دیجیتال هم فوری براتون صادر می‌شه.",
  },
  {
    id: nanoid(),
    title: "اگه جریمه‌هامو به موقع پرداخت نکنم، چی می‌شه؟",
    content:
      "اگه جریمه‌ها رو تو ۶۰ روز پرداخت نکنید، دوبرابر می‌شن و ممکنه خودروتون شکایت‌دار بشه. حتی اگه جریمه‌ها بالای ۱,۰۰۰,۰۰۰ تومن باشن، خطر توقیف خودرو هم وجود داره. نوین وان بهتون هشدار می‌ده که کدوم جریمه‌ها نزدیک دوبرابر شدن هستن تا سریع اقدام کنید.",
  },
  {
    id: nanoid(),
    title: "می‌تونم خلافی خودروی یکی دیگه رو استعلام کنم؟",
    content:
      "بله! فقط کافیه شماره پلاک خودرو رو داشته باشید. تو نوین وان نیازی به اطلاعات شخصی مالک نیست، مگر برای استعلام‌های خاص که کد ملی بخواد. این باعث می‌شه استعلام خلافی برای هر خودرویی راحت و سریع باشه. خلاصه برای استعلام خلافی بدون ریز جزئیات جریمه ها و فقط تجمیعی میتونید بدون کد ملی و فقط با پلاک اقدام کنید و اگر جزئیات کامل رو میخوای باید کد ملی شخص رو هم وارد کنی",
  },
  {
    id: nanoid(),
    title: "چقدر طول می‌کشه تا پرداخت خلافی تو سیستم راهور ثبت بشه؟",
    content:
      "پرداخت تو نوین وان فوری انجام می‌شه و رسید دیجیتال می‌گیرید، ولی ثبت تو سیستم راهور ۱۲۰ ممکنه تا ۷۲ ساعت طول بکشه چون سیستم اونا یه کم کنده. ما تو نوین وان سریع‌ترین پردازش رو داریم تا خیالتون راحت باشه",
  },
  {
    id: nanoid(),
    title: "چطور می‌تونم به جریمه‌های نادرست اعتراض کنم؟",
    content:
      "اگه فکر می‌کنید جریمه‌ای اشتباه ثبت شده، می‌تونید تو ۶۰ روز با کارت خودرو، گواهینامه، کارت شناسایی، و فرم اعتراض به مراکز اجرائیات راهور مراجعه کنید. نوین وان جزئیات جریمه‌ها مثل تصویر تخلف رو بهتون نشون می‌ده تا راحت‌تر اعتراض کنید.",
  },
  {
    id: nanoid(),
    title: "آیا نوین وان برای شرکت‌های حمل‌ونقل هم سرویس داره؟",
    content:
      "قطعاً! اگه ناوگان خودرویی دارید، می‌تونید با سرویس استعلام گروهی نوین وان، خلافی همه خودروها رو یه‌جا چک کنید و پرداخت کنید. این کار کلی تو وقت و هزینه‌تون صرفه‌جویی می‌کنه.",
  },
  {
    id: nanoid(),
    title: "اطلاعات من تو نوین وان چطور امن می‌مونه؟",
    content:
      "ما تو نوین وان از رمزنگاری پیشرفته استفاده می‌کنیم و داده‌هاتون بعد از یه ماه خودکار از سرورها پاک می‌شه. اطلاعات شما فقط تو حساب کاربری‌تون نمایش داده می‌شه و هیچ‌کس، حتی خود ما، بهش دسترسی نداره. خیالتون از بابت امنیت کاملاً راحته!",
  },
  {
    id: nanoid(),
    title: "برای تعویض پلاک یا فروش خودرو، خلافی رو چطور مدیریت کنم؟",
    content:
      "قبل از تعویض پلاک یا فروش خودرو، باید همه جریمه‌ها رو تسویه کنید. با نوین وان می‌تونید سریع خلافی خودروتون رو استعلام کنید، جزئیات رو ببینید، و همون‌جا پرداخت کنید. اینجوری بدون دردسر آماده نقل‌وانتقال خودرو می‌شید.",
  },
];

export const convertMoneyInquiryItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "تبدیل ریال به تومان چگونه انجام می‌شود؟",
    content:
      "برای تبدیل ریال به تومان کافی‌ست عدد ریالی را وارد کنید تا مبلغ به‌صورت خودکار بر ۱۰ تقسیم و به تومان نمایش داده شود.",
  },
  {
    id: nanoid(),
    title: "هر تومان چند ریال است؟",
    content:
      "هر ۱ تومان برابر با ۱۰ ریال است و این نسبت در تمام محاسبات رسمی ثابت است.",
  },
  {
    id: nanoid(),
    title: "تبدیل تومان به ریال چطور محاسبه می‌شود؟",
    content:
      "در تبدیل تومان به ریال، عدد واردشده در ۱۰ ضرب می‌شود تا مبلغ نهایی به ریال محاسبه گردد.",
  },
  {
    id: nanoid(),
    title: " آیا این برنامه تبدیل ریال به تومان آنلاین رایگان است؟",
    content:
      "بله، این سرویس تبدیل ریال به تومان و تومان به ریال کاملاً رایگان و بدون نیاز به ثبت‌نام است.",
  },
  {
    id: nanoid(),
    title: "آیا نتایج تبدیل ریال به تومان دقیق هستند؟",
    content:
      "بله، محاسبات کاملاً دقیق و بر اساس نسبت رسمی ریال و تومان انجام می‌شود و خطای محاسباتی ندارد.",
  },
  {
    id: nanoid(),
    title: " آیا امکان تبدیل تومن به ریال با املای محاوره‌ای هم وجود دارد؟",
    content:
      "بله، چه با جستجوی «تومن به ریال» و چه «تومان به ریال»، می‌توانید از این ابزار استفاده کنید.",
  },
  {
    id: nanoid(),
    title: " این ابزار برای چه کسانی کاربردی است؟",
    content:
      "برای کاربران عادی، حسابداران، فروشگاه‌های اینترنتی، کسب‌وکارها و هر کسی که با مبالغ ریالی و تومانی سروکار دارد.",
  },
  {
    id: nanoid(),
    title: " آیا تبدیل ریال به تومان به اینترنت خاصی نیاز دارد؟",
    content:
      "خیر، تنها با دسترسی عادی به اینترنت می‌توانید از این برنامه تبدیل ریال به تومان آنلاین استفاده کنید.",
  },
  {
    id: nanoid(),
    title: "آیا این سرویس روی موبایل هم قابل استفاده است؟",
    content:
      "بله، ابزار تبدیل ریال به تومان کاملاً ریسپانسیو است و روی موبایل، تبلت و دسکتاپ به‌خوبی کار می‌کند.",
  },
  {
    id: nanoid(),
    title: "آیا تبدیل ریال به تومان برای محاسبات رسمی قابل اعتماد است؟",
    content:
      "بله، این تبدیل بر اساس استاندارد رسمی پول ایران انجام می‌شود و برای محاسبات روزمره و اداری قابل استفاده است.",
  },
];

export const estelamPelakInquiryItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "چگونه بفهمم پلاک دولتی است یا شخصی؟",
    content:
      'پلاک‌های دولتی قرمز رنگ با حرف "الف" هستند، در حالی که شخصی سفید با حروف مانند "ج" یا "س". سرویس نوین وان این تمایز را نشان می‌دهد.',
  },
  {
    id: nanoid(),
    title: "آیا سرویس پلاک یاب هزینه‌ای دارد؟",
    content:
      "خیر، کاملاً رایگان است و بخشی از خدمات نوین وان برای کاربران ایرانی.",
  },
  {
    id: nanoid(),
    title: "اگر کد پلاک اشتباه وارد کنم چه می‌شود؟",
    content:
      "سیستم خطا را نمایش می‌دهد و پیشنهاد می‌کند کد درست را امتحان کنید. همیشه از منابع معتبر برای چک اولیه استفاده کنید.",
  },
  {
    id: nanoid(),
    title: "آیا این سرویس همان سرویس استعلام پلاک است؟",
    content:
      "خیر، این سرویس یکی از خدمات ارائه شده رایگان در سامانه نوین استعلام است و با سرویس استعلام پلاک خودرو تفاوت دارد، در آن سریس اطلاعاتی از خودرو بر اساس پلاک آن ارائه میگردد و رایگان نیست.",
  },
];

export const plateInquiryItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "استعلام پلاک فعال خودرو چیست؟",
    content:
      "استعلام پلاک فعال خودرو سرویسی است که به شما امکان می‌دهد از پلاک‌های ثبت‌شده به نام خود در سیستم راهنمایی و رانندگی مطلع شوید.",
  },
  {
    id: nanoid(),
    title: "چرا باید پلاک فعال خودرو را استعلام کنم؟",
    content:
      "این استعلام به شما کمک می‌کند تا از ثبت پلاک‌های ناخواسته به نام خود (مثلاً پس از فروش خودرو) مطلع شده و از مشکلات قانونی جلوگیری کنید.",
  },
  {
    id: nanoid(),
    title: "چگونه می‌توانم در سامانه نوین وان استعلام پلاک انجام دهم؟",
    content:
      "به وب‌سایت https://novin.one مراجعه کنید، سرویس استعلام پلاک را انتخاب کرده و کد ملی و شماره موبایل خود را وارد کنید.",
  },
  {
    id: nanoid(),
    title: "چه اطلاعاتی در استعلام پلاک فعال نمایش داده می‌شود؟",
    content:
      "اطلاعاتی مانند شماره پلاک، وضعیت (فعال یا غیرفعال)، و تاریخ ثبت پلاک به شما نمایش داده می‌شود.",
  },
  {
    id: nanoid(),
    title: "آیا استعلام پلاک فعال در نوین وان هزینه دارد؟",
    content:
      "بله، ممکن است هزینه‌ای اندک برای این سرویس دریافت شود. برای جزئیات بیشتر به وب‌سایت نوین وان مراجعه کنید.",
  },
  {
    id: nanoid(),
    title: "اگر پلاک فعالی به نام من ثبت باشد که نباید باشد، چه کنم؟",
    content:
      "به مراکز تعویض پلاک مراجعه کنید و درخواست فک پلاک دهید. نوین وان نیز می‌تواند راهنمایی‌های لازم را ارائه دهد.",
  },
  {
    id: nanoid(),
    title: "آیا می‌توانم پلاک‌های فک‌شده را نیز استعلام کنم؟",
    content:
      "بله، در سامانه نوین وان امکان استعلام پلاک‌های غیرفعال یا فک‌شده نیز وجود دارد.",
  },
  {
    id: nanoid(),
    title: "آیا استعلام پلاک فعال در نوین وان امن است؟",
    content:
      "بله، نوین وان از پروتکل‌های امنیتی پیشرفته برای حفاظت از اطلاعات کاربران استفاده می‌کند.",
  },
  {
    id: nanoid(),
    title: "چه مدارکی برای استعلام پلاک فعال نیاز است؟",
    content:
      "تنها به کد ملی و شماره موبایل مرتبط با آن نیاز دارید تا استعلام را انجام دهید.",
  },
  {
    id: nanoid(),
    title: "آیا می‌توانم از نوین وان برای استعلام خلافی خودرو نیز استفاده کنم؟",
    content:
      "بله، نوین وان خدمات دیگری مانند استعلام خلافی خودرو را نیز ارائه می‌دهد.",
  },
];

export const negativePointsInquiryItems: FaqItem[] = [
  {
    id: nanoid(),
    title:
      "چگونه می‌توانم نمره منفی گواهینامه‌ام را به‌صورت آنلاین استعلام کنم؟",
    content:
      "برای استعلام آنلاین، کافی است به سایت نوین وان مراجعه کرده، اطلاعات موردنیاز (شماره گواهینامه و کد ملی) را وارد کنید و گزارش را دریافت کنید.",
  },
  {
    id: nanoid(),
    title: "آیا استعلام نمره منفی هزینه دارد؟",
    content:
      "بله، بسته به پلتفرم مورد استفاده ممکن است هزینه اندکی داشته باشد. در سامانه نوین وان، هزینه‌ها شفاف و مقرون‌به‌صرفه هستند. برای جزئیات بیشتر، به صفحه تعرفه‌ها مراجعه کنید.",
  },
  {
    id: nanoid(),
    title: "چه زمانی گواهینامه به دلیل نمره منفی ضبط می‌شود؟",
    content:
      "اگر نمره منفی شما به 30 (برای گواهینامه‌های معمولی) یا 20 (برای گواهینامه‌های حرفه‌ای) برسد، گواهینامه شما به‌مدت 3 ماه ضبط می‌شود.",
  },
  {
    id: nanoid(),
    title: "آیا می‌توانم نمره منفی را حذف کنم؟",
    content:
      "بله، با رعایت قوانین به مدت 6 ماه یا شرکت در دوره‌های آموزشی، می‌توانید نمره منفی را کاهش دهید.",
  },
  {
    id: nanoid(),
    title: "آیا استعلام نمره منفی برای دیگران امکان‌پذیر است؟",
    content:
      "بله، در صورتی که اطلاعات لازم (مانند شماره گواهینامه و کد ملی) را داشته باشید، می‌توانید از طریق سامانه نوین وان برای دیگران نیز استعلام کنید.",
  },
];

export const passportStatusInquiryItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "چگونه وضعیت گذرنامه عادی را استعلام کنم؟",
    content:
      "برای استعلام گذرنامه عادی، به پنل نوین وان وارد شوید و کد ملی همراه با شماره پیگیری را وارد نمایید. نتایج در کمتر از ۳۰ ثانیه نمایش داده می‌شود و شامل وضعیت فعلی و تخمین زمان تحویل است.",
  },
  {
    id: nanoid(),
    title: "تفاوت استعلام گذرنامه زیارتی با عادی چیست؟",
    content:
      "استعلام گذرنامه زیارتی بر اساس کد ثبت‌نام سماح یا گواهی زیارتی انجام می‌شود و اولویت بالاتری در ایام اربعین دارد (۳-۵ روزه)، در حالی که عادی برای مقاصد جهانی است و ۱۰-۱۴ روز زمان می‌برد.",
  },
  {
    id: nanoid(),
    title: "آیا نوین وان برای هر دو نوع گذرنامه سرویس می‌دهد؟",
    content:
      "بله، نوین وان هر دو نوع گذرنامه عادی و زیارتی را پوشش می‌دهد و امکان پیگیری همزمان را از طریق یک داشبورد واحد فراهم می‌کند.",
  },
  {
    id: nanoid(),
    title: "هزینه استعلام گذرنامه چقدر است؟",
    content:
      "میزان هزینه هر استعلام در هر سال متفاوت است اما در سال 1404 هزینه استعلام گذرنامه نوین وان 16170 تومان است.",
  },
  {
    id: nanoid(),
    title: "اگر گذرنامه‌ام تأخیر داشته باشد، چه کنم؟",
    content:
      "در صورت تأخیر، وضعیت را از طریق تلفنی و از ارگان صادر کننده گذرنامه پیگیری کنید و یا با مراجعه به دفاتر پیشخوان مشکل را جویا شوید.",
  },
  {
    id: nanoid(),
    title: "می‌توانم همزمان گذرنامه عادی و زیارتی داشته باشم؟",
    content:
      "بله، طبق مقررات پلیس مهاجرت، نگهداری همزمان هر دو نوع مجاز است و نوین وان استعلام هر دو را بدون تداخل مدیریت می‌کند.",
  },
  {
    id: nanoid(),
    title: "برای استعلام گذرنامه عادی، چه اطلاعاتی نیاز دارم؟",
    content:
      "تنها ارائه کد ملی  کافی است. نوین وان با اعتبارسنجی خودکار، فرآیند را ساده می‌کند.",
  },
  {
    id: nanoid(),
    title: "استعلام گذرنامه زیارتی در ایام اربعین چگونه است؟",
    content:
      "در ایام اربعین، استعلام گذرنامه زیارتی با کد سماح اولویت‌دار است و نوین وان هشدارهای زمانی برای جلوگیری از تأخیر ارسال می‌کند.",
  },
  {
    id: nanoid(),
    title: "آیا نوین وان اطلاعات شخصی را ذخیره می‌کند؟",
    content:
      "خیر، نوین وان اطلاعات حساس مانند کد ملی را فقط برای استعلام موقت استفاده کرده و با پروتکل SSL محافظت می‌کند، بدون ذخیره دائمی.",
  },
  {
    id: nanoid(),
    title: "زمان تقریبی صدور گذرنامه عادی پس از استعلام مثبت چقدر است؟",
    content:
      "پس از تأیید استعلام گذرنامه عادی، صدور معمولاً ۱۰-۱۴ روز کاری طول می‌کشد، که نوین وان تخمین دقیق آن را نمایش می‌دهد.",
  },
  {
    id: nanoid(),
    title: "برای تمدید گذرنامه زیارتی، استعلام چگونه انجام می‌شود؟",
    content:
      "برای تمدید گذرنامه زیارتی، کد ملی و شماره گذرنامه قبلی را وارد کنید؛ نوین وان وضعیت تمدید را با تمرکز بر اعتبار محدود (۱ ساله) بررسی می‌کند.",
  },
  {
    id: nanoid(),
    title: "آیا استعلام آنلاین گذرنامه عادی معتبر است؟",
    content:
      "بله، استعلام نوین وان مستقیماً از سامانه رسمی اداره گذرنامه استخراج می‌شود و همان اعتبار مراجع حضوری را دارد.",
  },
  {
    id: nanoid(),
    title: "مشکلات رایج در استعلام گذرنامه زیارتی چیست؟",
    content:
      "مشکلاتی مانند خطای کد سماح یا شلوغی ایام پیک؛ نوین وان با راهنمایی گام‌به‌گام و پشتیبانی، بیش از ۹۰% موارد را در ۲۴ ساعت حل می‌کند.",
  },
  {
    id: nanoid(),
    title: "چگونه اعتبار گذرنامه فعلی را قبل از استعلام چک کنم؟",
    content:
      "با استعلام گذرنامه نوین وان می‌توانید به راحتی مدت زمان اعتبار گذرنامه خود را ببینید. برای عادی تا ۵ سال و برای زیارتی تا ۱ سال، تاریخ انقضا را مشاهده نمایید.",
  },
  {
    id: nanoid(),
    title: "آیا برای استعلام گذرنامه عادی، اپلیکیشن لازم است؟",
    content:
      "خیر، استعلام از طریق وب‌سایت نوین وان ممکن است، اما اپلیکیشن برای نوتیفیکیشن‌های فوری گذرنامه عادی یا زیارتی توصیه می‌شود.",
  },

  {
    id: nanoid(),
    title: "تفاوت جلد گذرنامه عادی و زیارتی در استعلام چیست؟",
    content:
      "جلد عادی قهوه‌ای و زیارتی آبی است، اما در استعلام نوین وان، نوع بر اساس کد پیگیری تشخیص داده می‌شود.",
  },
  {
    id: nanoid(),
    title: "اگر شماره پیگیری گذرنامه زیارتی را گم کرده باشم، چه کنم؟",
    content:
      "با کد ملی و گواهی سماح استعلام کنید؛ نوین وان گزینه بازیابی شماره پیگیری را از سامانه رسمی فراهم می‌آورد.",
  },
  {
    id: nanoid(),
    title: "استعلام گذرنامه عادی برای کودکان چگونه است؟",
    content:
      "با کد ملی والد و شماره درخواست مشترک؛ نوین وان مدارک اضافی مانند رضایت‌نامه را در فرآیند استعلام بررسی می‌کند.",
  },
  {
    id: nanoid(),
    title: "آیا نوین وان برای استعلام گذرنامه زیارتی اربعین ۱۴۰۴ بهینه است؟",
    content:
      "بله، با هشدارهای اختصاصی برای اربعین ۱۴۰۴، نوین وان پیگیری گذرنامه زیارتی را در کمتر از ۲۰ ثانیه انجام می‌دهد.",
  },
  {
    id: nanoid(),
    title: "پشتیبانی نوین وان برای مشکلات استعلام گذرنامه چطور است؟",
    content:
      "پشتیبانی ۲۴ ساعته از طریق چت، تلفن و ایمیل؛ برای هرگونه مسئله در استعلام گذرنامه عادی یا زیارتی، پاسخ در کمتر از ۵ دقیقه تضمین می‌شود.",
  },
];

export const sanaInquiryItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "استعلام وضعیت ثنا چیست و چرا اهمیت دارد؟",
    content:
      "استعلام وضعیت ثنا فرآیندی است که نشان می‌دهد آیا یک فرد در سامانه ثنا قوه قضاییه ثبت‌نام کرده است یا خیر. این استعلام برای امور حقوقی، بانکی (مانند دریافت وام) و پیگیری پرونده‌های قضایی ضروری است، زیرا ثبت‌نام در سامانه ثنا تضمین می‌کند که ابلاغیه‌های قضایی به صورت الکترونیکی دریافت شوند.",
  },
  {
    id: nanoid(),
    title: "چگونه می‌توانم استعلام وضعیت ثنا را انجام دهم؟",
    content:
      "برای استعلام وضعیت ثنا، به وب‌سایت سامانه نوین مراجعه کنید، سرویس استعلام وضعیت ثنا را انتخاب کنید، کد ملی شخص را وارد کرده و پس از پرداخت هزینه (در صورت نیاز)، نتیجه را دریافت کنید. این فرآیند سریع و آنلاین است.",
  },
  {
    id: nanoid(),
    title: "آیا برای استعلام وضعیت ثنا نیاز به ثبت‌نام در سامانه نوین دارم؟",
    content:
      "بله، برای استفاده از خدمات سامانه نوین، باید ابتدا در وب‌سایت novin.one ثبت‌نام کنید. فرآیند ثبت‌نام ساده است و تنها چند دقیقه طول می‌کشد.",
  },
  {
    id: nanoid(),
    title: "چه اطلاعاتی برای استعلام وضعیت ثنا مورد نیاز است؟",
    content:
      "برای انجام استعلام، تنها نیاز به کد ملی شخص مورد نظر دارید. اطمینان حاصل کنید که کد ملی وارد شده صحیح باشد تا نتیجه دقیق دریافت کنید.",
  },
  {
    id: nanoid(),
    title: "آیا استعلام وضعیت ثنا در سامانه نوین امن است؟",
    content:
      "بله، سامانه نوین از پروتکل‌های امنیتی پیشرفته استفاده می‌کند تا اطلاعات کاربران محافظت شود. این پلتفرم به منابع رسمی متصل است و اطلاعات قابل اعتمادی ارائه می‌دهد.",
  },
  {
    id: nanoid(),
    title: "هزینه استعلام وضعیت ثنا در سامانه نوین چقدر است؟",
    content:
      "هزینه این سرویس بسته به سیاست‌های سامانه نوین متفاوت است. برای اطلاع از مبلغ دقیق، به صفحه استعلام وضعیت ثنا مراجعه کنید.",
  },
  {
    id: nanoid(),
    title:
      "اگر نتیجه استعلام نشان دهد که فرد در سامانه ثنا ثبت‌نام نکرده است، چه باید کرد؟",
    content:
      "در این صورت، فرد باید در سامانه ثنا ثبت‌نام کند. برای این کار، به وب‌سایت sana.adliran.ir مراجعه کرده یا به دفاتر خدمات قضایی مراجعه کنید.",
  },
  {
    id: nanoid(),
    title: "آیا می‌توانم استعلام وضعیت ثنا را برای شخص دیگری انجام دهم؟",
    content:
      "بله، با داشتن کد ملی شخص، می‌توانید استعلام را انجام دهید. با این حال، رعایت قوانین حریم خصوصی و استفاده مسئولانه از این اطلاعات ضروری است.",
  },
  {
    id: nanoid(),
    title: "تفاوت استعلام وضعیت ثنا با سایر خدمات سامانه نوین چیست؟",
    content:
      "سامانه نوین خدمات متنوعی مانند استعلام چک برگشتی، شماره شبا و کد پستی ارائه می‌دهد. استعلام وضعیت ثنا صرفاً برای بررسی ثبت‌نام در سامانه ثنا است، در حالی که سایر خدمات برای امور بانکی، پستی یا حقوقی دیگر کاربرد دارند.",
  },
  {
    id: nanoid(),
    title: "آیا نتایج استعلام وضعیت ثنا قابل دانلود یا ذخیره هستند؟",
    content:
      "بله، در سامانه نوین می‌توانید نتایج استعلام را در حساب کاربری خود ذخیره کرده یا به صورت PDF دانلود کنید تا در آینده به آن دسترسی داشته باشید.",
  },
];

export const identityInquiryItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "استعلام ثبت احوال چیست و چرا اهمیت دارد؟",
    content:
      "استعلام ثبت احوال فرآیندی است که اطلاعات هویتی افراد مانند نام، نام خانوادگی، کد ملی و وضعیت حیات را از سازمان ثبت احوال کشور بررسی می‌کند. در ایران، این سرویس برای تأیید هویت در امور بانکی، حقوقی و دولتی ضروری است و از کلاهبرداری جلوگیری می‌کند.",
  },
  {
    id: nanoid(),
    title: "چگونه می‌توانم استعلام ثبت احوال را در سامانه نوین وان انجام دهم؟",
    content:
      "وارد سایت novin.one شوید، بخش خدمات دولتی را انتخاب کنید، کد ملی و تاریخ تولد را وارد نمایید و دکمه استعلام را بزنید. نتایج در کمتر از یک دقیقه نمایش داده می‌شود، شامل جزئیاتی مانند نام پدر، جنسیت و سریال شناسنامه.",
  },
  {
    id: nanoid(),
    title: "چه اطلاعاتی در خروجی استعلام ثبت احوال نوین وان دریافت می‌کنم؟",
    content:
      "داده‌ها شامل کد ملی، نام، نام خانوادگی، نام پدر، جنسیت، سریال شناسنامه، محل و تاریخ تولد، و وضعیت حیات (زنده یا فوت‌شده) است.",
  },
  {
    id: nanoid(),
    title: "آیا استعلام هویت در نوین وان امن است؟",
    content:
      "بله، سامانه از پروتکل‌های SSL برای رمزنگاری استفاده می‌کند و هیچ اطلاعاتی را ذخیره نمی‌کند. داده‌ها محرمانه باقی می‌مانند و تنها در حساب کاربری شما قابل مشاهده هستند.",
  },
  {
    id: nanoid(),
    title: "تفاوت نوین وان با سایت رسمی ثبت احوال چیست؟",
    content:
      "سایت رسمی ثبت احوال خدمات کلی ارائه می‌دهد، اما نوین وان با رابط کاربری ساده‌تر، سرعت بالاتر و یکپارچگی با خدمات بانکی و حقوقی (مانند استعلام چک) گزینه مکمل و کاربرپسندتری است.",
  },
  {
    id: nanoid(),
    title: "کاربردهای استعلام کد ملی در زندگی روزمره چیست؟",
    content:
      "این سرویس برای افتتاح حساب بانکی، ثبت اسناد حقوقی، خرید خودرو، جلوگیری از کلاهبرداری و حتی استعلام وضعیت نظام وظیفه مفید است. می‌توانید صحت اطلاعات طرف مقابل در قراردادها را سریع بررسی کنید.",
  },
  {
    id: nanoid(),
    title: "اگر تاریخ تولد را اشتباه وارد کنم، چه اتفاقی می‌افتد؟",
    content:
      "در صورت اشتباه در کد ملی یا تاریخ تولد، هیچ نتیجه‌ای دریافت نمی‌کنید. بنابراین، از دقت اطلاعات ورودی مطمئن شوید تا استعلام موفق باشد.",
  },
  {
    id: nanoid(),
    title: "آیا نوین وان خدمات دیگری علاوه بر استعلام هویت ارائه می‌دهد؟",
    content:
      "بله، خدمات دولتی مانند استعلام وضعیت گذرنامه، کد پستی، نظام وظیفه، اعتبارسنجی بانکی و چک‌های برگشتی نیز در نوین وان موجود است.",
  },
  {
    id: nanoid(),
    title: "تاریخچه سازمان ثبت احوال کشور چیست؟",
    content:
      "سازمان از سال ۱۲۹۷ شمسی فعالیت می‌کند و از سال ۱۳۹۶ با دیجیتال‌سازی، خدمات آنلاین مانند استعلام هویتی را گسترش داده است. بیش از ۵۰ میلیون استعلام در سال‌های اخیر انجام شده.",
  },
  {
    id: nanoid(),
    title: "چگونه می‌توانم از نوین وان برای امور حقوقی استفاده کنم؟",
    content:
      "در شکایت‌های قضایی، استعلام کد ملی با نام و وضعیت حیات ضروری است. نوین وان این را با لینک به خدمات حقوقی مانند استعلام ثنا و چک برگشتی یکپارچه کرده تا فرآیند را سریع‌تر کند.",
  },
];

export const bankValidationFaqItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "اعتبارسنجی بانکی چیست و چه تفاوتی با نمره اعتباری دارد؟",
    content:
      "اعتبارسنجی بانکی فرآیندی است که بر اساس داده‌های بانکی مانند چک‌های برگشتی و پرداخت‌های مالیاتی، یک نمره اعتباری عددی (از ۰ تا ۹۰۰) محاسبه می‌کند. رتبه اعتباری (مانند A1 یا E3) بر اساس این نمره تخمین زده می‌شود و هیچ تفاوتی با آن ندارد؛ بلکه مکمل آن است و به ۵ گروه اصلی (A خیلی خوب، B خوب، C متوسط، D ضعیف، E خیلی ضعیف) تقسیم می‌شود. در نوین وان، گزارش کامل هر دو را بدون OTP دریافت می‌کنید.",
  },
  {
    id: nanoid(),
    title: "رتبه اعتباری A1 به چه معناست و چگونه به آن می‌رسم؟",
    content:
      'رتبه A1 بهترین رتبه است و برای نمره‌های ۶۸۰ تا ۹۰۰ اختصاص می‌یابد. این رتبه به معنای "خیلی خوب" است و شانس وام بدون ضامن را افزایش می‌دهد. برای رسیدن به آن، پرداخت به‌موقع اقساط (۴۹% تأثیر) و رفع چک‌های برگشتی را اولویت دهید. کاربران نوین وان با پیگیری ۳-۶ ماهه، میانگین ۱۵۰ واحد افزایش نمره داشته‌اند – استعلام بدون OTP پیگیری را آسان می‌کند.',
  },
  {
    id: nanoid(),
    title: "چگونه نمره اعتباری خود را استعلام کنم؟ مراحل آن چقدر زمان می‌برد؟",
    content:
      "از طریق سامانه نوین وان به سرویس اعتبارسنجی بانکی مراجعه نموده و در کمتر از 3 دقیقه استعلام نمره اعتباری خود را انجام دهید.",
  },
  {
    id: nanoid(),
    title: "عوامل اصلی کاهش نمره اعتباری بانکی کدامند؟",
    content:
      "تاخیر در پرداخت اقساط (۴۹% تأثیر)، چک‌های برگشتی (۲۰%)، بدهی‌های مالیاتی (۱۲%)، استعلام مکرر (بیش از ۳ بار در ماه) و ضمانت برای بدحساب‌ها، نمره را کاهش می‌دهند. مثلاً هر چک برگشتی تا ۲۰۰ واحد کم می‌کند. مثال: یک کاربر با ۲ چک برگشتی از ۶۵۰ به ۴۵۰ افت کرد، اما با رفع سوءاثر بهبود یافت.",
  },
  {
    id: nanoid(),
    title: "هزینه استعلام رتبه اعتباری در نوین وان چقدر است؟",
    content:
      "هزینه استعلام رتبه اعتباری یا اعتبارسنجی بانکی در حال حاضر مبلغ 15هزار تومان است.",
  },
  {
    id: nanoid(),
    title: "رتبه اعتباری E3 یعنی چه و چگونه از آن خارج شوم؟",
    content:
      "E3 بدترین رتبه است (نمره ۰ تا ۴۱۹) و خدمات بانکی مانند وام یا چک را مسدود می‌کند. برای خروج، اقساط را تسویه کنید، سوءاثر چک را در سامانه صیاد رفع نمایید و بدهی‌های مالیاتی را پرداخت کنید. بهبود ۳-۶ ماه زمان می‌برد؛ نوین وان پلن شخصی برایتان می‌سازد.",
  },
  {
    id: nanoid(),
    title: "قوانین جدید اعتبارسنجی در ۱۴۰۴ چه تغییراتی ایجاد کرده؟",
    content:
      "طبق آیین‌نامه اردیبهشت ۱۴۰۴، بانک‌ها موظف به بررسی گزارش نمره اعتباری پیش از وام هستند. مدل AI دقت ۷۰% دارد و معوقات را ۱۵% کاهش داده. برای گروه A (بالای ۷۰۰)، وام تا ۵۰۰ میلیون بدون ضامن ممکن است، اما زیر ۵۰۰ محدودیت ایجاد می‌کند.",
  },
  {
    id: nanoid(),
    title: "چگونه رتبه اعتباری را بهبود ببخشم؟ نکات عملی چیست؟",
    content:
      "پرداخت به‌موقع اقساط، تسویه چک برگشتی، پرداخت قبوض منظم (آب، برق، گاز)، تنوع تسهیلات کوچک (۱۰-۲۰ میلیونی) و کاهش نسبت بدهی به درآمد زیر ۳۰% را رعایت کنید. لیست ۹ رفتار مثبت: از پرداخت اقساط بدون تأخیر تا آموزش مالی. کاربران ما با این روش‌ها ۱۵۰ واحد افزایش داشته‌اند.",
  },
  {
    id: nanoid(),
    title: "مزایای رتبه اعتباری بالا (مانند B2 یا A) چیست؟",
    content:
      "در گروه A (۷۰۰+)، وام بدون ضامن و نرخ بهره ۲-۳% پایین‌تر بگیرید. برای قسط‌بندی خرید، اقساط بدون پیش‌پرداخت ممکن است و سقف چک صیادی تا ۵ برابر گردش حساب افزایش می‌یابد. گروه B (۵۰۰-۷۰۰) نیاز به یک ضامن دارد، اما همچنان قابل اعتماد است.",
  },
  {
    id: nanoid(),
    title: "آیا اعتبارسنجی بانکی امن است و اطلاعاتم محفوظ می‌ماند؟",
    content:
      "بله، در نوین وان با رمزنگاری SSL و رعایت استانداردهای GDPR ایرانی، اطلاعات کد ملی و بانکی‌تان کاملاً امن است. اتصال مستقیم به بانک مرکزی بدون ذخیره داده‌های اضافی انجام می‌شود. برای سؤالات بیشتر، با پشتیبانی تماس بگیرید.",
  },
];

export const motorcycleFinesFaqItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "برای گرفتن خلافی موتور چه اطلاعاتی نیاز دارم؟",
    content:
      "برای استعلام خلافی موتور در سرویس نوین وان، معمولاً شماره پلاک موتور پلاک ملی کافی است. اگر می‌خواهید جزئیات کامل مانند مکان و زمان جرایم را ببینید، کد ملی مالک و شماره موبایل برای احراز هویت لازم است. بدون این اطلاعات، می‌توانید استعلام تجمیعی فقط مجموع مبلغ بگیرید.",
  },
  {
    id: nanoid(),
    title: "آیا استعلام خلافی موتور رایگان است؟",
    content:
      "خیر، جهت استعلام تخلفات موتور سیکلت می‌بایست مبلغ 16,170ت بر اساس نرخ سال 1404 پرداخت نمایید، و پس از آن نتیجه گزارش خلافی موتور با جزئیات کامل را دریافت خواهید نمود.",
  },
  {
    id: nanoid(),
    title: "آیا می‌توان با کد ملی خلافی موتور گرفت؟",
    content:
      "بله، اگر کد ملی مالک موتور را داشته باشید، می‌توانید همراه با پلاک، استعلام دقیق بگیرید. اما بدون پلاک، استعلام ممکن نیست زیرا سیستم بر اساس پلاک موتور کار می‌کند. در نوین وان، این روش برای مالکان اصلی ایده‌آل است.",
  },
  {
    id: nanoid(),
    title: "چطور می‌توانم خلافی موتور را بدون اطلاعات مالک مشاهده کنم؟",
    content:
      "برای استعلام خلافی نیاز به ارائه پلاک و کد ملی مالک دارید که روی کارت موتور وجود دارد و تنها با ارائه پلاک و کد ملی به راحتی استعلام صورت می‌پذیرد.",
  },
  {
    id: nanoid(),
    title: "هزینه استعلام خلافی موتور چقدر است؟",
    content:
      "هزینه استعلام خلافی موتور سیکلت در سال 1404 مبلغ 16,170 تومان است.",
  },
  {
    id: nanoid(),
    title: "چگونه بدون کارت موتور از میزان خلافی مطلع شوم؟",
    content:
      "بدون کارت موتور، با استفاده از پلاک و کد ملی مالک می‌توانید استعلام بگیرید. اگر کارت گم شده، از روش پیامکی (ارسال VIN به ۱۱۰۱۲۰۲۰۲۰) استفاده کنید. همیشه توصیه می‌شود کارت را جایگزین کنید.",
  },
  {
    id: nanoid(),
    title: "روش‌های پرداخت خلافی موتور چیست؟",
    content:
      "پس از استعلام در نوین وان، می‌توانید جرایم را موردی یا یکجا پرداخت کنید. از درگاه بانکی امن استفاده کنید. روش‌های دیگر شامل اپ‌های بانکی، خود پرداز یا سایت پلیس راهور است، اما نوین وان پرداخت آنی و تسویه سریع ارائه می‌دهد.",
  },
  {
    id: nanoid(),
    title: "اگر جریمه اشتباهی ثبت شده، چه کنم؟",
    content:
      "ابتدا جزئیات را در نوین وان چک کنید. اگر اشتباه است، با مدارک (مانند عکس یا شاهد) به نزدیک‌ترین مرکز پلیس +۱۰ مراجعه کنید و اعتراض ثبت کنید. فرآیند اعتراض معمولاً ۱۰ تا ۳۰ روز طول می‌کشد و اگر پذیرفته شود، جریمه حذف می‌شود.\n",
  },
  {
    id: nanoid(),
    title: "آیا خلافی موتور با گذشت زمان افزایش می‌یابد؟",
    content:
      "بله، اگر جرایم پرداخت نشود، ممکن است جریمه دیرکرد (تا ۲ برابر) اضافه شود. همیشه ظرف ۶۰ روز پرداخت کنید تا از افزایش جلوگیری شود. نوین وان هشدارهای به‌موقع می‌دهد.",
  },
];

export const foreignersInquiryFaqItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "استعلام اتباع خارجی چیست؟",
    content:
      "استعلام اتباع خارجی فرآیندی است که طی آن اطلاعات هویتی، اقامتی و حقوقی اتباع غیرایرانی در ایران بررسی می‌شود. در نوین وان، این سرویس با وارد کردن کد فیدا (شناسه فراگیر)، جزئیاتی مانند نام، تاریخ تولد، ملیت و اسناد هویتی را ارائه می‌دهد و بخشی از خدمات دولتی الکترونیک است.",
  },
  {
    id: nanoid(),
    title: "کد فیدا یا کد فراگیر اتباع خارجی چگونه دریافت می‌شود؟",
    content:
      "برای دریافت کد فیدا، به سایت fida.ir مراجعه کنید. مراحل شامل تهیه سیم‌کارت ایرانی، ورود به سایت، انتخاب زبان، ثبت شماره موبایل، وارد کردن اطلاعات پاسپورت، بارگذاری مدارک، عکس سلفی، ضبط ویدیو و دریافت کد پیگیری است. فرآیند معمولاً ۳ تا ۵ روز کاری طول می‌کشد و رایگان یا با هزینه کم است.",
  },
  {
    id: nanoid(),
    title: "چه اطلاعاتی با استعلام کد فیدا در نوین وان به دست می‌آید؟",
    content:
      "با استعلام در نوین وان، اطلاعاتی مانند شناسه فراگیر (فیدا)، نام، نام خانوادگی، نام پدر، تاریخ تولد، نام جد، جنسیت، کشور و شهر محل تولد، ملیت و فهرست اسناد هویتی (مانند پاسپورت یا کارت آمایش با شماره، تاریخ صدور و انقضا) دریافت می‌کنید. گزارش به صورت جامع و PDF ارائه می‌شود.",
  },
  {
    id: nanoid(),
    title: "مراحل استعلام اتباع خارجی در نوین وان چیست؟",
    content:
      'ابتدا به novin.one وارد شوید و با شماره موبایل ثبت‌نام کنید. سپس در بخش خدمات دولتی، "استعلام اتباع خارجی" را انتخاب کنید. کد فیدا را وارد نمایید، هزینه را پرداخت کنید و نتیجه را فوری مشاهده کنید. فرآیند آنلاین و بدون نیاز به مراجعه حضوری است.',
  },
  {
    id: nanoid(),
    title: "هزینه استعلام اتباع خارجی چقدر است؟",
    content:
      "هزینه استعلام در نوین وان مبلغ 15 هزار تومان است. پرداخت آنلاین با کارت بانکی انجام می‌شود و نتیجه آنی است.",
  },
  {
    id: nanoid(),
    title: "آیا استعلام اتباع خارجی آنلاین و فوری است؟",
    content:
      "بله، استعلام در نوین وان کاملاً آنلاین و فوری است. پس از وارد کردن کد فیدا و پرداخت، نتیجه در لحظه نمایش داده می‌شود، بدون نیاز به انتظار طولانی.",
  },
  {
    id: nanoid(),
    title: "مدارک لازم برای دریافت کد فیدا چیست؟",
    content:
      "مدارک شامل گذرنامه معتبر، سیم‌کارت ایرانی فعال، گوشی با دوربین برای سلفی و ویدیو، مدارک اقامتی مانند کارت آمایش یا پروانه کار، عکس پرسنلی و اطلاعات شخصی (نام، تاریخ تولد، ملیت و آدرس) است. همه باید واضح و خوانا باشند.",
  },
  {
    id: nanoid(),
    title: "اگر کد فیدا گم شد، چگونه المثنی بگیرم؟",
    content:
      "برای المثنی، به سایت fida.ir مراجعه کنید و درخواست فراموشی کد دهید. اطلاعات هویتی مانند نام، نام خانوادگی و شماره تماس را وارد کنید. فرآیند آنلاین است و کد جدید ارسال می‌شود.",
  },
  {
    id: nanoid(),
    title: "تفاوت کد فیدا با کارت آمایش چیست؟",
    content:
      "کد فیدا یک شناسه ۱۲ رقمی عمومی برای دسترسی به خدمات بانکی، آموزشی و اداری است، در حالی که کارت آمایش مخصوص اتباع افغان برای اقامت موقت است و گاهی جایگزین کد فیدا می‌شود، اما فیدا جامع‌تر و برای همه ملیت‌ها کاربرد دارد.",
  },
  {
    id: nanoid(),
    title: "آیا گردشگران می‌توانند کد فیدا دریافت کنند؟",
    content:
      "خیر، کد فیدا عمدتاً برای اتباع مقیم بلندمدت یا کسانی که فعالیت اقتصادی/تحصیلی دارند صادر می‌شود. گردشگران با اقامت کوتاه‌مدت معمولاً نیاز به آن ندارند، مگر برای خدمات خاص مانند سیم‌کارت موقت.",
  },
  {
    id: nanoid(),
    title: "چگونه وضعیت اقامت اتباع خارجی را استعلام کنم؟",
    content:
      "با کد فیدا در نوین وان استعلام کنید. اطلاعات اقامتی مانند تاریخ انقضا ویزا، مجوز کار و وضعیت حقوقی نمایش داده می‌شود. برای جزئیات بیشتر، به پلیس مهاجرت مراجعه کنید.",
  },
  {
    id: nanoid(),
    title: "سرویس نوین وان برای کدام ملیت‌ها قابل استفاده است؟",
    content:
      "سرویس برای همه ملیت‌ها مانند افغانستانی، عراقی، پاکستانی و غیره قابل استفاده است، به شرط داشتن کد فیدا یا مدارک معتبر. هیچ محدودیتی بر اساس ملیت وجود ندارد.",
  },
  {
    id: nanoid(),
    title: "امنیت اطلاعات در استعلام اتباع خارجی نوین وان چگونه است؟",
    content:
      "نوین وان از پروتکل‌های امنیتی استاندارد حفاظت داده‌ها استفاده می‌کند. اطلاعات محرمانه است و تنها با احراز هویت (مانند کد OTP) قابل دسترسی می‌باشد و همچنین پس از چند ساعت به طور کامل حذف میشوند.",
  },
  {
    id: nanoid(),
    title: "آیا نیاز به ثبت‌نام در نوین وان برای استعلام دارم؟",
    content:
      "بله، برای استفاده از سرویس، باید با شماره موبایل ثبت‌نام کنید و کد تأیید دریافت کنید. این کار ساده و رایگان است و امنیت را افزایش می‌دهد.",
  },
  {
    id: nanoid(),
    title: "زمان پردازش استعلام کد فیدا چقدر طول می‌کشد؟",
    content:
      "در نوین وان، استعلام فوری و کمتر از ۵ دقیقه است. برای دریافت اولیه کد فیدا از fida.ir، ۳ تا ۵ روز کاری زمان می‌برد.",
  },
  {
    id: nanoid(),
    title: "کاربرد کد فیدا در خدمات بانکی چیست؟",
    content:
      "کد فیدا برای افتتاح حساب، دریافت وام، انتقال پول و سایر خدمات بانکی الزامی است. بانک‌ها مانند ملی یا تجارت آن را برای تأیید هویت اتباع خارجی طلب می‌کنند.",
  },
  {
    id: nanoid(),
    title: "اگر مدارک ناقص باشد، چه اتفاقی می‌افتد؟",
    content:
      "درخواست رد می‌شود و باید از نو شروع کنید. چک‌لیست مدارک را بررسی کنید و اطمینان حاصل کنید همه فیلدهای الزامی پر شده باشند. تاخیر ممکن است تا ۱۰ روز ایجاد شود.",
  },
  {
    id: nanoid(),
    title: "به‌روزرسانی‌های جدید سرویس استعلام اتباع خارجی چیست؟",
    content:
      "در سال ۱۴۰۴ (۲۰۲۵)، ادغام با اپلیکیشن موبایل، پشتیبانی چندزبانه (فارسی، انگلیسی، عربی)، کاهش زمان پردازش به ۲ روز برای موارد فوری و استفاده از هوش مصنوعی برای تشخیص مدارک اضافه شده است.",
  },
  {
    id: nanoid(),
    title: "چگونه با پشتیبانی نوین وان تماس بگیرم؟",
    content:
      "از طریق چت آنلاین، تلفن یا ایمیل ۲۴ ساعته در سایت novin.one تماس بگیرید. همچنین بخش پشتیبانی در پنل کاربری موجود است.",
  },
  {
    id: nanoid(),
    title: " آیا استعلام گروهی برای شرکت‌ها ممکن است؟",
    content:
      "بله، شرکت‌ها می‌توانند استعلام گروهی چندین کد فیدا را انجام دهند، با مجوز قانونی مانند شناسه ملی شرکت. این برای HR و امور اداری مفید است و هزینه آن بر اساس تعداد محاسبه می‌شود.",
  },
];

export const companyMembersInquiryFaqItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "استعلام اعضا شرکت چیست و چرا به آن نیاز دارم؟",
    content:
      "استعلام اعضا شرکت فرآیندی است که فهرست مدیران، اعضای هیئت مدیره و نمایندگان قانونی یک شرکت را بر اساس شناسه ملی نمایش می‌دهد. در نوین.وان، این سرویس به شما کمک می‌کند تا برای سرمایه‌گذاری، عقد قرارداد یا جلوگیری از کلاهبرداری، اطلاعات دقیق دریافت کنید و تصمیمات آگاهانه بگیرید.",
  },
  {
    id: nanoid(),
    title: "چگونه می‌توانم استعلام اعضا شرکت را در نوین.وان انجام دهم؟",
    content:
      "کافی است به صفحه سرویس نوین.وان بروید، شناسه ملی شرکت (۱۱ رقمی) را وارد کنید و دکمه استعلام را بزنید. نتایج در قالب گزارشی کامل شامل نام، سمت، تاریخ شروع و پایان نمایش داده می‌شود – سریع و بدون نیاز به مراجعه حضوری.",
  },
  {
    id: nanoid(),
    title: "چه داده‌هایی در پاسخ استعلام اعضا شرکت نوین وان دریافت می‌کنم؟",
    content:
      "داده‌ها شامل شناسه ملی شرکت، نام کامل اعضا، کد ملی، نوع (حقیقی/حقوقی)، سمت، تاریخ شروع پایان، نماینده سازمان و نوع سازمان است. همه در ساختاری واضح برای استفاده آسان.",
  },
  {
    id: nanoid(),
    title: "آیا سرویس استعلام اعضا شرکت نوین وان رایگان است؟",
    content:
      "خیر، این سرویس نیازمند پرداخت هزینه نیز میباشد و نوین وان از طریق پرداخت هزینه درخواست اطلاعات از مراجع رسمی را انجام می‌دهد و این هزینه به حساب این سازمان‌ها واریز میگردد.",
  },
  {
    id: nanoid(),
    title: "چقدر زمان می‌برد تا نتایج استعلام اعضا شرکت را دریافت کنم؟",
    content:
      "در نوین وان، فرآیند تنها چند ثانیه طول می‌کشد. داده‌ها از منابع معتبر به‌روز می‌شوند، اما اگر تغییرات اخیر ثبت نشده باشد، ممکن است نیاز به بررسی مجدد پس از چند روز داشته باشید.",
  },
  {
    id: nanoid(),
    title:
      "آیا استعلام اعضا شرکت در نوین وان برای شرکت‌های خارجی هم کار می‌کند؟",
    content:
      "خیر، این سرویس محدود به شرکت‌های ثبت‌شده در ایران است. برای شرکت‌های خارجی، از خدمات بین‌المللی دیگر استفاده کنید، اما نوین.وان بر روی قوانین تجارت ایران تمرکز دارد.",
  },
  {
    id: nanoid(),
    title: "چگونه می‌توانم مطمئن شوم داده‌های استعلام اعضا شرکت دقیق هستند؟",
    content:
      "نوین وان داده‌ها را از پایگاه‌های رسمی مانند سازمان ثبت اسناد دریافت می‌کند. همیشه با روزنامه رسمی کشور مقایسه کنید، اما سرویس ما با دقت بالا (بیش از ۹۸%) به‌روز می‌شود تا اعتماد شما را جلب کند.",
  },
  {
    id: nanoid(),
    title: "در صورت خطا در استعلام اعضا شرکت نوین وان چه کنم؟",
    content:
      "اگر کد وضعیت ۲۰۰ دریافت نکردید مثلاً به دلیل اشتباه در شناسه ملی، ورودی را بررسی کنید. اگر مشکل ادامه داشت، با پشتیبانی نوین.وان تماس بگیرید – تیم ما ۲۴/۷ آماده کمک است.",
  },
  {
    id: nanoid(),
    title:
      "آیا می‌توانم استعلام اعضا شرکت را برای چندین شرکت همزمان انجام دهم؟",
    content:
      "بله، این ویژگی برای کسب‌وکارهای بزرگ ایده‌آل است و زمان را تا ۹۰% کاهش می‌دهد.",
  },
  {
    id: nanoid(),
    title: "استعلام اعضا شرکت چگونه به امنیت کسب‌وکار من کمک می‌کند؟",
    content:
      "با بررسی سابقه مدیران و تغییرات سمت‌ها، ریسک‌های حقوقی مانند بدهی‌های پنهان یا کلاهبرداری را شناسایی می‌کنید. نوین وان این اطلاعات را محرمانه نگه می‌دارد و تنها داده‌های عمومی را ارائه می‌دهد تا حریم خصوصی رعایت شود.",
  },
];

export const companyChildrenInquiryFaqItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
];

export const companyLicensesInquiryFaqItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
];

export const companyParentsInquiryFaqItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
];

export const corporateIdentityInquiryFaqItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
];

export const finesPhotoInquiryFaqItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "چگونه عکس خلافی خودرو را آنلاین مشاهده کنیم؟",
    content:
      "به سامانه نوین وان بروید، بخش خدمات خودرو را انتخاب کنید، پلاک را وارد نمایید و پس از احراز هویت با کد ملی و موبایل مالک، عکس جرایم دوربین را مستقیم ببینید.",
  },
  {
    id: nanoid(),
    title: "هزینه استعلام عکس جریمه دوربین چقدر است؟",
    content:
      "در نوین وان هزینه بر اساس تعرفه رسمی پلیس راهور و رقابتی است. معمولاً استعلام پایه همراه با دسترسی به تصاویر در یک گزارش واحد محاسبه می‌شود.",
  },
  {
    id: nanoid(),
    title: "چرا عکس جریمه دوربین نمایش داده نمی‌شود؟",
    content:
      "دلایل رایج شامل تاخیر بارگذاری جریمه جدید (۲۴ تا ۴۸ ساعت)، مشکل کش مرورگر یا احراز هویت ناقص است. صفحه را رفرش کنید یا احراز هویت را تکرار نمایید.",
  },
  {
    id: nanoid(),
    title: "جریمه دوربین بعد از چند روز با عکس قابل مشاهده می‌شود؟",
    content:
      "معمولاً ۲۴ تا ۷۲ ساعت پس از ثبت جریمه، عکس در سامانه راهور بارگذاری می‌شود و در نوین وان بلافاصله قابل مشاهده است.",
  },
  {
    id: nanoid(),
    title: "چگونه به جریمه دوربین با مشاهده عکس اعتراض کنیم؟",
    content:
      "عکس و جزئیات را از نوین وان ذخیره کنید، سپس با مدارک به مراکز اجرائیات پلیس راهور یا پلیس+۱۰ مراجعه نمایید. مهلت اعتراض ۶۰ روز است.",
  },
  {
    id: nanoid(),
    title: " آیا برای دیدن عکس خلافی نیاز به کد ملی و موبایل مالک است؟",
    content:
      "بله، برای دسترسی به تصاویر و جزئیات کامل، احراز هویت با کد ملی و شماره موبایل ثبت‌شده مالک الزامی است.",
  },
  {
    id: nanoid(),
    title: "تفاوت استعلام خلافی تجمیعی و استعلام با عکس چیست؟",
    content:
      "استعلام تجمیعی فقط مبلغ کل را نشان می‌دهد؛ استعلام با عکس شامل تصویر، زمان، مکان و نوع تخلف برای هر جریمه است.",
  },
  {
    id: nanoid(),
    title: "چگونه خلافی خودرو را بعد از دیدن عکس پرداخت کنیم؟",
    content:
      "در نوین وان پس از مشاهده عکس، جرایم را انتخاب کنید و مستقیم از درگاه بانکی پرداخت نمایید. تسویه آنی است.",
  },
  {
    id: nanoid(),
    title: "مهلت پرداخت خلافی برای جلوگیری از دو برابر شدن چقدر است؟",
    content:
      "۶۰ روز از تاریخ ثبت یا ابلاغ جریمه. پس از آن مبلغ دو برابر می‌شود.",
  },
  {
    id: nanoid(),
    title: " آیا می‌توان عکس جریمه دوربین را از موبایل دید؟",
    content:
      "بله، نوین وان کاملاً برای موبایل بهینه است و تصاویر با کیفیت بالا در مرورگر گوشی نمایش داده می‌شوند.",
  },
  {
    id: nanoid(),
    title: "اگر موبایل به نام مالک نباشد، عکس خلافی قابل مشاهده است؟",
    content:
      "برای تصاویر کامل خیر؛ شماره موبایل باید با مالک خودرو تطابق داشته باشد تا احراز هویت موفق شود.",
  },
  {
    id: nanoid(),
    title: "هزینه مشاهده هر عکس جریمه جداگانه چقدر است؟",
    content:
      "در نوین وان مبلغ 3795 به ازای هر تصویر جریمه می‌پرداخت کرد این برای سال 1404 است.",
  },
  {
    id: nanoid(),
    title: " آیا همه جرایم دوربین حتماً عکس دارند؟",
    content:
      "بله، جرایم دوربین‌محور همیشه با تصویر ثبت می‌شوند، اما ممکن است در ساعات اولیه بارگذاری نشده باشد.",
  },
  {
    id: nanoid(),
    title: " چگونه مشکل تار بودن یا عدم لود عکس جریمه را حل کنیم؟",
    content:
      "مرورگر را به کروم تغییر دهید، کش را پاک کنید یا از اینترنت پرسرعت استفاده نمایید. در نوین وان تصاویر بهینه لود می‌شوند.",
  },
  {
    id: nanoid(),
    title: "اعتراض به جریمه دوربین چقدر زمان می‌برد و به کجا مراجعه کنیم؟",
    content:
      "معمولاً چند روز تا چند هفته طول می‌کشد. به دفاتر پلیس+۱۰ یا مراکز اجرائیات پلیس راهور مراجعه کنید.",
  },
  {
    id: nanoid(),
    title: " آیا پرداخت خلافی با عکس تسویه آنی دارد؟",
    content:
      "بله، در نوین وان پس از پرداخت، تسویه فوری در سامانه راهور ثبت می‌شود و رسید دیجیتال دریافت می‌کنید.",
  },
  {
    id: nanoid(),
    title: "چگونه رسید پرداخت خلافی با جزئیات و عکس را دریافت کنیم؟",
    content:
      "پس از پرداخت در نوین وان، رسید کامل با جزئیات جرایم و عکس‌ها به صورت دیجیتال نمایش داده و قابل ذخیره است.",
  },
  {
    id: nanoid(),
    title: "آیا می‌توان خلافی خودرو با عکس را برای پلاک دیگران استعلام کرد؟",
    content:
      "برای مبلغ تجمیعی بله، اما برای مشاهده عکس فقط مالک یا نماینده قانونی با احراز هویت می‌تواند اقدام کند.",
  },
  {
    id: nanoid(),
    title: " به‌روزرسانی جرایم دوربین در سامانه‌ها چقدر طول می‌کشد؟",
    content:
      "در نوین وان داده‌ها لحظه‌ای از راهور ۱۲۰ دریافت می‌شوند و معمولاً کمتر از ۲۴ ساعت تاخیر دارند.",
  },
  {
    id: nanoid(),
    title:
      "بهترین زمان پرداخت خلافی با عکس برای جلوگیری از جریمه اضافی کی است؟",
    content:
      "در ۶۰ روز اول پس از ثبت جریمه، تا از دو برابر شدن مبلغ و هزینه‌های اضافی جلوگیری شود.",
  },
];

export const carDocumentInquiryFaqItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "استعلام کارت خودرو یعنی چه؟",
    content:
      "استعلام کارت خودرو خدمتی آنلاین است که وضعیت فعلی کارت ماشین مانند صدور، چاپ، هوشمند بودن و ارسال آن را نشان می‌دهد. در سامانه نوین وان با وارد کردن پلاک و کد ملی مالک، این اطلاعات را سریع دریافت می‌کنید.",
  },
  {
    id: nanoid(),
    title: "چطور وضعیت کارت ماشین را آنلاین پیگیری کنم؟",
    content:
      "به سامانه نوین وان وارد شوید، سرویس استعلام کارت و سند خودرو را انتخاب کنید، پلاک و کد ملی را وارد نمایید و پس از پرداخت، نتیجه را ببینید. فقط همین دو اطلاعات کافی است.",
  },
  {
    id: nanoid(),
    title: "سند خودرو چاپ شده یا نه؟ چطور بفهمم؟",
    content:
      "در سامانه نوین وان با پلاک و کد ملی استعلام بگیرید. نتیجه دقیقاً نشان می‌دهد وضعیت سند چاپ شده است یا هنوز در مرحله صدور قرار دارد.",
  },
  {
    id: nanoid(),
    title: "بارکد پستی کارت خودرو را از کجا بگیرم؟",
    content:
      "با استعلام در سامانه نوین وان، بارکد پستی کارت و سند نمایش داده می‌شود. بعد می‌توانید در سایت پست رهگیری کنید.",
  },
  {
    id: nanoid(),
    title: "تفاوت کارت هوشمند و کارت قدیمی خودرو چیست؟",
    content:
      "کارت قدیمی کاغذی و ساده بود، اما کارت هوشمند چیپ‌دار، امن‌تر و شامل سوابق کامل مانند معاینه فنی و تصادفات است. کارت هوشمند جعل‌ناپذیر و بهتر است.",
  },
  {
    id: nanoid(),
    title: "چقدر طول می‌کشد تا کارت خودرو به دستم برسد؟",
    content:
      "معمولاً ۱۰ تا ۳۰ روز برای خودروهای کارکرده و تا ۶۰ روز برای صفر. با استعلام نوین وان می‌توانید پیشرفت را دقیق چک کنید.",
  },
  {
    id: nanoid(),
    title: "اگر کارت خودرو برگشتی شد چه کار کنم؟",
    content:
      "آدرس را در سامانه پلیس بروزرسانی کنید و دوباره با استعلام نوین وان بارکد پستی بگیرید تا ارسال مجدد انجام شود.",
  },
  {
    id: nanoid(),
    title: "برای کارت المثنی چه مدارکی لازم است؟",
    content:
      "آگهی مفقودی در روزنامه، کارت ملی، شناسنامه، برگ سبز، رسید خلافی صفر و تأییدیه آدرس. بعد به مرکز تعویض پلاک مراجعه کنید.",
  },
  {
    id: nanoid(),
    title: "برگ سبز واقعاً سند مالکیت است؟",
    content:
      "بله، طبق قوانین جدید، برگ سبز پلیس سند رسمی مالکیت است و برای اکثر معاملات کافی محسوب می‌شود.",
  },
  {
    id: nanoid(),
    title: "چطور اصالت سند خودرو را چک کنم؟",
    content:
      "با استعلام در سامانه نوین وان وضعیت صدور و چاپ را ببینید. برای تصدیق بیشتر، از سایت ثبت اسناد با شناسه سند استفاده کنید.",
  },
  {
    id: nanoid(),
    title: "هزینه استعلام کارت و سند خودرو چقدر است؟",
    content:
      "در سامانه نوین وان هزینه‌ای کم و شفاف دارد که ارزش اطلاعات کامل و آنی را دارد.",
  },
  {
    id: nanoid(),
    title: "چرا کارت هوشمند بهتر از قدیمی است؟",
    content:
      "امنیت بالاتر، جلوگیری از جعل، ذخیره سوابق کامل و دسترسی آسان به اطلاعات برای بیمه و خدمات دیگر.",
  },
  {
    id: nanoid(),
    title: "احراز آدرس برای دریافت کارت چرا مهم است؟",
    content:
      "چون کارت و سند فقط به آدرس تأییدشده پست می‌شود. آدرس اشتباه باعث برگشت مدارک می‌شود.",
  },
  {
    id: nanoid(),
    title: "کارت سوخت و کارت خودرو چه فرقی دارند؟",
    content:
      "کارت خودرو برای مالکیت و رانندگی، کارت سوخت برای سهمیه بنزین. پیگیری هر کدام جداگانه است و کارت خودرو در نوین وان چک می‌شود.",
  },
  {
    id: nanoid(),
    title: "در خرید خودرو دست دوم چه چیزهایی از کارت و سند چک کنم؟",
    content:
      "وضعیت چاپ، تاریخ صدور، نوع کارت (هوشمند یا نه) و تطابق با فروشنده. استعلام نوین وان قبل از معامله ضروری است.",
  },
  {
    id: nanoid(),
    title: "اگر کارت یا سند گم شد چه کنم؟",
    content:
      "آگهی مفقودی بدهید، ۱۰ روز صبر کنید و با مدارک لازم درخواست المثنی کنید. وضعیت جدید را در نوین وان پیگیری نمایید.",
  },
  {
    id: nanoid(),
    title: "زمان صدور سند خودرو چقدر است؟",
    content:
      "معمولاً چند روز تا دو هفته پس از تعویض پلاک. استعلام نوین وان دقیق‌ترین راه برای چک کردن است.",
  },
  {
    id: nanoid(),
    title: "مدارک خودرو را چطور از پست رهگیری کنم؟",
    content:
      "بارکد پستی را از استعلام نوین وان بگیرید و در سایت پست وارد کنید تا وضعیت ارسال را ببینید.",
  },
  {
    id: nanoid(),
    title: "مشکلات رایج در صدور کارت خودرو چیست؟",
    content:
      "تأخیر اداری، آدرس اشتباه یا ناقص بودن اطلاعات. با استعلام منظم در نوین وان زودتر متوجه می‌شوید و حل می‌کنید.",
  },
  {
    id: nanoid(),
    title: "قوانین جدید درباره سند خودرو چیست؟",
    content:
      "برگ سبز سند رسمی است و دیگر الزامی به تنظیم سند در دفترخانه نیست، مگر موارد خاص حقوقی.",
  },
];

export const chequeInquiryFaqItems: FaqItem[] = [
  {
    id: nanoid(),
    title: " استعلام ثبت چک صیادی چیست؟",
    content:
      "استعلام ثبت چک صیادی بررسی دقیق وضعیت ثبت چک در سامانه صیاد بانک مرکزی است. با وارد کردن شناسه ۱۶ رقمی صیادی و کد ملی دارنده چک، می‌توانید ببینید چک ثبت شده یا نه، و جزئیات کامل مثل مبلغ، تاریخ سررسید، نام صادرکننده و گیرنده، و وضعیت تأیید را دریافت کنید. این کار قبل از هر معامله ضروری است تا از اعتبار چک مطمئن شوید.",
  },
  {
    id: nanoid(),
    title: "چگونه بفهمیم چک صیادی ثبت شده یا نه؟",
    content:
      "کافی است شناسه ۱۶ رقمی روی چک را همراه کد ملی دارنده چک وارد کنید. در چند ثانیه نتیجه نشان می‌دهد چک ثبت شده یا ثبت نشده. اگر ثبت شده باشد، تمام جزئیات ثبتی نمایش داده می‌شود؛ در غیر این صورت هشدار می‌دهد که چک اعتبار قانونی ندارد.",
  },
  {
    id: nanoid(),
    title: "چک صیادی به نام چه کسی ثبت شده است؟",
    content:
      "با استعلام ثبت چک صیادی و وارد کردن شناسه صیادی و کد ملی، نام دقیق گیرنده ثبت‌شده نمایش داده می‌شود. این کار کمک می‌کند مطمئن شوید چک به نام شما یا شخص مورد نظر است و مالکیت آن درست است.",
  },
  {
    id: nanoid(),
    title: "چک در انتظار تایید گیرنده یعنی چه؟",
    content:
      "این وضعیت یعنی صادرکننده چک را در سامانه صیاد ثبت کرده، اما گیرنده هنوز آن را تأیید نکرده. تا تأیید انجام نشود، چک کاملاً معتبر نیست و ممکن است در وصول یا انتقال مشکل ایجاد کند.",
  },
  {
    id: nanoid(),
    title: "اگر چک صیادی ثبت نشود چه میشود؟",
    content:
      "چک ثبت‌نشده فاقد اعتبار قانونی است و بانک وجه آن را پرداخت نمی‌کند. پیگیری فقط از راه حقوقی عادی ممکن است که زمان‌بر و پرهزینه است. ریسک کلاهبرداری و ضرر مالی هم بسیار بالاست.",
  },
  {
    id: nanoid(),
    title: "استعلام ثبت چک صیادی با کد ملی چگونه انجام می‌شود؟",
    content:
      "شناسه ۱۶ رقمی صیادی را به همراه کد ملی دارنده چک (گیرنده) وارد کنید. سیستم اطلاعات ثبتی را تطبیق می‌دهد و نتیجه فوری نشان می‌دهد. بدون نیاز به حساب بانکی یا لاگین.",
  },
  {
    id: nanoid(),
    title: "چک صیادی ثبت شده یا نه چطور بررسی کنیم؟",
    content:
      "با ابزار آنلاین استعلام ثبت، شناسه صیادی و کد ملی را وارد کنید. نتیجه بلافاصله مشخص می‌کند چک ثبت شده و جزئیات کامل را نشان می‌دهد یا ثبت نشده و نباید قبول شود.",
  },
  {
    id: nanoid(),
    title: "چه اطلاعاتی در استعلام ثبت چک صیادی نمایش داده می‌شود؟",
    content:
      "مبلغ دقیق، تاریخ سررسید، نام صادرکننده و گیرنده، وضعیت تأیید، مسدودی، ضمانت، نوع چک و شرح صدور (مثل دلیل چک) نمایش داده می‌شود.",
  },
  {
    id: nanoid(),
    title: "تفاوت استعلام ثبت چک صیادی با استعلام وضعیت اعتباری چک چیست؟",
    content:
      "استعلام ثبت روی خود چک تمرکز دارد (واقعی بودن و مالکیت)؛ استعلام اعتباری روی سابقه صادرکننده (چک‌های برگشتی گذشته). هر دو مهم هستند، اما ثبت اولویت دارد.",
  },
  {
    id: nanoid(),
    title: "چک صیادی در انتظار تایید گیرنده چه عواقبی دارد؟",
    content:
      "اگر تأیید نشود، چک قابلیت وصول کامل ندارد، انتقال سخت می‌شود و ممکن است بی‌اعتبار گردد. بهتر است گیرنده بلافاصله تأیید کند.",
  },
  {
    id: nanoid(),
    title: "چگونه مالکیت چک صیادی را با شناسه صیادی بررسی کنیم؟",
    content:
      "شناسه صیادی و کد ملی گیرنده را وارد کنید. نام و کد ملی ثبت‌شده نمایش داده می‌شود و مالکیت تطبیق داده می‌شود.",
  },
  {
    id: nanoid(),
    title: "مدت زمان مجاز برای تایید چک صیادی توسط گیرنده چقدر است؟",
    content:
      "قانون زمان دقیق تعیین نکرده، اما تأخیر ریسک دارد. بهتر است بلافاصله پس از دریافت چک فیزیکی، تأیید انجام شود تا مشکل پیش نیاید.",
  },
  {
    id: nanoid(),
    title: "آیا برای استعلام ثبت چک صیادی نیاز به حساب بانکی است؟",
    content:
      "خیر، کاملاً آنلاین و بدون نیاز به لاگین بانکی یا اپلیکیشن است. فقط شناسه صیادی و کد ملی کافی است.",
  },
  {
    id: nanoid(),
    title: "خطرات دریافت چک ثبت‌نشده در سامانه صیاد چیست؟",
    content:
      "بانک پرداخت نمی‌کند، پیگیری حقوقی سخت است، ریسک جعل بالا می‌رود و ممکن است ضرر مالی مستقیم داشته باشید.",
  },
  {
    id: nanoid(),
    title: "وضعیت مسدودی چک در استعلام ثبت چک صیادی یعنی چه؟",
    content:
      "اگر چک مسدود باشد، به دلایل قانونی (مثل شکایت یا حکم قضایی) وصول نمی‌شود. استعلام این وضعیت را فوراً نشان می‌دهد.",
  },
  {
    id: nanoid(),
    title: "چرا قبل از دریافت چک باید استعلام ثبت صیادی بگیریم؟",
    content:
      "برای جلوگیری از چک جعلی، ثبت‌نشده یا با مالکیت اشتباه. این کار ساده ریسک معامله را به صفر می‌رساند.",
  },
  {
    id: nanoid(),
    title: " چک صیادی هنوز تایید نشده چه مشکلی ایجاد می‌کند؟",
    content:
      "چک نیمه‌تمام است و بانک ممکن است پرداخت نکند. انتقال هم سخت می‌شود و ریسک بی‌اعتباری وجود دارد.",
  },
  {
    id: nanoid(),
    title: "چگونه بفهمیم چک صیادی به نام من ثبت شده یا نه؟",
    content:
      "با وارد کردن شناسه صیادی و کد ملی خودتان، نام گیرنده ثبتی نمایش داده می‌شود و تطبیق می‌دهد.",
  },
  {
    id: nanoid(),
    title: "استعلام اطلاعات ثبتی چک صیاد با شناسه ۱۶ رقمی چطور است؟",
    content:
      "شناسه ۱۶ رقمی را همراه کد ملی وارد کنید. تمام جزئیات ثبتی مثل مبلغ، تاریخ و نام‌ها فوراً نشان داده می‌شود.",
  },
  {
    id: nanoid(),
    title: "بهترین زمان برای بررسی ثبت چک صیادی کی است؟",
    content:
      "قبل از نهایی کردن معامله و تحویل کالا/خدمات. همین لحظه که چک را دریافت کردید، استعلام بگیرید تا ریسک صفر شود.",
  },
];

export const chequeInquiryV2FaqItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "شناسه صیادی چک کجاست؟",
    content:
      "در چک‌های بنفش جدید، شناسه ۱۶ رقمی معمولاً در قسمت بالای سمت چپ برگه، زیر لوگوی بانک و کنار QR کد قرار دارد و با فونت واضح چاپ شده است.",
  },
  {
    id: nanoid(),
    title: "چطور چک صیادی را آنلاین استعلام کنیم؟",
    content:
      "ساده‌ترین روش ورود به سامانه‌هایی مثل نوین وان یا سایت بانک مرکزی است؛ فقط شناسه ۱۶ رقمی را وارد کنید تا نام صادرکننده، شماره حساب و وضعیت اعتباری بلافاصله نمایش داده شود.",
  },
  {
    id: nanoid(),
    title: "وضعیت سفید در استعلام چک صیادی یعنی چه؟",
    content:
      "یعنی صادرکننده هیچ چک برگشتی رفع‌نشده ندارد و خوش‌حساب است؛ بهترین وضعیت برای معامله با ریسک بسیار پایین.",
  },
  {
    id: nanoid(),
    title: "اگر وضعیت چک صیادی قرمز باشد چه کنیم؟",
    content:
      "اصلاً چک را قبول نکنید؛ یعنی بیش از ۱۰ چک برگشتی یا تعهد بالا دارد و حساب احتمالاً مسدود است، ریسک برگشت تقریباً صددرصد.",
  },
  {
    id: nanoid(),
    title: "استعلام چک صیادی رایگان است؟",
    content:
      "بله، در سایت بانک مرکزی کاملاً رایگان است؛ در سامانه نوین وان با هزینه خیلی کم.",
  },
  {
    id: nanoid(),
    title: "آیا می‌توان با کد ملی استعلام چک کرد؟",
    content:
      "خیر، فقط با شناسه ۱۶ رقمی چک امکان‌پذیر است؛ کد ملی برای ثبت یا تایید استفاده می‌شود نه استعلام. ولی جهت تعداد چک برگشتی میتوانید از سرویس استعلام چک برگشتی نوین وان استفاده کنید که فقط کد ملی لازم است.",
  },
  {
    id: nanoid(),
    title: "چک حقوقی چطور استعلام می‌شود و چه تفاوتی دارد؟",
    content:
      "دقیقاً مثل چک حقیقی با شناسه ۱۶ رقمی؛ فقط نام شرکت و نماینده قانونی نمایش داده می‌شود و اعتبار بر اساس سابقه شرکت محاسبه می‌شود.",
  },
  {
    id: nanoid(),
    title: "چک‌های قدیمی غیرصیادی هنوز معتبر هستند؟",
    content:
      "بله، اما فقط در شعبه بانک صادرکننده قابل نقد شدن و فاقد امکان استعلام کامل؛ توصیه می‌شود از چک صیادی استفاده کنید.",
  },
  {
    id: nanoid(),
    title: "اگر نام صادرکننده در استعلام با چک مطابقت نداشت چی؟",
    content:
      "ممکن است خطا، جعل یا سوءاستفاده باشد؛ فوراً با صادرکننده و بانک پیگیری کنید و معامله را متوقف نمایید.",
  },
  {
    id: nanoid(),
    title: "چطور چک جدید را در سامانه صیاد ثبت کنیم؟",
    content:
      "از اپلیکیشن بانکی یا سایت بانک مرکزی، شناسه، مبلغ، تاریخ و اطلاعات گیرنده را وارد و ثبت کنید؛ بدون ثبت چک اعتبار قانونی کامل ندارد.",
  },
  {
    id: nanoid(),
    title: "اگر چک در صیاد ثبت نشده باشد بانک قبول می‌کند؟",
    content:
      "خیر، چک بدون ثبت بی‌اعتبار است و بانک‌ها موظف به رد آن هستند؛ در استعلام هم هشدار می‌دهد.",
  },
  {
    id: nanoid(),
    title: "نوع چک BANS در نتایج یعنی چه؟",
    content: "چک عادی؛ دیگر انواع:  چک الکترونیک چکاد، موردی،تضمینی بین‌بانکی.",
  },
  {
    id: nanoid(),
    title: "چک برگشتی چطور رفع سوءاثر می‌شود؟",
    content:
      "با پرداخت کامل، ارائه لاشه چک، رضایت‌نامه محضری یا حکم قضایی به بانک؛ فرآیند حضوری در شعبه.",
  },
  {
    id: nanoid(),
    title: "پنل سازمانی برای استعلام چک صیادی چه مزیت دارد؟",
    content:
      "برای کسب‌وکارها مناسب است؛ استعلام نامحدود، اتصال API و هزینه کمتر نسبت به استعلام‌های تکی.",
  },
  {
    id: nanoid(),
    title: "استعلام چک صیادی پیامکی چطور است؟",
    content:
      "شناسه را به سرشماره ۷۰۱۷۰۱ بفرستید؛ سریع اما محدود (روزانه ۴ بار) و فقط وضعیت کلی رنگی نشان می‌دهد.",
  },
  {
    id: nanoid(),
    title: "اگر وضعیت زرد باشد چک را قبول کنیم؟",
    content:
      "احتیاط کنید؛ معمولاً یک چک برگشتی دارد، برای مبالغ کم شاید، اما تضمین اضافی بگیرید.",
  },
  {
    id: nanoid(),
    title: "شماره شبا (IBAN) در استعلام چه کاربردی دارد؟",
    content:
      "برای پیگیری قانونی، توقیف حساب یا وصول در صورت برگشت چک ضروری است.",
  },
  {
    id: nanoid(),
    title: "چک الکترونیک (چکاد) چه فرقی با چک کاغذی دارد؟",
    content: "کاملاً دیجیتال، بدون برگه کاغذی، امنیت بالاتر و فرآیند سریع‌تر.",
  },
  {
    id: nanoid(),
    title: "بهترین زمان استعلام چک صیادی کی است؟",
    content:
      "بلافاصله قبل یا همزمان با معامله، وقتی شناسه را دریافت کردید تا ریسک صفر شود.",
  },
];

export const transferChainFaqItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
  {
    id: nanoid(),
    title: "",
    content: "",
  },
];

export const postalTrackingFaqItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "کد رهگیری مرسوله پستی چیست و چند رقمی است؟",
    content:
      "کد رهگیری یک عدد ۲۴ رقمی منحصربه‌فرد است که پس از تحویل مرسوله به پست، روی رسید چاپ می‌شود یا از طریق پیامک ارسال می‌گردد. این کد برای رهگیری آنلاین در نوین وان یا سایت پست ضروری است.",
  },
  {
    id: nanoid(),
    title: "کد رهگیری مرسوله پستی را از کجا پیدا کنم؟",
    content:
      "روی رسید پستی چاپ‌شده، در پیامک فروشنده یا پست، یا در بخش سفارشات حساب کاربری فروشگاه آنلاین (مانند دیجی‌کالا) موجود است.",
  },
  {
    id: nanoid(),
    title: "اگر کد رهگیری فعال نشده باشد چه کنیم؟",
    content:
      "معمولاً چند ساعت تا ۲۴ ساعت پس از پذیرش مرسوله طول می‌کشد تا فعال شود. صبر کنید و مجدداً چک نمایید؛ اگر ادامه داشت، با فروشنده یا اداره پست مبدا تماس بگیرید.",
  },
  {
    id: nanoid(),
    title: "آیا امکان پیگیری مرسوله پستی بدون کد رهگیری وجود دارد؟",
    content:
      "در سیستم استاندارد پست، خیر؛ رهگیری عمدتاً با کد انجام می‌شود. اما با مراجعه حضوری به اداره پست و ارائه کد ملی یا اطلاعات فرستنده/گیرنده، امکان پیگیری محدود وجود دارد.",
  },
  {
    id: nanoid(),
    title: "زمان تحویل مرسوله پیشتاز چقدر است؟",
    content:
      "درون‌شهری کمتر از ۲۴ ساعت، بین‌شهری ۲۴ تا ۷۲ ساعت (در شهرهای بزرگ معمولاً ۴۸ ساعت)؛ این زمان تقریبی است و به عوامل جوی و حجم مرسولات بستگی دارد.",
  },
  {
    id: nanoid(),
    title: "مدت زمان رسیدن مرسوله سفارشی یا ثبت‌شده چقدر است؟",
    content:
      "معمولاً ۳ تا ۷ روز کاری، بسته به فاصله مبدا و مقصد؛ این سرویس اقتصادی‌تر اما کندتر از پیشتاز است.",
  },
  {
    id: nanoid(),
    title: "عوامل اصلی تأخیر در تحویل بسته پستی چیست؟",
    content:
      "حجم بالای مرسولات در ایام پیک، شرایط جوی، اشتباه در آدرس، مشکلات لجستیکی یا تعطیلات رسمی؛ پیگیری لحظه‌ای در نوین وان کمک می‌کند زودتر متوجه شوید.",
  },
  {
    id: nanoid(),
    title: "تفاوت هزینه پست پیشتاز، سفارشی و معمولی چقدر است؟",
    content:
      "پیشتاز گران‌ترین (برای مثال درون‌استانی تا ۱ کیلو حدود ۳۸ هزار تومان)، سفارشی ارزان‌تر (۲۰-۴۰% کمتر) و معمولی کم‌هزینه‌ترین است؛ تعرفه‌ها بر اساس وزن و مسافت محاسبه می‌شود.",
  },
  {
    id: nanoid(),
    title: "آیا رهگیری دقیق‌تر هزینه اضافی دارد؟",
    content:
      "خیر؛ کد رهگیری برای همه انواع مرسولات استاندارد رایگان است و در نوین وان بدون هزینه اضافی ارائه می‌شود.",
  },
  {
    id: nanoid(),
    title: "چگونه مرسوله بین‌المللی را در ایران پیگیری کنیم؟",
    content:
      "برای EMS از سایت ems.post یا ابزارهای جهانی استفاده کنید؛ پس از ورود به ایران، به سیستم داخلی پست منتقل می‌شود و ممکن است کد جدیدی دریافت کنید.",
  },
  {
    id: nanoid(),
    title: "تفاوت رهگیری پست دولتی و شرکت‌های خصوصی چیست؟",
    content:
      "پست دولتی (پیشتاز/سفارشی) با کد ۲۴ رقمی و پوشش گسترده اما گاهی کندتر؛ شرکت‌های خصوصی مانند تیپاکس یا پستکس اغلب لحظه‌ای‌تر اما گران‌تر و محدودتر هستند.",
  },
  {
    id: nanoid(),
    title: "اگر مرسوله مفقود شد چه اقدامی انجام دهیم؟",
    content:
      "ابتدا رهگیری کنید؛ اگر وضعیت «تحویل‌شده» نشان نداد، با پشتیبانی پست (۱۹۳) تماس بگیرید و فرم اعتراض ثبت نمایید.",
  },
  {
    id: nanoid(),
    title: "وضعیت‌های مختلف در رهگیری مرسوله پستی به چه معناست؟",
    content:
      "«در حال پردازش»: ثبت اولیه؛ «خروج از مبدا»: حرکت به سمت مقصد؛ «تحویل‌شده»: رسیده به گیرنده.",
  },
  {
    id: nanoid(),
    title: "آیا می‌توان با شماره موبایل یا کد ملی رهگیری کرد؟",
    content:
      "مستقیماً خیر؛ اما در موارد سازمانی (مانند اسناد ناجا) امکان‌پذیر است. برای مرسولات عادی، کد رهگیری لازم است.",
  },
  {
    id: nanoid(),
    title: "مدت زمان فعال شدن کد رهگیری پس از ارسال چقدر است؟",
    content:
      "معمولاً چند ساعت تا حداکثر ۲۴ ساعت؛ در نوین وان بروزرسانی مداوم انجام می‌شود.",
  },
  {
    id: nanoid(),
    title: "چگونه از تأخیر در رهگیری جلوگیری کنیم؟",
    content:
      "درس دقیق وارد کنید، کد را سریع به گیرنده بدهید و مرتب چک نمایید؛ انتخاب پیشتاز برای مسیرهای طولانی توصیه می‌شود.",
  },
  {
    id: nanoid(),
    title: "اگر مرسوله آسیب دیده باشد چه کنیم؟",
    content:
      "هنگام تحویل بررسی کنید و اگر مشکل داشت، از مأمور پست تأیید کتبی بگیرید؛ سپس با پست پیگیری نمایید.",
  },
  {
    id: nanoid(),
    title:
      "آیا امکان رهگیری مرسولات خارجی با کد بین‌المللی در نوین وان وجود دارد؟",
    content:
      "تمرکز نوین وان روی مرسولات داخلی است؛ برای خارجی‌ها از سایت EMS یا شرکت مربوطه استفاده کنید",
  },
  {
    id: nanoid(),
    title: "بهترین راه پیگیری سریع مرسوله پستی چیست؟",
    content:
      "استفاده از نوین وان با فرم ساده و بروزرسانی لحظه‌ای؛ بدون نیاز به سایت‌های متعدد و با یکپارچگی با سایر استعلام‌ها",
  },
];

export const companyNewspaperFaqItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "استعلام آگهی روزنامه رسمی چیست و چه اطلاعاتی ارائه می‌دهد؟",
    content:
      "استعلام آگهی روزنامه رسمی به معنای دریافت تمام آگهی‌های قانونی منتشرشده برای یک شرکت در روزنامه رسمی جمهوری اسلامی ایران است. این گزارش شامل آگهی تاسیس، تغییرات مرکز اصلی، افزایش یا کاهش سرمایه، جابجایی مدیران، اصلاح اساسنامه، انحلال و سایر تصمیمات هیئت مدیره می‌شود و دقیقاً همان مدرک رسمی است که برای بررسی اعتبار شرکت نیاز دارید.",
  },
  {
    id: nanoid(),
    title: "چگونه آگهی روزنامه رسمی شرکت را با شناسه ملی استعلام بگیریم؟",
    content:
      "کافی است شناسه ملی ۱۱ رقمی شرکت را در فرم بالای همین صفحه وارد کنید و دکمه استعلام را بزنید. سیستم نوین وان بلافاصله گزارش کامل را نمایش می‌دهد — بدون نیاز به جستجوی دستی در سامانه‌های دولتی.",
  },
  {
    id: nanoid(),
    title: "تفاوت سرویس نوین وان با سامانه رسمی rrk.ir چیست؟",
    content:
      "سامانه rrk.ir آگهی‌ها را به صورت پراکنده و بدون ساختار نمایش می‌دهد و اغلب کند است. اما نوین وان تمام آگهی‌ها را در یک صفحه مرتب و خوانا، با امکان دانلود PDF حرفه‌ای و به‌روزرسانی لحظه‌ای ارائه می‌کند و کل فرآیند را در کمتر از یک دقیقه انجام می‌دهد.",
  },
  {
    id: nanoid(),
    title: "آیا گزارش شامل تمام آگهی‌های قدیمی شرکت می‌شود؟",
    content:
      "بله، گزارش کامل نوین وان از روز تاسیس تا آخرین آگهی منتشرشده را پوشش می‌دهد. تمام تغییرات قدیمی به ترتیب زمانی و با متن کامل نمایش داده می‌شوند.",
  },
  {
    id: nanoid(),
    title: "هزینه استعلام آگهی روزنامه رسمی چقدر است؟",
    content:
      "هزینه در نوین وان شفاف و بسیار مقرون‌به‌صرفه است. قیمت دقیق بلافاصله قبل از استعلام نشان داده می‌شود و هیچ هزینه پنهان یا هزینه اضافی وجود ندارد.",
  },
  {
    id: nanoid(),
    title: "آیا داده‌ها مستقیم از منبع رسمی روزنامه رسمی استخراج می‌شوند؟",
    content:
      "بله، تمام اطلاعات مستقیماً از آرشیو رسمی روزنامه جمهوری اسلامی ایران استخراج و به‌روزرسانی می‌شوند. بنابراین گزارش کاملاً معتبر، قابل استناد و مورد قبول تمام ارگان‌های دولتی، بانکی و قضایی است.",
  },
  {
    id: nanoid(),
    title: "استعلام آخرین تغییرات شرکت در روزنامه رسمی چگونه انجام می‌شود؟",
    content:
      "با وارد کردن شناسه ملی در نوین وان، آخرین تغییرات به ترتیب زمانی در بالای گزارش نمایش داده می‌شوند و می‌توانید دقیقاً ببینید چه تغییراتی (مرکز، سرمایه، مدیران و …) در چه تاریخی رخ داده است.",
  },
  {
    id: nanoid(),
    title:
      "گزارش آگهی روزنامه رسمی برای بررسی اعتبار شرکای تجاری چه کاربردی دارد؟",
    content:
      "این گزارش سابقه کامل حقوقی شرکت را نشان می‌دهد: مدیران واقعی، تغییرات سهام، مشکلات احتمالی و پایداری شرکت. بسیاری از مدیران و وکلا پیش از هر قرارداد یا همکاری از این گزارش استفاده می‌کنند تا ریسک را به حداقل برسانند.",
  },
  {
    id: nanoid(),
    title: "آیا امکان دانلود گزارش به صورت PDF وجود دارد؟",
    content:
      "بله، بلافاصله پس از پرداخت، گزارش حرفه‌ای PDF با طراحی مرتب و آماده ارائه قابل دانلود است. این فایل شامل تمام جزئیات و شماره آگهی‌ها بوده و مناسب ارائه به بانک یا دادگاه است.",
  },
  {
    id: nanoid(),
    title: "استعلام آگهی روزنامه رسمی با شماره ثبت شرکت ممکن است؟",
    content:
      "بله، اما بهترین و دقیق‌ترین روش استفاده از شناسه ملی است. در نوین وان حتی اگر فقط شماره ثبت داشته باشید، سیستم به صورت هوشمند جستجو را انجام می‌دهد.",
  },
  {
    id: nanoid(),
    title: "زمان دریافت گزارش استعلام آگهی روزنامه رسمی چقدر طول می‌کشد؟",
    content:
      "کل فرآیند از ورود شناسه ملی تا نمایش گزارش و دانلود PDF کمتر از ۶۰ ثانیه طول می‌کشد.",
  },
  {
    id: nanoid(),
    title: "آیا استعلام آگهی روزنامه رسمی برای امور بانکی الزامی است؟",
    content:
      "بله، اکثر بانک‌ها برای اعطای تسهیلات، گشایش اعتبار یا سایر خدمات، گزارش رسمی آگهی‌های روزنامه را درخواست می‌کنند. گزارش PDF نوین وان دقیقاً همین نیاز را به بهترین شکل برآورده می‌کند.",
  },
  {
    id: nanoid(),
    title: "تفاوت روزنامه رسمی و روزنامه کثیرالانتشار چیست؟",
    content:
      "روزنامه رسمی مرجع قانونی و رسمی کشور برای آگهی‌های الزامی شرکت‌هاست و برای ارائه به ارگان‌های دولتی ضروری است. روزنامه کثیرالانتشار فقط برای اطلاع‌رسانی عمومی داخلی شرکت استفاده می‌شود و ارزش قانونی رسمی ندارد.",
  },
  {
    id: nanoid(),
    title: "چگونه آگهی تاسیس شرکت را در روزنامه رسمی پیدا کنیم؟",
    content:
      "با استعلام شناسه ملی در نوین وان، آگهی تاسیس همیشه به عنوان اولین آگهی گزارش نمایش داده می‌شود و جزئیات کامل موضوع فعالیت، سرمایه اولیه و مدیران را شامل می‌شود.",
  },
  {
    id: nanoid(),
    title: "برای استعلام آگهی روزنامه رسمی آیا نیاز به ثبت‌نام داریم؟",
    content:
      "خیر. در نوین وان هیچ ثبت‌نام یا ورود کاربری لازم نیست. فقط شناسه ملی را وارد کنید و گزارش را دریافت کنید.",
  },
  {
    id: nanoid(),
    title: "استعلام آگهی روزنامه رسمی شرکت‌های منحل شده چگونه است؟",
    content:
      "بله، گزارش شامل آگهی انحلال و تمام مراحل پیش از آن نیز می‌شود و دقیقاً مشخص می‌کند شرکت در چه تاریخی منحل شده است.",
  },
  {
    id: nanoid(),
    title: "مزایای استفاده از نوین وان برای استعلام روزنامه رسمی چیست؟",
    content:
      "سرعت بالا، نمایش مرتب تمام آگهی‌ها در یک صفحه، دانلود PDF حرفه‌ای، عدم نیاز به ثبت‌نام، به‌روزرسانی لحظه‌ای و صرفه‌جویی قابل توجه در زمان و هزینه نسبت به روش‌های سنتی.",
  },
  {
    id: nanoid(),
    title: "استعلام آگهی روزنامه رسمی در مناقصه‌ها چه اهمیتی دارد؟",
    content:
      "در مناقصه‌ها و مزایدات دولتی، ارائه گزارش آگهی روزنامه رسمی برای اثبات وجود قانونی، عدم انحلال و وضعیت مدیران الزامی است. گزارش نوین وان این مدرک را به صورت آماده و حرفه‌ای فراهم می‌کند.",
  },
  {
    id: nanoid(),
    title:
      "آیا گزارش نوین وان برای ارائه به دادگاه و ارگان‌های دولتی معتبر است؟",
    content:
      "بله، چون مستقیماً از منبع رسمی استخراج شده، کاملاً معتبر و قابل استناد در دادگاه‌ها، بانک‌ها و تمام دستگاه‌های دولتی است.",
  },
  {
    id: nanoid(),
    title: "اگر شناسه ملی شرکت را ندارم چگونه استعلام آگهی روزنامه رسمی بگیرم؟",
    content:
      "در نوین وان حتی با نام شرکت یا شماره ثبت نیز می‌توانید جستجو کنید. سیستم هوشمند اطلاعات را پیدا کرده و گزارش را ارائه می‌دهد.",
  },
];

export const electricityBillFaqItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "چطور قبض برق را آنلاین استعلام کنم؟",
    content:
      "با وارد کردن شناسه قبض یا شماره اشتراک برق در نوین وان، مبلغ قابل پرداخت، وضعیت بدهی و مهلت پرداخت قبض برق در کمتر از یک دقیقه نمایش داده می‌شود.",
  },
  {
    id: nanoid(),
    title: "شناسه قبض برق را از کجا پیدا کنم؟",
    content:
      "شناسه قبض برق روی پیامک‌های اطلاع‌رسانی شرکت توزیع برق موجود است. همچنین با ارسال شماره بدنه کنتور به سرشماره ۵۰۰۰۴۰۱۲۱ یا تماس با سامانه ۱۵۲۱ می‌توانید شناسه را دریافت کنید.",
  },
  {
    id: nanoid(),
    title: "آیا برای پرداخت قبض برق به قبض کاغذی نیاز دارم؟",
    content:
      "خیر. از سال ۱۳۹۸ قبض کاغذی برق حذف شده است. فقط به شناسه قبض یا شماره اشتراک نیاز دارید که از طریق پیامک یا سامانه‌های برق قابل دریافت است.",
  },
  {
    id: nanoid(),
    title: "مهلت پرداخت قبض برق چقدر است؟",
    content:
      "مهلت پرداخت قبض برق در هر دوره روی قبض درج می‌شود و بسته به منطقه متفاوت است. عدم پرداخت در موعد مقرر منجر به جریمه دیرکرد و در صورت تداوم، قطع برق خواهد شد.",
  },
  {
    id: nanoid(),
    title: "پس از پرداخت قبض برق چه زمانی بدهی صفر می‌شود؟",
    content:
      "تأیید پرداخت توسط شرکت توزیع برق معمولاً ۲۴ تا ۷۲ ساعت پس از پرداخت انجام می‌شود. صفر نشدن فوری بدهی طبیعی است و نیاز به پرداخت مجدد ندارد.",
  },
  {
    id: nanoid(),
    title: "آیا می‌توانم قبض برق چند دوره معوقه را یکجا پرداخت کنم؟",
    content:
      "بله. نوین وان مجموع بدهی‌های معوقه دوره‌های قبلی را به همراه قبض جاری نمایش می‌دهد و امکان تسویه یکجا یا جداگانه را فراهم می‌کند.",
  },
  {
    id: nanoid(),
    title: "اگر تراکنش پرداخت قبض برق ناموفق باشد چه اتفاقی می‌افتد؟",
    content:
      "در صورت ناموفق بودن تراکنش، مبلغ کسرشده ظرف ۷۲ ساعت کاری به حساب بازمی‌گردد. در صورت عدم برگشت با پشتیبانی نوین وان تماس بگیرید.",
  },
  {
    id: nanoid(),
    title: "اگر قبض برق را دو بار پرداخت کنم چه می‌شود؟",
    content:
      "مبلغ اضافه به‌عنوان بستانکاری در سامانه برق ثبت و از قبض دوره بعد کسر می‌شود. برای پیگیری با رسید پرداخت به شرکت توزیع برق منطقه خود مراجعه کنید.",
  },
  {
    id: nanoid(),
    title: "آیا مستأجر می‌تواند قبض برق ملک استیجاری را پرداخت کند؟",
    content:
      "بله. با داشتن شناسه قبض یا شماره اشتراک برق واحد، هر شخصی اعم از مالک یا مستأجر می‌تواند قبض برق آن واحد را در نوین وان استعلام و پرداخت کند.",
  },
  {
    id: nanoid(),
    title: "پیامک قبض برق به شماره مستأجر قبلی می‌رود، چطور تغییر دهم؟",
    content:
      "برای تغییر شماره دریافت پیامک قبض برق باید به همراه مدارک ملک به اداره برق منطقه مراجعه کنید یا از طریق سامانه برق‌من درخواست ثبت کنید.",
  },
  {
    id: nanoid(),
    title: "آیا پرداخت قبض برق در نوین وان هزینه اضافه دارد؟",
    content:
      "خیر. سرویس استعلام و پرداخت قبض برق در نوین وان بدون کارمزد اضافه است و شما فقط مبلغ خود قبض را پرداخت می‌کنید.",
  },
  {
    id: nanoid(),
    title: "آیا پس از پرداخت قبض برق رسید دریافت می‌کنم؟",
    content:
      "بله. پس از هر پرداخت موفق، رسید الکترونیکی شامل شماره پیگیری، مبلغ، تاریخ و ساعت تراکنش صادر می‌شود که قابل دانلود و ارائه به مراجع مربوطه است.",
  },
  {
    id: nanoid(),
    title: "قبض برق این دوره نیامده، چطور استعلام کنم؟",
    content:
      "با شماره اشتراک برق یا شماره بدنه کنتور می‌توانید بدون دریافت پیامک قبض، استعلام را در نوین وان انجام دهید. شماره بدنه کنتور روی صفحه کنتور برق حک شده است.",
  },
  {
    id: nanoid(),
    title: "شماره اشتراک برق را از کجا پیدا کنم؟",
    content:
      "شماره اشتراک برق روی قبوض کاغذی قدیمی، پیامک‌های شرکت توزیع برق و سامانه‌های مربوطه قابل مشاهده است. همچنین با تماس با سامانه ۱۵۲۱ می‌توانید آن را دریافت کنید.",
  },
  {
    id: nanoid(),
    title: "قبض برق هر چند وقت یک بار صادر می‌شود؟",
    content:
      "قبض برق معمولاً هر دو ماه یک‌بار صادر می‌شود؛ یعنی در طول یک سال حدود ۶ قبض دریافت می‌کنید. در صورت عدم قرائت کنتور، قبض برآوردی صادر و در دوره بعد تسویه می‌شود.",
  },
  {
    id: nanoid(),
    title: "آیا پرداخت قبض برق در نوین وان امن است؟",
    content:
      "بله. تمام پرداخت‌ها از طریق درگاه‌های بانکی مورد تأیید بانک مرکزی انجام می‌شود. اطلاعات کارت بانکی ذخیره نمی‌شود و ارتباط با SSL کامل رمزگذاری شده است.",
  },
  {
    id: nanoid(),
    title: "اگر قبض برق اشتباه صادر شده باشد چطور اعتراض کنم؟",
    content:
      "از طریق سامانه ۱۵۲۱ یا مراجعه حضوری به اداره برق منطقه با رسید پرداخت و عکس کنتور، درخواست بازبینی مصرف و قرائت مجدد ثبت کنید.",
  },
  {
    id: nanoid(),
    title: "آیا می‌توانم قبض برق را با موبایل پرداخت کنم؟",
    content:
      "بله. نوین وان کاملاً ریسپانسیو طراحی شده و روی تمام مرورگرهای موبایل و تبلت بدون نیاز به نصب اپلیکیشن جداگانه قابل استفاده است.",
  },
  {
    id: nanoid(),
    title: "آیا امکان تقسیط بدهی قبض برق وجود دارد؟",
    content:
      "تقسیط بدهی قبض برق فقط از طریق مراجعه حضوری به اداره برق منطقه امکان‌پذیر است و برخلاف قبض آب و گاز، امکان تقسیط آنلاین فعلاً وجود ندارد. نوین وان مبلغ کامل بدهی جاری را برای پرداخت یکجا نمایش می‌دهد.",
  },
  {
    id: nanoid(),
    title: "تفاوت شناسه قبض و شناسه پرداخت برق چیست؟",
    content:
      "شناسه قبض برق یک کد ثابت اختصاصی هر اشتراک است که تغییر نمی‌کند. شناسه پرداخت در هر دوره با صدور قبض جدید تغییر می‌کند و برای انجام تراکنش پرداخت استفاده می‌شود. هر دو در پیامک قبض ارسال می‌شوند.",
  },
];

export const electricityBillInfoFaqItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "قبض برق با جزئیات دقیقاً چه اطلاعاتی بیشتر از قبض معمولی دارد؟",
    content:
      "در قبض معمولی فقط مبلغ نهایی نمایش داده می‌شود. نسخه جزئیات شامل نام و نشانی مشترک، شماره اشتراک، تاریخ قرائت کنتور، حجم مصرف به کیلووات‌ساعت، پله تعرفه پلکانی، هزینه انرژی، آبونمان، هزینه سوخت نیروگاه، عوارض برق، بیمه مشترکان، بیمه حوادث همگانی، مالیات ارزش افزوده، تعدیل دیرکرد و بدهی یا بستانکاری دوره قبل است.",
  },
  {
    id: nanoid(),
    title: "تعرفه پلکانی برق چیست و چطور روی مبلغ قبض تأثیر می‌گذارد؟",
    content:
      "در سیستم پلکانی، هرچه مصرف بیشتر باشد نرخ هر کیلووات‌ساعت هم گران‌تر می‌شود. تا سقف الگوی مصرف نرخ یارانه‌ای اعمال می‌شود، از الگو تا ۱.۵ برابر نرخ بالاتری دارد، از ۱.۵ تا ۲.۵ برابر الگو نرخ بیشتری، و بیش از ۲.۵ برابر الگو بالاترین نرخ محاسبه می‌شود. در جزئیات قبض می‌بینید مصرفتان دقیقاً در کدام پله قرار گرفته.",
  },
  {
    id: nanoid(),
    title: "الگوی مصرف برق خانگی در تهران و سایر شهرها چقدر است؟",
    content:
      "الگوی مصرف بر اساس منطقه جغرافیایی و فصل تعیین می‌شود. برای مشترکان تهران در ماه‌های غیرگرم (مهر تا اردیبهشت) الگوی مصرف ۲۰۰ کیلووات‌ساعت ماهانه و در ماه‌های گرم بالاتر است. مصرف زیر الگو از پایین‌ترین نرخ یارانه‌ای برخوردار می‌شود.",
  },
  {
    id: nanoid(),
    title: "عوارض برق در قبض چیست و به کجا می‌رود؟",
    content:
      "عوارض برق معادل ۱۰ درصد هزینه انرژی مصرفی است که برای توسعه برق روستایی و حمایت از انرژی‌های تجدیدپذیر اخذ می‌شود. این رقم در قبض ساده پنهان است اما در نسخه جزئیات نوین وان به‌عنوان یک آیتم مستقل درج می‌شود.",
  },
  {
    id: nanoid(),
    title: "هزینه سوخت نیروگاهی در قبض برق چیست؟",
    content:
      "هزینه سوخت نیروگاه بخشی از صورت‌حساب برق است که بر اساس نوع سوخت مصرفی نیروگاه‌ها (گاز، مازوت یا گازوئیل) و میزان مصرف مشترک محاسبه می‌شود. این هزینه در قبض معمولی دیده نمی‌شود اما در نسخه با جزئیات به‌صراحت درج است.",
  },
  {
    id: nanoid(),
    title: "بیمه مشترکان و بیمه حوادث همگانی در قبض برق چیستند؟",
    content:
      "بیمه مشترکان برای جبران خسارت ناشی از حوادثی مثل آتش‌سوزی یا انفجار تجهیزات برقی اخذ می‌شود. بیمه حوادث همگانی نیز برای پوشش بلایای طبیعی مثل زلزله و سیل است. هر دو مبالغ بسیار ناچیزی هستند اما در جزئیات قبض به تفکیک نمایش داده می‌شوند.",
  },
  {
    id: nanoid(),
    title: "مالیات ارزش افزوده قبض برق چند درصد است؟",
    content:
      "بر اساس قانون دائمی ارزش افزوده، ۹ درصد از مجموع هزینه انرژی و آبونمان به‌عنوان مالیات ارزش افزوده محاسبه می‌شود. این رقم در قبض با جزئیات به‌صورت یک آیتم مجزا نمایش داده می‌شود و قابل بررسی و پیگیری است.",
  },
  {
    id: nanoid(),
    title: "تعدیل دیرکرد یا تشویق خوش‌حسابی در قبض برق چیست؟",
    content:
      "اگر قبض قبلی دیر پرداخت شده باشد، جریمه دیرکرد به قبض جاری اضافه می‌شود. برعکس، پرداخت در موعد مقرر می‌تواند تخفیف خوش‌حسابی در پی داشته باشد. این آیتم در نسخه با جزئیات به‌صورت مجزا قابل مشاهده است.",
  },
  {
    id: nanoid(),
    title: "چرا قبض برق این دوره ناگهان چند برابر شده؟",
    content:
      "دلایل اصلی عبارتند از: جهش مصرف به پله بالاتر تعرفه، صدور قبض تجمیعی دو دوره، اضافه شدن بدهی معوقه دوره قبل، اعمال جریمه دیرکرد، یا تغییر تعرفه در سال ۱۴۰۴. با دیدن جزئیات کامل در نوین وان دقیقاً می‌بینید کدام آیتم مسبب افزایش بوده است.",
  },
  {
    id: nanoid(),
    title: "آبونمان قبض برق بابت چه چیزی گرفته می‌شود؟",
    content:
      "آبونمان هزینه ثابت خدماتی است که بابت قرائت کنتور، نگهداری شبکه توزیع برق و ارائه خدمات مشترکین اخذ می‌شود. این هزینه صرف‌نظر از میزان مصرف هر دوره روی قبض درج می‌شود.",
  },
  {
    id: nanoid(),
    title: "کنتور هوشمند برق چه اطلاعات اضافه‌ای در جزئیات قبض نشان می‌دهد؟",
    content:
      "مشترکانی که کنتور هوشمند دارند می‌توانند مصرف برق خود را در ساعات کم‌باری، میان‌باری و اوج‌باری به‌صورت جداگانه ببینند. این تفکیک زمانی امکان مدیریت هوشمندتر مصرف و کاهش هدفمند قبض را فراهم می‌کند.",
  },
  {
    id: nanoid(),
    title: "چطور بفهمم قبض برقم واقعی است یا برآوردی؟",
    content:
      "در صورت‌حساب با جزئیات، نوع صدور قبض (واقعی یا برآوردی) و تاریخ قرائت کنتور به‌صراحت درج می‌شود. قبض برآوردی بر اساس میانگین مصرف دوره‌های قبلی صادر شده و با قرائت واقعی دوره بعد تسویه می‌شود که گاهی منجر به قبض بالاتر می‌شود.",
  },
  {
    id: nanoid(),
    title: "تفاوت شماره اشتراک و شماره بدنه کنتور چیست؟",
    content:
      "شماره اشتراک کد اختصاصی مشترک است که در سامانه‌های برق ثبت شده. شماره بدنه کنتور روی کنتور فیزیکی حک شده و برای دریافت شناسه قبض از طریق پیامک به سرشماره ۱۰۰۰۱۵۲۱ استفاده می‌شود. برای استعلام در نوین وان هر دو کارایی دارند.",
  },
  {
    id: nanoid(),
    title: "آیا می‌توانم با جزئیات قبض برق به شرکت توزیع اعتراض کنم؟",
    content:
      "بله. داده‌های نمایش‌داده‌شده در نوین وان مستقیماً از سامانه رسمی شرکت توزیع برق دریافت می‌شود. این اطلاعات برای ثبت اعتراض از طریق سامانه ۱۵۲۱ یا مراجعه به دفاتر اداره برق قابل استناد است.",
  },
  {
    id: nanoid(),
    title: "قبض برق واحدهای تجاری و صنعتی جزئیات متفاوتی دارند؟",
    content:
      "بله. مشترکان غیرخانگی دارای تعرفه‌های متفاوت، ضرایب اوج‌باری، هزینه دیماند و سازوکار اندازه‌گیری چندزمانه هستند. نوین وان جزئیات قبض هر نوع اشتراکی را مطابق نوع کاربری آن نمایش می‌دهد.",
  },
  {
    id: nanoid(),
    title: "بدهی معوقه قبض برق چیست و چرا روی این دوره آمده؟",
    content:
      "بدهی معوقه مبلغ پرداخت‌نشده دوره‌های قبلی است که به قبض جاری اضافه می‌شود. تأخیر سازمان برق در ثبت پرداخت (گاهی تا ۷۲ ساعت) می‌تواند باعث نمایش موقت این رقم شود. در جزئیات قبض مبلغ معوقه جداگانه مشخص است.",
  },
  {
    id: nanoid(),
    title: "قبض برق واحد استیجاری را هم می‌توانم با جزئیات استعلام کنم؟",
    content:
      "بله. با داشتن شماره اشتراک یا شناسه قبض واحد، صرف‌نظر از مالک یا مستأجر بودن، می‌توانید قبض برق هر واحدی را با جزئیات کامل استعلام کنید.",
  },
  {
    id: nanoid(),
    title: "آیا جزئیات قبض برق دوره‌های قبلی هم قابل مشاهده است؟",
    content:
      "سرویس قبض برق با جزئیات نوین وان صورت‌حساب دوره جاری را نمایش می‌دهد. برای مشاهده سوابق و دوره‌های قبلی از سرویس تاریخچه قبض نوین وان استفاده کنید که فهرست کامل قبوض گذشته را نشان می‌دهد.",
  },
  {
    id: nanoid(),
    title: "چطور با کمک جزئیات قبض برق، مصرفم را کاهش دهم؟",
    content:
      "با دیدن دقیق پله تعرفه‌ای و حجم مصرف در جزئیات، می‌فهمید چند کیلووات‌ساعت تا پله ارزان‌تر فاصله دارید. جابجایی مصرف وسایل پرمصرف مثل کولر و ماشین لباسشویی به ساعات کم‌باری می‌تواند قبض را به‌طور قابل‌توجهی کاهش دهد.",
  },
  {
    id: nanoid(),
    title: "قبض برق در تابستان چرا خیلی بیشتر از زمستان است؟",
    content:
      "در ماه‌های گرم، الگوی مصرف بالاتر تعیین می‌شود اما استفاده از کولر و سایر وسایل سرمایشی مصرف را به‌شدت افزایش می‌دهد و کاربر را به پله‌های بالاتر تعرفه می‌رساند. همچنین تعرفه تابستانه در برخی مناطق تا ۲۰ درصد بالاتر از زمستان است. در جزئیات قبض دقیقاً می‌بینید کدام پله هزینه اصلی را ساخته.",
  },
];

export const gasBillInfoFaqItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "قبض گاز با جزئیات دقیقاً چه اطلاعاتی بیشتر از قبض معمولی دارد؟",
    content:
      "در قبض معمولی فقط مبلغ نهایی نمایش داده می‌شود. نسخه با جزئیات شامل نام و نشانی مشترک، شماره اشتراک، شماره سریال کنتور، تاریخ قرائت کنتور، حجم مصرف به مترمکعب، پله تعرفه پلکانی، اقلیم جغرافیایی، گازبهای محاسبه‌شده، عوارض ثابت ماهانه، مالیات ارزش افزوده، پاداش صرفه‌جویی (در صورت شمول) و بدهی معوقه دوره‌های قبل است.",
  },
  {
    id: nanoid(),
    title: "تعرفه پلکانی جدید گاز از مهر ۱۴۰۴ چگونه کار می‌کند؟",
    content:
      "در نظام جدید، مصرف هر مشترک با میانگین مصرف همان ماه در ۵ سال گذشته مقایسه می‌شود و بر این اساس در یکی از ۴ پله قرار می‌گیرد. مصرف کمتر از ۵۰ درصد میانگین (پله اول)، ۵۰ تا ۷۵ درصد (پله دوم)، ۷۵ تا ۹۵ درصد (پله سوم) و بیش از ۹۵ درصد (پله چهارم) که پرمصرف‌ها با نرخ نزدیک به صادراتی محاسبه می‌شوند.",
  },
  {
    id: nanoid(),
    title: "اقلیم‌بندی گاز یعنی چه و چه تأثیری روی قبض دارد؟",
    content:
      "کشور به ۵ اقلیم بر اساس شرایط آب‌وهوایی تقسیم شده است. در اقلیم ۱ که سردترین مناطق کشور است، سقف مصرف در پله اول ۵۰۰ مترمکعب است، در اقلیم ۲ این سقف ۴۵۰ و در اقلیم ۳ به ۴۰۰ مترمکعب می‌رسد. اقلیم مشترک مستقیماً روی الگوی مصرف مجاز و نرخ تعرفه تأثیر می‌گذارد.",
  },
  {
    id: nanoid(),
    title: "پاداش صرفه‌جویی گاز چیست و چطور محاسبه می‌شود؟",
    content:
      "مشترکانی که در ماه‌های سرد سال (۱۶ آبان تا ۱۵ اسفند) مصرف‌شان نسبت به دوره مشابه سال قبل کاهش داشته باشد، به ازای هر یک درصد کاهش، سه درصد تخفیف در گازبهای صورت‌حساب دریافت می‌کنند. سقف این تخفیف ۴۵ درصد است. مشترکانی که مصرف‌شان حداکثر ۷۰ درصد الگوی متعارف باشد، گازبهای آن‌ها ۱۰۰ درصد رایگان خواهد بود.",
  },
  {
    id: nanoid(),
    title: "گازبها در قبض یعنی چه و چطور محاسبه می‌شود؟",
    content:
      "گازبها هزینه اصلی مصرف گاز است که بر اساس حجم مصرف به مترمکعب و تعرفه پله‌ای محاسبه می‌شود. تعرفه به صورت پلکانی اعمال می‌شود یعنی هر پله فقط به مصرف مازاد بر پله قبلی تعلق می‌گیرد و کل مصرف با یک نرخ محاسبه نمی‌شود.",
  },
  {
    id: nanoid(),
    title: "عوارض ثابت ماهانه قبض گاز چیست؟",
    content:
      "عوارض ثابت ماهانه مبلغ مشخصی بین ۴۰۰۰ تا ۱۰۰۰۰ ریال است که صرف‌نظر از میزان مصرف، هر دوره به قبض اضافه می‌شود. این مبلغ در قبض ساده دیده نمی‌شود اما در نسخه جزئیات نوین وان به‌عنوان یک آیتم مستقل نمایش داده می‌شود.",
  },
  {
    id: nanoid(),
    title: "مالیات ارزش افزوده قبض گاز چند درصد است؟",
    content:
      "بر اساس قانون دائمی ارزش افزوده، ۹ درصد از مجموع گازبها و عوارض ثابت به‌عنوان مالیات ارزش افزوده محاسبه می‌شود. در جزئیات قبض نوین وان این رقم به‌عنوان یک آیتم مجزا نمایش داده و قابل بررسی است.",
  },
  {
    id: nanoid(),
    title: "چرا قبض گاز این دوره ناگهان چند برابر شده؟",
    content:
      "دلایل اصلی عبارتند از: جهش مصرف به پله بالاتر تعرفه (به‌خصوص در ماه‌های بسیار سرد)، صدور قبض تجمیعی دو دوره، اضافه شدن بدهی معوقه، حذف پاداش صرفه‌جویی به دلیل افزایش مصرف، یا تغییر اقلیم‌بندی. در جزئیات قبض نوین وان دقیقاً می‌بینید کدام آیتم مسبب افزایش بوده.",
  },
  {
    id: nanoid(),
    title: "مبنای محاسبه پله گاز میانگین ۵ سال گذشته یعنی چه؟",
    content:
      "شرکت ملی گاز برای هر مشترک، میانگین مصرف همان ماه در ۵ سال اخیر را محاسبه می‌کند و مصرف فعلی را با آن مقایسه می‌کند. اگر مصرف امسال کمتر از ۵۰ درصد این میانگین باشد در پله اول (ارزان‌ترین نرخ) و اگر بیش از ۹۵ درصد باشد در پله چهارم (گران‌ترین نرخ) قرار می‌گیرد.",
  },
  {
    id: nanoid(),
    title: "شماره اشتراک گاز را از کجا پیدا کنم؟",
    content:
      "شماره اشتراک گاز یک کد ۱۲ رقمی است که روی قبوض کاغذی قبلی، قراردادنامه گاز و پیامک‌های اطلاع‌رسانی شرکت گاز درج شده است. همچنین می‌توانید از طریق سامانه billing.nigc.ir یا تماس با اورژانس گاز ۱۹۴ آن را دریافت کنید.",
  },
  {
    id: nanoid(),
    title: "آیا می‌توانم بدون شناسه قبض، فقط با شماره اشتراک گاز استعلام کنم؟",
    content:
      "بله. نوین وان از هر دو روش ورودی (شناسه قبض ۱۳ رقمی و شماره اشتراک ۱۲ رقمی) پشتیبانی می‌کند. شماره اشتراک روی کنتور گاز و مدارک اشتراک شما موجود است و برای استعلام کافی است.",
  },
  {
    id: nanoid(),
    title: "قبض گاز چه زمانی صادر می‌شود و دوره آن چقدر است؟",
    content:
      "قبض گاز معمولاً هر دو ماه یک‌بار صادر می‌شود. در ماه‌های سرد سال (آبان تا فروردین) دوره قبض ممکن است ماهانه باشد. تاریخ قرائت کنتور و دوره پوشش قبض در جزئیات صورت‌حساب به‌صراحت درج می‌شود.",
  },
  {
    id: nanoid(),
    title: "چطور بفهمم قبضم واقعی است یا برآوردی؟",
    content:
      "در صورت‌حساب با جزئیات، نوع صدور قبض (واقعی یا برآوردی) و تاریخ قرائت کنتور مشخص است. قبض برآوردی بر اساس مصرف متوسط دوره‌های مشابه قبلی صادر می‌شود و با قرائت واقعی دوره بعد تسویه می‌گردد.",
  },
  {
    id: nanoid(),
    title: "آیا گاز رایگان برای مشترکان خاص وجود دارد؟",
    content:
      "بله. مشترکانی که در ماه‌های بسیار سرد مصرف‌شان حداکثر ۷۰ درصد الگوی متعارف باشد، گازبهای آن‌ها صد درصد رایگان محاسبه می‌شود. همچنین مشترکان تحت پوشش کمیته امداد و بهزیستی تا سقف الگوی مصرف یارانه کامل دریافت می‌کنند. در جزئیات قبض این اطلاعات به‌صراحت درج است.",
  },
  {
    id: nanoid(),
    title: "قبض گاز فصل سرد با فصل گرم چه تفاوتی دارد؟",
    content:
      "در فصل سرد (۱۶ آبان تا ۱۵ اسفند) تعرفه‌ها بالاتر است و پاداش صرفه‌جویی فعال می‌شود. الگوی مصرف در این دوره بیشتر است اما سازوکار مقایسه با میانگین ۵ ساله همچنان اعمال می‌شود. در فصل گرم مصرف و نرخ پایین‌تر است.",
  },
  {
    id: nanoid(),
    title: "اگر می‌خواهم به مبلغ قبض گاز اعتراض کنم چه کنم؟",
    content:
      "ابتدا با جزئیات قبض در نوین وان آیتم مشکوک را شناسایی کنید. سپس از طریق اورژانس گاز ۱۹۴ یا سامانه آنلاین شرکت گاز استان خود مکاتبه کنید. اطلاعات نوین وان مستقیماً از سامانه رسمی شرکت ملی گاز دریافت می‌شود و برای پیگیری قابل استناد است.",
  },
  {
    id: nanoid(),
    title: "بدهی معوقه قبض گاز چیست و چرا روی این دوره اضافه شده؟",
    content:
      "بدهی معوقه مبلغ پرداخت‌نشده دوره‌های قبلی است که به قبض جاری اضافه می‌شود. گاهی تأخیر سامانه گاز در ثبت پرداخت نیز موجب نمایش موقت بدهی می‌شود. در جزئیات قبض نوین وان مبلغ معوقه جداگانه مشخص است.",
  },
  {
    id: nanoid(),
    title: "قبض گاز واحد استیجاری را هم می‌توانم با جزئیات ببینم؟",
    content:
      "بله. با داشتن شماره اشتراک یا شناسه قبض واحد، صرف‌نظر از مالک یا مستأجر بودن، می‌توانید قبض گاز هر واحدی را با جزئیات کامل استعلام کنید.",
  },
  {
    id: nanoid(),
    title: "آیا جزئیات قبض گاز دوره‌های قبلی هم قابل مشاهده است؟",
    content:
      "سرویس قبض گاز با جزئیات نوین وان صورت‌حساب دوره جاری را نمایش می‌دهد. برای مشاهده سوابق و دوره‌های قبلی از سرویس تاریخچه قبض نوین وان استفاده کنید که فهرست کامل قبوض پیشین را نشان می‌دهد.",
  },
  {
    id: nanoid(),
    title: "چطور با کمک جزئیات قبض گاز مصرفم را مدیریت کنم؟",
    content:
      "با مشاهده دقیق پله تعرفه‌ای و مقایسه با میانگین مصرف ۵ ساله در جزئیات، می‌فهمید دقیقاً چند مترمکعب تا پله ارزان‌تر فاصله دارید. کاهش ۱۰ درصدی مصرف نسبت به سال گذشته می‌تواند تخفیف ۳۰ درصدی در گازبها ایجاد کند و در ماه‌های خیلی سرد قبض را به صفر برساند.",
  },
];

export const gasBillFaqItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "چطور قبض گاز را آنلاین استعلام کنم؟",
    content:
      "با وارد کردن شماره اشتراک ۱۲ رقمی یا شناسه قبض گاز در نوین وان، مبلغ قابل پرداخت، وضعیت بدهی و مهلت پرداخت قبض گاز در کمتر از یک دقیقه نمایش داده می‌شود.",
  },
  {
    id: nanoid(),
    title: "شماره اشتراک گاز را از کجا پیدا کنم؟",
    content:
      "شماره اشتراک گاز یک کد ۱۲ رقمی است که روی قراردادنامه اشتراک، قبوض کاغذی قدیمی و پیامک‌های شرکت گاز درج شده است. همچنین با تماس با اورژانس گاز ۱۹۴ یا مراجعه به شرکت گاز استان می‌توانید آن را دریافت کنید.",
  },
  {
    id: nanoid(),
    title: "آیا برای پرداخت قبض گاز به قبض کاغذی نیاز دارم؟",
    content:
      "خیر. صدور قبض کاغذی گاز متوقف شده و پیامک جایگزین آن شده است. فقط به شماره اشتراک ۱۲ رقمی یا شناسه قبض نیاز دارید که از طریق پیامک یا قراردادنامه قابل دریافت است.",
  },
  {
    id: nanoid(),
    title: "مهلت پرداخت قبض گاز چقدر است؟",
    content:
      "مهلت پرداخت قبض گاز روی هر قبض درج می‌شود. عدم پرداخت به‌موقع منجر به جریمه دیرکرد می‌شود. در صورت تأخیر طولانی، امکان صدور اخطار و قطع انشعاب نیز وجود دارد.",
  },
  {
    id: nanoid(),
    title: "پس از پرداخت قبض گاز چه زمانی بدهی صفر می‌شود؟",
    content:
      "تأیید پرداخت توسط شرکت ملی گاز معمولاً ۲۴ تا ۷۲ ساعت پس از پرداخت انجام می‌شود. صفر نشدن فوری بدهی طبیعی است و نیاز به پرداخت مجدد ندارد.",
  },
  {
    id: nanoid(),
    title: "آیا می‌توانم قبض گاز چند دوره معوقه را یکجا پرداخت کنم؟",
    content:
      "بله. نوین وان مجموع بدهی‌های معوقه دوره‌های قبلی را به همراه قبض جاری نمایش می‌دهد و امکان تسویه یکجا یا جداگانه را فراهم می‌کند.",
  },
  {
    id: nanoid(),
    title: "اگر پیامک اخطار قطع گاز دریافت کردم چه کنم؟",
    content:
      "در صورت دریافت پیامک اخطار باید فوراً اقدام به پرداخت کنید. در صورت ادامه بدهی، امکان قطع انشعاب و اضافه شدن هزینه وصل مجدد وجود دارد. نوین وان امکان تسویه سریع بدهی را فراهم می‌کند.",
  },
  {
    id: nanoid(),
    title: "اگر قبض گاز را دو بار پرداخت کنم چه می‌شود؟",
    content:
      "مبلغ اضافه به‌عنوان بستانکاری در سامانه شرکت گاز ثبت شده و از قبض دوره بعد کسر می‌شود. برای پیگیری می‌توانید با رسید پرداخت به شرکت گاز استان مراجعه کنید.",
  },
  {
    id: nanoid(),
    title: "آیا مستأجر می‌تواند قبض گاز ملک استیجاری را پرداخت کند؟",
    content:
      "بله. با داشتن شماره اشتراک یا شناسه قبض گاز، هر شخصی اعم از مالک یا مستأجر می‌تواند قبض گاز را در نوین وان استعلام و پرداخت کند.",
  },
  {
    id: nanoid(),
    title: "پیامک قبض گاز به شماره مستأجر قبلی می‌رود، چطور تغییر دهم؟",
    content:
      "برای تغییر شماره دریافت پیامک باید با مدارک ملک و قراردادنامه به شرکت گاز استان مراجعه کنید یا از طریق اورژانس گاز ۱۹۴ درخواست اصلاح ثبت نمایید.",
  },
  {
    id: nanoid(),
    title: "آیا پرداخت قبض گاز در نوین وان هزینه اضافه دارد؟",
    content:
      "خیر. سرویس استعلام و پرداخت قبض گاز در نوین وان بدون کارمزد اضافه است و شما فقط مبلغ خود قبض را پرداخت می‌کنید.",
  },
  {
    id: nanoid(),
    title: "آیا پس از پرداخت قبض گاز رسید دریافت می‌کنم؟",
    content:
      "بله. پس از هر پرداخت موفق، رسید الکترونیکی شامل شماره پیگیری، مبلغ، تاریخ و ساعت تراکنش صادر می‌شود که قابل دانلود و ارائه به مراجع مربوطه است.",
  },
  {
    id: nanoid(),
    title: "قبض گاز این دوره نیامده، چطور استعلام کنم؟",
    content:
      "با شماره اشتراک ۱۲ رقمی یا شناسه قبض گاز می‌توانید بدون دریافت پیامک، استعلام را در نوین وان انجام دهید. این اطلاعات روی قراردادنامه یا قبوض قدیمی موجود است.",
  },
  {
    id: nanoid(),
    title: "قبض گاز هر چند وقت یک بار صادر می‌شود؟",
    content:
      "قبض گاز معمولاً هر دو ماه یک‌بار صادر می‌شود و در ماه‌های سرد سال ممکن است ماهانه باشد. در صورت عدم قرائت کنتور، قبض به‌صورت برآوردی صادر می‌شود.",
  },
  {
    id: nanoid(),
    title: "آیا پرداخت قبض گاز در نوین وان امن است؟",
    content:
      "بله. تمام پرداخت‌ها از طریق درگاه‌های بانکی مورد تأیید بانک مرکزی انجام می‌شود. اطلاعات کارت بانکی ذخیره نمی‌شود و ارتباط با SSL کاملاً رمزگذاری شده است.",
  },
  {
    id: nanoid(),
    title: "اگر قبض گاز اشتباه صادر شده باشد چطور اعتراض کنم؟",
    content:
      "از طریق سامانه اورژانس گاز ۱۹۴ یا مراجعه حضوری به شرکت گاز استان با ارائه رسید پرداخت، شماره اشتراک و مدارک کنتور می‌توانید درخواست بازبینی ثبت کنید.",
  },
  {
    id: nanoid(),
    title: "آیا می‌توانم قبض گاز را با موبایل پرداخت کنم؟",
    content:
      "بله. نوین وان کاملاً ریسپانسیو است و روی موبایل و تبلت بدون نیاز به نصب اپلیکیشن قابل استفاده می‌باشد.",
  },
  {
    id: nanoid(),
    title: "آیا امکان تقسیط بدهی قبض گاز وجود دارد؟",
    content:
      "تقسیط بدهی قبض گاز فقط از طریق مراجعه حضوری به شرکت گاز استان با مدارک هویتی و شماره اشتراک امکان‌پذیر است. در نوین وان فقط امکان پرداخت کامل بدهی نمایش داده می‌شود.",
  },
  {
    id: nanoid(),
    title: "اگر تراکنش پرداخت قبض گاز ناموفق باشد چه اتفاقی می‌افتد؟",
    content:
      "در صورت ناموفق بودن تراکنش، مبلغ کسرشده ظرف ۷۲ ساعت کاری به حساب بازمی‌گردد. در صورت عدم بازگشت، باید با پشتیبانی نوین وان تماس بگیرید.",
  },
  {
    id: nanoid(),
    title: "تفاوت شناسه قبض و شناسه پرداخت گاز چیست؟",
    content:
      "شناسه قبض کد ۱۳ رقمی برای استعلام اطلاعات قبض است و هر دوره تغییر می‌کند. شناسه پرداخت برای انجام تراکنش استفاده می‌شود و در پیامک قبض ارسال می‌شود.",
  },
];

export const waterBillFaqItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "چطور قبض آب را آنلاین استعلام کنم؟",
    content:
      "با وارد کردن شناسه قبض یا شماره اشتراک آب در نوین وان، مبلغ قابل پرداخت، وضعیت بدهی و تاریخ سررسید قبض آب در کمتر از یک دقیقه نمایش داده می‌شود.",
  },
  {
    id: nanoid(),
    title: "شناسه قبض آب را از کجا پیدا کنم؟",
    content:
      "شناسه قبض یک کد ۱۳ رقمی است که روی قبوض کاغذی قدیمی، پیامک‌های آبفا یا از طریق ارسال شماره اشتراک به سرشماره ۱۰۰۱۵۲۲ قابل دریافت است.",
  },
  {
    id: nanoid(),
    title: "آیا برای پرداخت قبض آب به قبض کاغذی نیاز دارم؟",
    content:
      "خیر. فقط به شماره اشتراک آب نیاز دارید که روی کنتور یا قبوض قدیمی موجود است. از سال ۱۳۹۸ قبض کاغذی آب حذف شده و پیامک جایگزین آن شده است.",
  },
  {
    id: nanoid(),
    title: "پس از پرداخت قبض آب چه زمانی بدهی صفر می‌شود؟",
    content:
      "تأیید پرداخت توسط سازمان آبفا معمولاً ۲۴ تا ۷۲ ساعت پس از پرداخت انجام می‌شود. صفر نشدن فوری بدهی طبیعی است و نیاز به پرداخت مجدد ندارد.",
  },
  {
    id: nanoid(),
    title: "مهلت پرداخت قبض آب تا کِی است؟",
    content:
      "بر خلاف قبض برق و گاز، قبض آب مهلت مشخص و جریمه دیرکرد ندارد. با این حال پرداخت به‌موقع توصیه می‌شود تا بدهی‌های معوقه روی هم انباشته نشود.",
  },
  {
    id: nanoid(),
    title: "آیا می‌توانم قبض آب چند دوره معوقه را یکجا پرداخت کنم؟",
    content:
      "بله. نوین وان مجموع بدهی‌های معوقه دوره‌های قبلی را به همراه قبض جاری نمایش می‌دهد و امکان تسویه یکجا یا جداگانه را فراهم می‌کند.",
  },
  {
    id: nanoid(),
    title: "اگر تراکنش پرداخت قبض آب ناموفق باشد چه اتفاقی می‌افتد؟",
    content:
      "در صورت ناموفق بودن تراکنش، مبلغ کسرشده ظرف ۷۲ ساعت کاری به حساب بازمی‌گردد. در صورت عدم برگشت با پشتیبانی نوین وان تماس بگیرید.",
  },
  {
    id: nanoid(),
    title: "اگر قبض آب را دو بار پرداخت کنم چه می‌شود؟",
    content:
      "مبلغ اضافه به‌عنوان بستانکاری در سامانه آبفا ثبت می‌شود و از قبض دوره بعد کسر خواهد شد. امکان پرداخت تکراری قبض آب پرداخت‌شده وجود ندارد.",
  },
  {
    id: nanoid(),
    title: "آیا مستأجر می‌تواند قبض آب ملک استیجاری را پرداخت کند؟",
    content:
      "بله. با داشتن شناسه قبض یا شماره اشتراک آب واحد، هر شخصی اعم از مالک یا مستأجر می‌تواند قبض آب آن واحد را در نوین وان استعلام و پرداخت کند.",
  },
  {
    id: nanoid(),
    title: "پیامک قبض آب به نام مستأجر قبلی می‌آید، چه کنم؟",
    content:
      "برای تغییر شماره موبایل دریافت‌کننده پیامک قبض آب باید با همراه داشتن مدارک ملک به شرکت آب و فاضلاب منطقه مراجعه کنید یا از طریق سامانه ۱۲۲ درخواست دهید.",
  },
  {
    id: nanoid(),
    title: "آیا پرداخت قبض آب در نوین وان هزینه اضافه دارد؟",
    content:
      "خیر. سرویس استعلام و پرداخت قبض آب در نوین وان بدون کارمزد اضافه است و شما فقط مبلغ خود قبض را پرداخت می‌کنید.",
  },
  {
    id: nanoid(),
    title: "آیا پس از پرداخت قبض آب رسید دریافت می‌کنم؟",
    content:
      "بله. پس از هر پرداخت موفق، رسید الکترونیکی شامل شماره پیگیری، مبلغ، تاریخ و ساعت تراکنش صادر می‌شود که قابل دانلود و ارائه به مراجع مربوطه است.",
  },
  {
    id: nanoid(),
    title: "قبض آب این دوره نیامده، چطور استعلام کنم؟",
    content:
      "با شماره اشتراک ثابت آب که روی کنتور حک شده یا در قراردادنامه اشتراک موجود است، می‌توانید بدون دریافت پیامک قبض، استعلام را در نوین وان انجام دهید.",
  },
  {
    id: nanoid(),
    title: "شماره اشتراک آب را از کجا پیدا کنم؟",
    content:
      "شماره اشتراک آب یک کد ۸ رقمی است که روی کنتور آب، قراردادنامه اشتراک و قبوض کاغذی قدیمی درج شده است. همچنین می‌توانید از طریق سامانه ۱۲۲ آن را دریافت کنید.",
  },
  {
    id: nanoid(),
    title: "قبض آب هر چند وقت یکبار صادر می‌شود؟",
    content:
      "قبض آب معمولاً هر دو ماه یکبار صادر می‌شود. در صورت عدم قرائت کنتور در دوره‌ای، قبض به‌صورت برآوردی صادر شده و در دوره بعد با قرائت واقعی تسویه می‌شود.",
  },
  {
    id: nanoid(),
    title: "آیا پرداخت قبض آب در نوین وان امن است؟",
    content:
      "بله. تمام پرداخت‌ها از طریق درگاه‌های بانکی مورد تأیید بانک مرکزی انجام می‌شود. اطلاعات کارت بانکی ذخیره نمی‌شود و ارتباط با SSL کامل رمزگذاری شده است.",
  },
  {
    id: nanoid(),
    title: "اگر قبض آب اشتباه صادر شده باشد چطور اعتراض کنم؟",
    content:
      "از طریق سامانه ۱۲۲ آبفا یا مراجعه حضوری به امور مشترکین با رسید پرداخت و عکس کنتور، درخواست بازبینی مصرف و قرائت مجدد ثبت کنید.",
  },
  {
    id: nanoid(),
    title: "آیا می‌توانم قبض آب را با موبایل پرداخت کنم؟",
    content:
      "بله. نوین وان کاملاً ریسپانسیو طراحی شده و روی تمام مرورگرهای موبایل و تبلت بدون نیاز به نصب اپلیکیشن جداگانه قابل استفاده است.",
  },
  {
    id: nanoid(),
    title: "آیا امکان تقسیط بدهی قبض آب وجود دارد؟",
    content:
      "تقسیط بدهی قبض آب از طریق مراجعه حضوری به شرکت آب و فاضلاب منطقه با ارائه کارت ملی و شماره اشتراک امکان‌پذیر است. نوین وان مبلغ کامل بدهی جاری را برای پرداخت یکجا نمایش می‌دهد.",
  },
  {
    id: nanoid(),
    title: "تفاوت شناسه قبض و شناسه پرداخت آب چیست؟",
    content:
      "شناسه قبض کد ۱۳ رقمی برای استعلام اطلاعات قبض است و هر دوره تغییر می‌کند. شناسه پرداخت کد ۱۳ رقمی دیگری است که مخصوص انجام تراکنش پرداخت است. هر دو در پیامک قبض ارسال می‌شوند.",
  },
];

export const waterBillInfoFaqItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "قبض آب با جزئیات دقیقاً چه اطلاعاتی نشان می‌دهد؟",
    content:
      "نام مشترک، نشانی، شماره اشتراک، تاریخ قرائت کنتور، حجم مصرف به مترمکعب، نوع و طبقه تعرفه، آبونمان، هزینه دفع فاضلاب، مالیات آب، ارزش افزوده، ضریب تبعیض منطقه‌ای، بدهی معوقه و مبلغ خالص قابل پرداخت.",
  },
  {
    id: nanoid(),
    title: "تعرفه پلکانی آب چیست و چطور قبضم را تغییر می‌دهد؟",
    content:
      "در سیستم تعرفه پلکانی، هرچه مصرف بیشتر باشد نرخ هر مترمکعب آب هم گران‌تر می‌شود. مصرف زیر الگو یارانه کامل دارد، اما مصرف بالای سه برابر الگو بدون یارانه محاسبه می‌شود و می‌تواند قبض را تا چند برابر افزایش دهد. با دیدن جزئیات می‌فهمید الان در کدام طبقه هستید.",
  },
  {
    id: nanoid(),
    title: "چرا قبض آب این دوره ناگهان خیلی بیشتر شده؟",
    content:
      "دلایل اصلی عبارتند از: صدور قبض تجمیعی دو دوره، جهش مصرف به طبقه بالاتر تعرفه پلکانی، اضافه شدن بدهی معوقه دوره قبل، یا تغییر نرخ یارانه از ابتدای ۱۴۰۴. قبض با جزئیات دقیقاً نشان می‌دهد کدام آیتم باعث افزایش شده.",
  },
  {
    id: nanoid(),
    title: "آبونمان قبض آب چیست و چرا حتی با مصرف صفر هم باید پرداخت شود؟",
    content:
      "آبونمان هزینه ثابت نگهداری شبکه و زیرساخت آب و فاضلاب است که صرف‌نظر از میزان مصرف، هر دوره برای هر واحد مشترک اخذ می‌شود. مبلغ آبونمان آب و فاضلاب برابر تعیین شده و هر دو روی قبض درج می‌شوند.",
  },
  {
    id: nanoid(),
    title: "ضریب تبعیض منطقه‌ای در قبض آب به چه معناست؟",
    content:
      "عددی است که بر اساس توان اقتصادی و موقعیت جغرافیایی شهر یا منطقه تعیین می‌شود تا نرخ نهایی آب‌بها در مناطق مختلف کشور متفاوت باشد. در جزئیات قبض این ضریب به‌صراحت درج است و می‌توانید صحت اعمال آن را بررسی کنید.",
  },
  {
    id: nanoid(),
    title: "قبض تجمیعی آب چیست و چرا رقمش بالاست؟",
    content:
      "قبض تجمیعی وقتی صادر می‌شود که مصرف چند دوره با هم محاسبه شود؛ مثلاً وقتی کنتور قرائت نشده باشد یا قبض برآوردی صادر شده باشد. این تجمیع می‌تواند مشترک را وارد طبقه تعرفه بالاتر کند و مبلغ را چند برابر افزایش دهد.",
  },
  {
    id: nanoid(),
    title: "مالیات آب و هزینه دفع فاضلاب چه‌قدر است؟",
    content:
      "هزینه دفع فاضلاب معادل ۷۰ درصد آب‌بهای خانگی تعیین شده است. مالیات آب، ارزش افزوده و بیمه اقلام جداگانه‌ای هستند که در قبض ساده دیده نمی‌شوند اما در نسخه جزئیات کاملاً ریز می‌شوند.",
  },
  {
    id: nanoid(),
    title: "چطور بفهمم قبضم واقعی است یا برآوردی؟",
    content:
      "در صورت‌حساب با جزئیات، نوع صدور قبض (واقعی یا برآوردی) و تاریخ قرائت کنتور به‌صراحت درج می‌شود. قبض برآوردی بر اساس میانگین مصرف دوره‌های قبلی صادر شده و با قرائت واقعی دوره بعد تسویه می‌شود.",
  },
  {
    id: nanoid(),
    title: "الگوی مصرف آب برای هر شهر چگونه تعیین می‌شود؟",
    content:
      "الگوی مصرف بر اساس متوسط بُعد خانوار در هر شهر تعیین می‌شود. مثلاً الگوی خانوار تهرانی ۱۲ مترمکعب در ماه است. مصرف زیر الگو یارانه کامل دارد؛ بالای الگو نرخ پلکانی اعمال می‌شود.",
  },
  {
    id: nanoid(),
    title: "تفاوت تعرفه خانگی و غیرخانگی در قبض آب چیست؟",
    content:
      "نوع تعرفه تعیین می‌کند محاسبات بر چه اساسی انجام شود. مشترکان تجاری، صنعتی و اداری از نرخ‌های متفاوتی نسبت به خانگی برخوردارند. در جزئیات قبض نوین وان نوع کاربری به‌صراحت نمایش داده می‌شود.",
  },
  {
    id: nanoid(),
    title: "چطور با جزئیات قبض آب اعتراض رسمی ثبت کنم؟",
    content:
      "ابتدا قبض را با جزئیات استعلام کنید و آیتم مشکوک را شناسایی کنید. سپس از طریق سامانه ۱۲۲ آبفا یا مراجعه به امور مشترکین، اطلاعات دقیق صورت‌حساب را ارائه دهید. داده‌های نوین وان مستقیماً از سامانه رسمی آبفا دریافت می‌شود.",
  },
  {
    id: nanoid(),
    title: "اگر کنتور آب خراب باشد جزئیات قبض چه نشان می‌دهد؟",
    content:
      "قبض برآوردی صادر می‌شود و نوع آن در جزئیات قابل تشخیص است. باید خرابی کنتور را از طریق سامانه ۱۲۲ به آبفا اطلاع دهید تا پس از تعویض کنتور، قبض واقعی صادر شده و مابه‌التفاوت محاسبه شود.",
  },
  {
    id: nanoid(),
    title: "آیا مشترکان تحت پوشش کمیته امداد قبض آب رایگان دارند؟",
    content:
      "بله. مشترکان تحت پوشش کمیته امداد و بهزیستی تا سقف الگوی مصرف از آب رایگان بهره‌مند می‌شوند. این یارانه در جزئیات قبض به‌عنوان معافیت درج و از مبلغ کل کسر می‌شود.",
  },
  {
    id: nanoid(),
    title: "تفاوت شناسه قبض و شماره اشتراک آب چیست؟",
    content:
      "شماره اشتراک یک کد ثابت اختصاصی هر واحد است که هرگز تغییر نمی‌کند. شناسه قبض یک کد ۱۳ رقمی است که هر دوره با صدور قبض جدید تغییر می‌کند. برای استعلام با جزئیات می‌توانید از هر دو استفاده کنید.",
  },
  {
    id: nanoid(),
    title: "آیا می‌توانم قبض آب واحد استیجاری را هم با جزئیات ببینم؟",
    content:
      "بله. تا زمانی که شماره اشتراک یا شناسه قبض واحد را داشته باشید، صرف‌نظر از مالک یا مستأجر بودن، می‌توانید قبض آب هر واحدی را با جزئیات کامل استعلام کنید.",
  },
  {
    id: nanoid(),
    title: "بدهی معوقه قبض آب چیست و چرا روی قبض این دوره اضافه شده؟",
    content:
      "بدهی معوقه مجموع مبالغ پرداخت‌نشده دوره‌های قبلی است. اگر قبضی پرداخت نشده باشد یا تأیید آبفا تأخیر داشته باشد، به قبض دوره بعد اضافه می‌شود. در جزئیات قبض، مبلغ معوقه جداگانه قابل مشاهده است.",
  },
  {
    id: nanoid(),
    title: "آیا قبض آب واحدهای تجاری جزئیات متفاوتی دارند؟",
    content:
      "بله. برای مشترکان غیرخانگی تعرفه‌ها، ضرایب و آبونمان متفاوت است. نوین وان جزئیات قبض هر نوع اشتراکی را مطابق نوع کاربری آن نمایش می‌دهد و نوع تعرفه در صورت‌حساب به‌صراحت درج می‌شود.",
  },
  {
    id: nanoid(),
    title: "اطلاعات نوین وان برای اعتراض اداری به آبفا معتبر است؟",
    content:
      "اطلاعات نوین وان مستقیماً از سامانه رسمی آب و فاضلاب دریافت می‌شود و همان داده‌ای است که آبفا ثبت کرده. این اطلاعات برای پیگیری مکاتبات و ارائه مستندات اعتراضی قابل استناد است.",
  },
  {
    id: nanoid(),
    title: "آیا سرویس جزئیات قبض آب برای دوره‌های قبلی هم کار می‌کند؟",
    content:
      "سرویس قبض با جزئیات صورت‌حساب دوره جاری را نمایش می‌دهد. برای مشاهده سوابق و دوره‌های قبلی، از سرویس تاریخچه قبض نوین وان استفاده کنید که فهرست کامل قبوض پیشین را نشان می‌دهد.",
  },
  {
    id: nanoid(),
    title: "چطور می‌توانم مصرف آب خانه را با کمک جزئیات قبض کاهش دهم؟",
    content:
      "با مشاهده طبقه تعرفه‌ای و الگوی مصرف در جزئیات قبض، می‌فهمید دقیقاً چه‌قدر از الگو بیشتر مصرف کرده‌اید. کاهش مصرف به زیر الگوی تعیین‌شده شهرتان می‌تواند مبلغ قبض را به شکل محسوسی کاهش دهد.",
  },
];

export const billsFaqItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "پس از پرداخت قبض، بدهی من چه زمانی صفر می‌شود؟",
    content:
      "تأیید پرداخت قبوض خدماتی معمولاً با تأخیر ۲۴ تا ۷۲ ساعته توسط سازمان مربوطه ثبت می‌شود. اگر پس از ۳ روز کاری بدهی همچنان نمایش داده می‌شد، با پشتیبانی نوین وان تماس بگیرید.",
  },
  {
    id: nanoid(),
    title: "آیا می‌توانم تصویر قبض فیزیکی خود را از طریق نوین وان دریافت کنم؟",
    content:
      "بله. نوین وان امکان دریافت تصویر دیجیتال قبض را برای قبوض آب، برق، گاز و تلفن ثابت فراهم کرده است. این تصویر همان فرم رسمی قبض است و می‌توان از آن برای اقدامات اداری استفاده کرد.",
  },
  {
    id: nanoid(),
    title: "تاریخچه قبض چیست و چه اطلاعاتی نشان می‌دهد؟",
    content:
      "در بخش تاریخچه قبض، لیست کامل قبوض صادرشده و وضعیت پرداخت هر دوره نمایش داده می‌شود. این قابلیت به شما کمک می‌کند الگوی مصرف‌تان را در طول زمان تحلیل کنید و از پرداخت‌های قبلی مطمئن شوید.",
  },
  {
    id: nanoid(),
    title: "پرداخت قبض با جزئیات چه تفاوتی با پرداخت عادی دارد؟",
    content:
      "در پرداخت عادی فقط مبلغ کل و وضعیت پرداخت نمایش می‌یابد، اما در نسخه «با جزئیات» می‌توانید ریز مصرف، دوره صورت‌حساب، ضرایب تعرفه و بدهی معوقه را نیز مشاهده کنید.",
  },
  {
    id: nanoid(),
    title: "آیا می‌توانم چند قبض را با یک تراکنش پرداخت کنم؟",
    content:
      "بله. نوین وان قابلیت پرداخت چندقبضه را دارد. می‌توانید قبض آب، برق و گاز خود را با یک بار ورود اطلاعات پرداخت تسویه کنید و رسید یکپارچه دریافت نمایید.",
  },
  {
    id: nanoid(),
    title: "آیا پرداخت قبوض در نوین وان امن است؟",
    content:
      "بله. تمام تراکنش‌های مالی از طریق درگاه‌های پرداخت مورد تأیید بانک مرکزی انجام می‌شود و اطلاعات کارت بانکی شما ذخیره نمی‌شود. نوین وان دارای گواهی SSL و رمزگذاری کامل اطلاعات است.",
  },
  {
    id: nanoid(),
    title: "اگر تراکنش پرداخت قبض ناموفق باشد، مبلغ کجا می‌رود؟",
    content:
      "در صورت ناموفق بودن تراکنش، مبلغ کسرشده از حساب طی ۷۲ ساعت کاری به حساب شما بازمی‌گردد. اگر پس از این مدت برگشت نخورد، با پشتیبانی نوین وان تماس بگیرید.",
  },
  {
    id: nanoid(),
    title: "چطور قبض برق را بدون قبض کاغذی پرداخت کنم؟",
    content:
      "کافی است شماره اشتراک برق (درج‌شده روی کنتور یا پیامک قبض) را در نوین وان وارد کنید. سیستم اطلاعات کامل قبض را از سامانه شرکت توزیع برق دریافت و برای پرداخت نمایش می‌دهد.",
  },
  {
    id: nanoid(),
    title: "آیا امکان استعلام قبض گاز بدون شناسه قبض وجود دارد؟",
    content:
      "بله. با شماره اشتراک گاز که معمولاً روی قراردادنامه یا قبض‌های قبلی موجود است، می‌توانید استعلام انجام دهید. در صورت نداشتن این اطلاعات، با شرکت گاز منطقه خود تماس بگیرید تا شماره اشتراک را دریافت کنید.",
  },
  {
    id: nanoid(),
    title: "چطور قبض تلفن ثابت را از طریق نوین وان استعلام کنم؟",
    content:
      "قبض تلفن ثابت از طریق شماره تلفن یا شناسه اشتراک مخابرات قابل استعلام است. نوین وان به سامانه مخابرات ایران متصل است و اطلاعات دوره جاری و بدهی‌های معوقه را نمایش می‌دهد.",
  },
  {
    id: nanoid(),
    title: "آیا نوین وان API قبوض برای توسعه‌دهندگان ارائه می‌دهد؟",
    content:
      "بله. نوین وان پنل API اختصاصی با مستندات کامل RESTful برای توسعه‌دهندگان، اپلیکیشن‌سازان و کسب‌وکارها ارائه می‌دهد. این API شامل استعلام، پرداخت، دریافت تصویر و تاریخچه تمام قبوض است.",
  },
  {
    id: nanoid(),
    title: "چطور می‌توانم قبض موبایل همراه اول را استعلام کنم؟",
    content:
      "با وارد کردن شماره موبایل همراه اول، آخرین صورت‌حساب، مبلغ بدهی و وضعیت پرداخت آن به‌صورت آنی نمایش داده می‌شود. سپس می‌توانید مستقیماً از همان صفحه پرداخت انجام دهید.",
  },
  {
    id: nanoid(),
    title: "آیا می‌توانم قبض ایرانسل را هم از نوین وان پرداخت کنم؟",
    content:
      "بله. نوین وان پشتیبانی کاملی از قبوض اپراتورهای همراه شامل ایرانسل و رایتل دارد. با وارد کردن شماره موبایل یا شناسه اشتراک، استعلام و پرداخت در چند ثانیه انجام می‌شود.",
  },
  {
    id: nanoid(),
    title: "آیا پس از پرداخت قبض رسید می‌گیرم؟",
    content:
      "بله. پس از هر پرداخت موفق، رسید الکترونیکی شامل شماره پیگیری، مبلغ پرداختی، تاریخ و ساعت تراکنش برای شما صادر می‌شود که قابل دانلود و ارسال به ایمیل است.",
  },
  {
    id: nanoid(),
    title: "آیا قبض‌های معوقه چند دوره گذشته هم قابل پرداخت است؟",
    content:
      "بله. نوین وان علاوه بر قبض دوره جاری، بدهی‌های معوقه چند دوره قبلی را نیز نمایش می‌دهد و امکان تسویه تمام بدهی‌ها با یک یا چند تراکنش جداگانه را فراهم می‌کند.",
  },
  {
    id: nanoid(),
    title: "آیا نوین وان روی موبایل هم کار می‌کند؟",
    content:
      "بله. پلتفرم نوین وان برای موبایل به شکلی مناسب طراحی شده و روی تمام مرورگرهای موبایل و تبلت بدون نیاز به نصب اپلیکیشن جداگانه قابل استفاده است.",
  },
  {
    id: nanoid(),
    title: " آیا می‌توانم یادآور پرداخت قبض تنظیم کنم؟",
    content:
      "بله. با ثبت اشتراک‌های خود در حساب کاربری نوین وان، سیستم به‌صورت خودکار هنگام صدور قبض جدید یا نزدیک‌شدن به موعد پرداخت، اطلاع‌رسانی پیامکی یا ایمیلی ارسال می‌کند.",
  },
  {
    id: nanoid(),
    title: " اگر مبلغ قبض بیشتر از حد معمول باشد چه کنم؟",
    content:
      "از طریق بخش «قبض با جزئیات» در نوین وان می‌توانید ریز مصرف دوره جاری را بررسی کنید. اگر افزایش مصرف غیرعادی بود، می‌توانید با سازمان مربوطه مکاتبه کنید. نوین وان اطلاعات لازم برای پیگیری را در اختیارتان می‌گذارد.",
  },
];
